import { emptyProjectApi as api } from './api';
export const addTagTypes = [
  'Admins',
  'AggregationTypes',
  'Attachments',
  'Audience',
  'AudienceV10s',
  'TestGroupV10s',
  'BlueprintCatalog',
  'Blueprints',
  'ChatConversations',
  'Communities',
  'CommunityRecruitCount',
  'CustomerRegistration',
  'Customers',
  'CustomTopics',
  'DisqualificationLogics',
  'Experiences',
  'FeasibilityEstimate',
  'FieldingGroup',
  'FieldingGroupAssignments',
  'HighlighterExperiences',
  'HubSpotDeals',
  'Inserts',
  'Kits',
  'Links',
  'ManualSurveys',
  'ModuleBlocks',
  'ModuleConfigurations',
  'Modules',
  'NotificationUnsubscriptions',
  'Organizations',
  'PackingList',
  'PersonaChatConversations',
  'PresentationRules',
  'ProductLists',
  'ProductProjectAssets',
  'Products',
  'ProjectCategories',
  'ProjectFinalReports',
  'ProjectIntakeAnswers',
  'ProjectOrchestrator',
  'ProjectReview',
  'Projects',
  'ProjectsConfiguration',
  'ProjectsHacky',
  'ProjectSurveys',
  'QualityControlReport',
  'Recommendations',
  'RecruitCount',
  'RecruitingData',
  'Report',
  'ResultContexts',
  'Results',
  'ResultsMeta',
  'Segment',
  'ShareLinks',
  'Shipments',
  'ShowLogics',
  'SlotValues',
  'Solutions',
  'SolutionSurveyDesigns',
  'Steps',
  'SurveyBundles',
  'SurveyConfigBlockGroups',
  'SurveyConfigBlocks',
  'SurveyConfigQuestionChoices',
  'SurveyConfigRouting',
  'SurveyConfigs',
  'SurveyFileAnswers',
  'SurveyGroups',
  'SurveyQuestions',
  'Teams',
  'TestCategories',
  'TestClassifications',
  'TestDesign',
] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getAdmins: build.query<GetAdminsApiResponse, GetAdminsApiArg>({
        query: (queryArg) => ({
          url: `/Admins`,
          params: {
            emailAddress: queryArg.emailAddress,
          },
        }),
        providesTags: ['Admins'],
      }),
      postAdmins: build.mutation<PostAdminsApiResponse, PostAdminsApiArg>({
        query: (queryArg) => ({
          url: `/Admins`,
          method: 'POST',
          body: queryArg.createAdminRequest,
        }),
        invalidatesTags: ['Admins'],
      }),
      postByIdDisable: build.mutation<PostByIdDisableApiResponse, PostByIdDisableApiArg>({
        query: (queryArg) => ({ url: `/${queryArg.id}/$disable`, method: 'POST' }),
        invalidatesTags: ['Admins'],
      }),
      getProjectsByProjectIdAdmins: build.query<
        GetProjectsByProjectIdAdminsApiResponse,
        GetProjectsByProjectIdAdminsApiArg
      >({
        query: (queryArg) => ({ url: `/Projects/${queryArg.projectId}/Admins` }),
        providesTags: ['Admins'],
      }),
      getAggregationtypes: build.query<GetAggregationtypesApiResponse, GetAggregationtypesApiArg>({
        query: () => ({ url: `/aggregationtypes` }),
        providesTags: ['AggregationTypes'],
      }),
      getProjectsByProjectIdAttachments: build.query<
        GetProjectsByProjectIdAttachmentsApiResponse,
        GetProjectsByProjectIdAttachmentsApiArg
      >({
        query: (queryArg) => ({ url: `/Projects/${queryArg.projectId}/Attachments` }),
        providesTags: ['Attachments'],
      }),
      postProjectsByProjectIdAttachments: build.mutation<
        PostProjectsByProjectIdAttachmentsApiResponse,
        PostProjectsByProjectIdAttachmentsApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/Attachments`,
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['Attachments'],
      }),
      putProjectsByProjectIdAttachmentsAndAttachmentId: build.mutation<
        PutProjectsByProjectIdAttachmentsAndAttachmentIdApiResponse,
        PutProjectsByProjectIdAttachmentsAndAttachmentIdApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/Attachments/${queryArg.attachmentId}`,
          method: 'PUT',
          body: queryArg.projectAttachment,
        }),
        invalidatesTags: ['Attachments'],
      }),
      deleteProjectsByProjectIdAttachmentsAndProjectAttachmentId: build.mutation<
        DeleteProjectsByProjectIdAttachmentsAndProjectAttachmentIdApiResponse,
        DeleteProjectsByProjectIdAttachmentsAndProjectAttachmentIdApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/Attachments/${queryArg.projectAttachmentId}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['Attachments'],
      }),
      getProjectsByProjectIdAudienceBuilderAudience: build.query<
        GetProjectsByProjectIdAudienceBuilderAudienceApiResponse,
        GetProjectsByProjectIdAudienceBuilderAudienceApiArg
      >({
        query: (queryArg) => ({ url: `/Projects/${queryArg.projectId}/audienceBuilderAudience` }),
        providesTags: ['Audience'],
      }),
      putProjectsByProjectIdAudienceBuilderAudience: build.mutation<
        PutProjectsByProjectIdAudienceBuilderAudienceApiResponse,
        PutProjectsByProjectIdAudienceBuilderAudienceApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/audienceBuilderAudience`,
          method: 'PUT',
          body: queryArg.audienceBuilderAudienceBuilderAudience,
        }),
        invalidatesTags: ['Audience'],
      }),
      postProjectsByProjectIdAudienceAttachments: build.mutation<
        PostProjectsByProjectIdAudienceAttachmentsApiResponse,
        PostProjectsByProjectIdAudienceAttachmentsApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/audienceAttachments`,
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['Audience'],
      }),
      getProjectsByProjectIdAudienceAttachmentsAndAttachmentId: build.query<
        GetProjectsByProjectIdAudienceAttachmentsAndAttachmentIdApiResponse,
        GetProjectsByProjectIdAudienceAttachmentsAndAttachmentIdApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/audienceAttachments/${queryArg.attachmentId}`,
        }),
        providesTags: ['Audience'],
      }),
      getProjectsByProjectIdAudiences: build.query<
        GetProjectsByProjectIdAudiencesApiResponse,
        GetProjectsByProjectIdAudiencesApiArg
      >({
        query: (queryArg) => ({ url: `/Projects/${queryArg.projectId}/Audiences` }),
        providesTags: ['AudienceV10s'],
      }),
      postProjectsByProjectIdAudiences: build.mutation<
        PostProjectsByProjectIdAudiencesApiResponse,
        PostProjectsByProjectIdAudiencesApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/Audiences`,
          method: 'POST',
          body: queryArg.createAudienceV10Request,
        }),
        invalidatesTags: ['AudienceV10s'],
      }),
      patchProjectsByProjectIdAudiencesAndAudienceId: build.mutation<
        PatchProjectsByProjectIdAudiencesAndAudienceIdApiResponse,
        PatchProjectsByProjectIdAudiencesAndAudienceIdApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/Audiences/${queryArg.audienceId}`,
          method: 'PATCH',
          body: queryArg.updateAudienceV10Request,
        }),
        invalidatesTags: ['AudienceV10s'],
      }),
      deleteProjectsByProjectIdAudiencesAndAudienceId: build.mutation<
        DeleteProjectsByProjectIdAudiencesAndAudienceIdApiResponse,
        DeleteProjectsByProjectIdAudiencesAndAudienceIdApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/Audiences/${queryArg.audienceId}`,
          method: 'DELETE',
          body: queryArg.deleteAudienceV10Request,
        }),
        invalidatesTags: ['AudienceV10s', 'TestGroupV10s'],
      }),
      postProjectsByProjectIdAudiencesBulk: build.mutation<
        PostProjectsByProjectIdAudiencesBulkApiResponse,
        PostProjectsByProjectIdAudiencesBulkApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/Audiences/$bulk`,
          method: 'POST',
          body: queryArg.bulkAudienceV10Request,
        }),
        invalidatesTags: ['AudienceV10s', 'TestGroupV10s'],
      }),
      getBlueprintCatalogExport: build.query<
        GetBlueprintCatalogExportApiResponse,
        GetBlueprintCatalogExportApiArg
      >({
        query: () => ({ url: `/BlueprintCatalog/$export` }),
        providesTags: ['BlueprintCatalog'],
      }),
      getBlueprintCatalogApplyJobs: build.query<
        GetBlueprintCatalogApplyJobsApiResponse,
        GetBlueprintCatalogApplyJobsApiArg
      >({
        query: () => ({ url: `/BlueprintCatalog/$applyJobs` }),
        providesTags: ['BlueprintCatalog'],
      }),
      postBlueprintCatalogApply: build.mutation<
        PostBlueprintCatalogApplyApiResponse,
        PostBlueprintCatalogApplyApiArg
      >({
        query: (queryArg) => ({
          url: `/BlueprintCatalog/$apply`,
          method: 'POST',
          body: queryArg.blueprintCatalog,
        }),
        invalidatesTags: ['BlueprintCatalog'],
      }),
      postBlueprintsModuleconfigurations: build.mutation<
        PostBlueprintsModuleconfigurationsApiResponse,
        PostBlueprintsModuleconfigurationsApiArg
      >({
        query: (queryArg) => ({
          url: `/Blueprints/moduleconfigurations`,
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['Blueprints'],
      }),
      postBlueprints: build.mutation<PostBlueprintsApiResponse, PostBlueprintsApiArg>({
        query: (queryArg) => ({ url: `/Blueprints`, method: 'POST', body: queryArg.body }),
        invalidatesTags: ['Blueprints'],
      }),
      getBlueprints: build.query<GetBlueprintsApiResponse, GetBlueprintsApiArg>({
        query: (queryArg) => ({
          url: `/Blueprints`,
          params: {
            solutionId: queryArg.solutionId,
            surveyRoleId: queryArg.surveyRoleId,
            testCategoryId: queryArg.testCategoryId,
            subject: queryArg.subject,
          },
        }),
        providesTags: ['Blueprints'],
      }),
      postProjectsByProjectIdChatConversationsAndConversationIdMessages: build.mutation<
        PostProjectsByProjectIdChatConversationsAndConversationIdMessagesApiResponse,
        PostProjectsByProjectIdChatConversationsAndConversationIdMessagesApiArg
      >({
        query: (queryArg) => ({
          url: `/projects/${queryArg.projectId}/ChatConversations/${queryArg.conversationId}/Messages`,
          method: 'POST',
          body: queryArg.appendChatMessageRequest,
        }),
        invalidatesTags: ['ChatConversations'],
      }),
      getProjectsByProjectIdChatConversationsAndConversationId: build.query<
        GetProjectsByProjectIdChatConversationsAndConversationIdApiResponse,
        GetProjectsByProjectIdChatConversationsAndConversationIdApiArg
      >({
        query: (queryArg) => ({
          url: `/projects/${queryArg.projectId}/ChatConversations/${queryArg.conversationId}`,
        }),
        providesTags: ['ChatConversations'],
      }),
      patchProjectsByProjectIdChatConversationsAndConversationId: build.mutation<
        PatchProjectsByProjectIdChatConversationsAndConversationIdApiResponse,
        PatchProjectsByProjectIdChatConversationsAndConversationIdApiArg
      >({
        query: (queryArg) => ({
          url: `/projects/${queryArg.projectId}/ChatConversations/${queryArg.conversationId}`,
          method: 'PATCH',
          body: queryArg.updateChatConversationRequest,
        }),
        invalidatesTags: ['ChatConversations'],
      }),
      deleteProjectsByProjectIdChatConversationsAndConversationId: build.mutation<
        DeleteProjectsByProjectIdChatConversationsAndConversationIdApiResponse,
        DeleteProjectsByProjectIdChatConversationsAndConversationIdApiArg
      >({
        query: (queryArg) => ({
          url: `/projects/${queryArg.projectId}/ChatConversations/${queryArg.conversationId}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['ChatConversations'],
      }),
      getProjectsByProjectIdChatConversations: build.query<
        GetProjectsByProjectIdChatConversationsApiResponse,
        GetProjectsByProjectIdChatConversationsApiArg
      >({
        query: (queryArg) => ({
          url: `/projects/${queryArg.projectId}/ChatConversations`,
          params: {
            limit: queryArg.limit,
          },
        }),
        providesTags: ['ChatConversations'],
      }),
      getCommunities: build.query<GetCommunitiesApiResponse, GetCommunitiesApiArg>({
        query: () => ({ url: `/Communities` }),
        providesTags: ['Communities'],
      }),
      getCommunitiesBySlug: build.query<
        GetCommunitiesBySlugApiResponse,
        GetCommunitiesBySlugApiArg
      >({
        query: (queryArg) => ({ url: `/Communities/${queryArg.slug}` }),
        providesTags: ['Communities'],
      }),
      getCommunitiesBySlugStudyEvents: build.query<
        GetCommunitiesBySlugStudyEventsApiResponse,
        GetCommunitiesBySlugStudyEventsApiArg
      >({
        query: (queryArg) => ({
          url: `/Communities/${queryArg.slug}/study-events`,
          params: {
            from: queryArg['from'],
            to: queryArg.to,
          },
        }),
        providesTags: ['Communities'],
      }),
      getCommunitiesStudyEventsSchema: build.query<
        GetCommunitiesStudyEventsSchemaApiResponse,
        GetCommunitiesStudyEventsSchemaApiArg
      >({
        query: () => ({ url: `/Communities/study-events/schema` }),
        providesTags: ['Communities'],
      }),
      postCommunitiesBySlugRecruitCount: build.mutation<
        PostCommunitiesBySlugRecruitCountApiResponse,
        PostCommunitiesBySlugRecruitCountApiArg
      >({
        query: (queryArg) => ({
          url: `/Communities/${queryArg.slug}/RecruitCount`,
          method: 'POST',
          body: queryArg.feasibilityRecruitCountRequest,
        }),
        invalidatesTags: ['CommunityRecruitCount'],
      }),
      postCustomerRegistrationSelfServe: build.mutation<
        PostCustomerRegistrationSelfServeApiResponse,
        PostCustomerRegistrationSelfServeApiArg
      >({
        query: (queryArg) => ({
          url: `/CustomerRegistration/self-serve`,
          method: 'POST',
          body: queryArg.customerRegistrationRequest,
        }),
        invalidatesTags: ['CustomerRegistration'],
      }),
      getCustomers: build.query<GetCustomersApiResponse, GetCustomersApiArg>({
        query: (queryArg) => ({
          url: `/Customers`,
          params: {
            emailAddress: queryArg.emailAddress,
            organizationId: queryArg.organizationId,
          },
        }),
        providesTags: ['Customers'],
      }),
      postCustomers: build.mutation<PostCustomersApiResponse, PostCustomersApiArg>({
        query: (queryArg) => ({
          url: `/Customers`,
          method: 'POST',
          body: queryArg.createCustomerRequest,
        }),
        invalidatesTags: ['Customers'],
      }),
      putCustomers: build.mutation<PutCustomersApiResponse, PutCustomersApiArg>({
        query: (queryArg) => ({
          url: `/Customers`,
          method: 'PUT',
          body: queryArg.updateCustomerRequest,
        }),
        invalidatesTags: ['Customers'],
      }),
      postCustomersBulk: build.mutation<PostCustomersBulkApiResponse, PostCustomersBulkApiArg>({
        query: (queryArg) => ({
          url: `/Customers/bulk`,
          method: 'POST',
          body: queryArg.createCustomersBulkRequest,
        }),
        invalidatesTags: ['Customers'],
      }),
      getCustomersByCustomerId: build.query<
        GetCustomersByCustomerIdApiResponse,
        GetCustomersByCustomerIdApiArg
      >({
        query: (queryArg) => ({ url: `/Customers/${queryArg.customerId}` }),
        providesTags: ['Customers'],
      }),
      getTeamsByTeamIdCustomers: build.query<
        GetTeamsByTeamIdCustomersApiResponse,
        GetTeamsByTeamIdCustomersApiArg
      >({
        query: (queryArg) => ({
          url: `/Teams/${queryArg.teamId}/Customers`,
          params: {
            includeDisabled: queryArg.includeDisabled,
          },
        }),
        providesTags: ['Customers'],
      }),
      postTeamsByTeamIdCustomersAndCustomerId: build.mutation<
        PostTeamsByTeamIdCustomersAndCustomerIdApiResponse,
        PostTeamsByTeamIdCustomersAndCustomerIdApiArg
      >({
        query: (queryArg) => ({
          url: `/Teams/${queryArg.teamId}/Customers/${queryArg.customerId}`,
          method: 'POST',
        }),
        invalidatesTags: ['Customers'],
      }),
      deleteTeamsByTeamIdCustomersAndCustomerId: build.mutation<
        DeleteTeamsByTeamIdCustomersAndCustomerIdApiResponse,
        DeleteTeamsByTeamIdCustomersAndCustomerIdApiArg
      >({
        query: (queryArg) => ({
          url: `/Teams/${queryArg.teamId}/Customers/${queryArg.customerId}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['Customers'],
      }),
      postCustomersByCustomerIdDisable: build.mutation<
        PostCustomersByCustomerIdDisableApiResponse,
        PostCustomersByCustomerIdDisableApiArg
      >({
        query: (queryArg) => ({
          url: `/Customers/${queryArg.customerId}/$disable`,
          method: 'POST',
        }),
        invalidatesTags: ['Customers'],
      }),
      postCustomersByCustomerIdEnable: build.mutation<
        PostCustomersByCustomerIdEnableApiResponse,
        PostCustomersByCustomerIdEnableApiArg
      >({
        query: (queryArg) => ({ url: `/Customers/${queryArg.customerId}/$enable`, method: 'POST' }),
        invalidatesTags: ['Customers'],
      }),
      postCustomersByCustomerIdTracklogin: build.mutation<
        PostCustomersByCustomerIdTrackloginApiResponse,
        PostCustomersByCustomerIdTrackloginApiArg
      >({
        query: (queryArg) => ({
          url: `/Customers/${queryArg.customerId}/$tracklogin`,
          method: 'POST',
        }),
        invalidatesTags: ['Customers'],
      }),
      getProjectsByProjectIdResultsCustomTopics: build.query<
        GetProjectsByProjectIdResultsCustomTopicsApiResponse,
        GetProjectsByProjectIdResultsCustomTopicsApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/Results/CustomTopics`,
          params: {
            resultContextId: queryArg.resultContextId,
            lineItemId: queryArg.lineItemId,
          },
        }),
        providesTags: ['CustomTopics'],
      }),
      postProjectsByProjectIdResultsCustomTopics: build.mutation<
        PostProjectsByProjectIdResultsCustomTopicsApiResponse,
        PostProjectsByProjectIdResultsCustomTopicsApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/Results/CustomTopics`,
          method: 'POST',
          body: queryArg.createCustomTopicRequest,
          params: {
            resultContextId: queryArg.resultContextId,
            lineItemId: queryArg.lineItemId,
          },
        }),
        invalidatesTags: ['CustomTopics'],
      }),
      deleteProjectsByProjectIdResultsCustomTopicsAndId: build.mutation<
        DeleteProjectsByProjectIdResultsCustomTopicsAndIdApiResponse,
        DeleteProjectsByProjectIdResultsCustomTopicsAndIdApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/Results/CustomTopics/${queryArg.id}`,
          method: 'DELETE',
          params: {
            resultContextId: queryArg.resultContextId,
            lineItemId: queryArg.lineItemId,
          },
        }),
        invalidatesTags: ['CustomTopics'],
      }),
      getDisqualificationlogicsAllowedops: build.query<
        GetDisqualificationlogicsAllowedopsApiResponse,
        GetDisqualificationlogicsAllowedopsApiArg
      >({
        query: () => ({ url: `/disqualificationlogics/allowedops` }),
        providesTags: ['DisqualificationLogics'],
      }),
      getSurveyconfigsBySurveyConfigIdDisqualificationlogics: build.query<
        GetSurveyconfigsBySurveyConfigIdDisqualificationlogicsApiResponse,
        GetSurveyconfigsBySurveyConfigIdDisqualificationlogicsApiArg
      >({
        query: (queryArg) => ({
          url: `/surveyconfigs/${queryArg.surveyConfigId}/disqualificationlogics`,
        }),
        providesTags: ['DisqualificationLogics'],
      }),
      putSurveyconfigsBySurveyConfigIdDisqualificationlogicsAndId: build.mutation<
        PutSurveyconfigsBySurveyConfigIdDisqualificationlogicsAndIdApiResponse,
        PutSurveyconfigsBySurveyConfigIdDisqualificationlogicsAndIdApiArg
      >({
        query: (queryArg) => ({
          url: `/surveyconfigs/${queryArg.surveyConfigId}/disqualificationlogics/${queryArg.id}`,
          method: 'PUT',
          body: queryArg.disqualificationLogic,
        }),
        invalidatesTags: ['DisqualificationLogics'],
      }),
      deleteSurveyconfigsBySurveyConfigIdDisqualificationlogicsAndId: build.mutation<
        DeleteSurveyconfigsBySurveyConfigIdDisqualificationlogicsAndIdApiResponse,
        DeleteSurveyconfigsBySurveyConfigIdDisqualificationlogicsAndIdApiArg
      >({
        query: (queryArg) => ({
          url: `/surveyconfigs/${queryArg.surveyConfigId}/disqualificationlogics/${queryArg.id}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['DisqualificationLogics'],
      }),
      getSurveyconfigsBySurveyConfigIdDisqualificationlogicsValidation: build.query<
        GetSurveyconfigsBySurveyConfigIdDisqualificationlogicsValidationApiResponse,
        GetSurveyconfigsBySurveyConfigIdDisqualificationlogicsValidationApiArg
      >({
        query: (queryArg) => ({
          url: `/surveyconfigs/${queryArg.surveyConfigId}/disqualificationlogics/$validation`,
        }),
        providesTags: ['DisqualificationLogics'],
      }),
      getExperiences: build.query<GetExperiencesApiResponse, GetExperiencesApiArg>({
        query: () => ({ url: `/Experiences` }),
        providesTags: ['Experiences'],
      }),
      getProjectsByProjectIdFeasibilityEstimate: build.query<
        GetProjectsByProjectIdFeasibilityEstimateApiResponse,
        GetProjectsByProjectIdFeasibilityEstimateApiArg
      >({
        query: (queryArg) => ({ url: `/projects/${queryArg.projectId}/feasibility-estimate` }),
        providesTags: ['FeasibilityEstimate'],
      }),
      putProjectsByProjectIdFeasibilityEstimate: build.mutation<
        PutProjectsByProjectIdFeasibilityEstimateApiResponse,
        PutProjectsByProjectIdFeasibilityEstimateApiArg
      >({
        query: (queryArg) => ({
          url: `/projects/${queryArg.projectId}/feasibility-estimate`,
          method: 'PUT',
          body: queryArg.upsertFeasibilityEstimateRequest,
        }),
        invalidatesTags: ['FeasibilityEstimate'],
      }),
      putProjectsByProjectIdFieldingGroupAssignHighlighters: build.mutation<
        PutProjectsByProjectIdFieldingGroupAssignHighlightersApiResponse,
        PutProjectsByProjectIdFieldingGroupAssignHighlightersApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/FieldingGroup/$assignHighlighters`,
          method: 'PUT',
          body: queryArg.bulkCreateFieldingGroupRequest,
        }),
        invalidatesTags: ['FieldingGroup'],
      }),
      patchProjectsByProjectIdFieldingGroupAndFieldingGroupId: build.mutation<
        PatchProjectsByProjectIdFieldingGroupAndFieldingGroupIdApiResponse,
        PatchProjectsByProjectIdFieldingGroupAndFieldingGroupIdApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/FieldingGroup/${queryArg.fieldingGroupId}`,
          method: 'PATCH',
          body: queryArg.fieldingGroup,
        }),
        invalidatesTags: ['FieldingGroup'],
      }),
      deleteProjectsByProjectIdFieldingGroupAndFieldingGroupId: build.mutation<
        DeleteProjectsByProjectIdFieldingGroupAndFieldingGroupIdApiResponse,
        DeleteProjectsByProjectIdFieldingGroupAndFieldingGroupIdApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/FieldingGroup/${queryArg.fieldingGroupId}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['FieldingGroup'],
      }),
      deleteProjectsByProjectIdFieldingGroup: build.mutation<
        DeleteProjectsByProjectIdFieldingGroupApiResponse,
        DeleteProjectsByProjectIdFieldingGroupApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/FieldingGroup`,
          method: 'DELETE',
        }),
        invalidatesTags: ['FieldingGroup'],
      }),
      getProjectsByProjectIdFieldingGroup: build.query<
        GetProjectsByProjectIdFieldingGroupApiResponse,
        GetProjectsByProjectIdFieldingGroupApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/FieldingGroup`,
          params: {
            highlighterId: queryArg.highlighterId,
            expand: queryArg.expand,
          },
        }),
        providesTags: ['FieldingGroup'],
      }),
      getFieldingGroup: build.query<GetFieldingGroupApiResponse, GetFieldingGroupApiArg>({
        query: (queryArg) => ({
          url: `/fieldingGroup`,
          params: {
            highlighterId: queryArg.highlighterId,
            expand: queryArg.expand,
          },
        }),
        providesTags: ['FieldingGroup'],
      }),
      postProjectsByProjectIdFieldingGroupFromKits: build.mutation<
        PostProjectsByProjectIdFieldingGroupFromKitsApiResponse,
        PostProjectsByProjectIdFieldingGroupFromKitsApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/FieldingGroup/$fromKits`,
          method: 'POST',
          body: queryArg.createFromKitsRequest,
        }),
        invalidatesTags: ['FieldingGroup'],
      }),
      postProjectsByProjectIdFieldingGroupFromTestGroups: build.mutation<
        PostProjectsByProjectIdFieldingGroupFromTestGroupsApiResponse,
        PostProjectsByProjectIdFieldingGroupFromTestGroupsApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/FieldingGroup/$fromTestGroups`,
          method: 'POST',
        }),
        invalidatesTags: ['FieldingGroup'],
      }),
      postProjectsByProjectIdFieldingGroupDeleteAllEntities: build.mutation<
        PostProjectsByProjectIdFieldingGroupDeleteAllEntitiesApiResponse,
        PostProjectsByProjectIdFieldingGroupDeleteAllEntitiesApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/FieldingGroup/$deleteAllEntities`,
          method: 'POST',
        }),
        invalidatesTags: ['FieldingGroup'],
      }),
      postFieldingGroupsByFieldingGroupIdFieldingGroupAssignments: build.mutation<
        PostFieldingGroupsByFieldingGroupIdFieldingGroupAssignmentsApiResponse,
        PostFieldingGroupsByFieldingGroupIdFieldingGroupAssignmentsApiArg
      >({
        query: (queryArg) => ({
          url: `/FieldingGroups/${queryArg.fieldingGroupId}/FieldingGroupAssignments`,
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['FieldingGroupAssignments'],
      }),
      deleteFieldingGroupsByFieldingGroupIdFieldingGroupAssignments: build.mutation<
        DeleteFieldingGroupsByFieldingGroupIdFieldingGroupAssignmentsApiResponse,
        DeleteFieldingGroupsByFieldingGroupIdFieldingGroupAssignmentsApiArg
      >({
        query: (queryArg) => ({
          url: `/FieldingGroups/${queryArg.fieldingGroupId}/FieldingGroupAssignments`,
          method: 'DELETE',
          body: queryArg.body,
        }),
        invalidatesTags: ['FieldingGroupAssignments'],
      }),
      getProjectsByProjectIdHighlighterExperiences: build.query<
        GetProjectsByProjectIdHighlighterExperiencesApiResponse,
        GetProjectsByProjectIdHighlighterExperiencesApiArg
      >({
        query: (queryArg) => ({ url: `/Projects/${queryArg.projectId}/HighlighterExperiences` }),
        providesTags: ['HighlighterExperiences'],
      }),
      postProjectsByProjectIdHighlighterExperiences: build.mutation<
        PostProjectsByProjectIdHighlighterExperiencesApiResponse,
        PostProjectsByProjectIdHighlighterExperiencesApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/HighlighterExperiences`,
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['HighlighterExperiences'],
      }),
      getProjectsByProjectIdHighlighterExperiencesOverview: build.query<
        GetProjectsByProjectIdHighlighterExperiencesOverviewApiResponse,
        GetProjectsByProjectIdHighlighterExperiencesOverviewApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/HighlighterExperiences/$overview`,
        }),
        providesTags: ['HighlighterExperiences'],
      }),
      getProjectsByProjectIdHighlighterExperiencesAndExperienceIdAssignments: build.query<
        GetProjectsByProjectIdHighlighterExperiencesAndExperienceIdAssignmentsApiResponse,
        GetProjectsByProjectIdHighlighterExperiencesAndExperienceIdAssignmentsApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/HighlighterExperiences/${queryArg.experienceId}/assignments`,
        }),
        providesTags: ['HighlighterExperiences'],
      }),
      postProjectsByProjectIdHighlighterExperiencesAndExperienceIdInitialize: build.mutation<
        PostProjectsByProjectIdHighlighterExperiencesAndExperienceIdInitializeApiResponse,
        PostProjectsByProjectIdHighlighterExperiencesAndExperienceIdInitializeApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/HighlighterExperiences/${queryArg.experienceId}/$initialize`,
          method: 'POST',
          body: queryArg.initializeHighlighterExperienceRequest,
        }),
        invalidatesTags: ['HighlighterExperiences'],
      }),
      postProjectsByProjectIdHighlighterExperiencesAndExperienceIdActivate: build.mutation<
        PostProjectsByProjectIdHighlighterExperiencesAndExperienceIdActivateApiResponse,
        PostProjectsByProjectIdHighlighterExperiencesAndExperienceIdActivateApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/HighlighterExperiences/${queryArg.experienceId}/$activate`,
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['HighlighterExperiences'],
      }),
      getHubSpotDealsByDealId: build.query<
        GetHubSpotDealsByDealIdApiResponse,
        GetHubSpotDealsByDealIdApiArg
      >({
        query: (queryArg) => ({ url: `/HubSpot/Deals/${queryArg.dealId}` }),
        providesTags: ['HubSpotDeals'],
      }),
      postInserts: build.mutation<PostInsertsApiResponse, PostInsertsApiArg>({
        query: (queryArg) => ({
          url: `/Inserts`,
          method: 'POST',
          body: queryArg.createInsertRequest,
        }),
        invalidatesTags: ['Inserts'],
      }),
      putInsertsByInsertId: build.mutation<
        PutInsertsByInsertIdApiResponse,
        PutInsertsByInsertIdApiArg
      >({
        query: (queryArg) => ({
          url: `/Inserts/${queryArg.insertId}`,
          method: 'PUT',
          body: queryArg.insert,
        }),
        invalidatesTags: ['Inserts'],
      }),
      deleteInsertsByInsertId: build.mutation<
        DeleteInsertsByInsertIdApiResponse,
        DeleteInsertsByInsertIdApiArg
      >({
        query: (queryArg) => ({ url: `/Inserts/${queryArg.insertId}`, method: 'DELETE' }),
        invalidatesTags: ['Inserts'],
      }),
      postInsertsByInsertIdFile: build.mutation<
        PostInsertsByInsertIdFileApiResponse,
        PostInsertsByInsertIdFileApiArg
      >({
        query: (queryArg) => ({
          url: `/Inserts/${queryArg.insertId}/file`,
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['Inserts'],
      }),
      deleteInsertsByInsertIdFile: build.mutation<
        DeleteInsertsByInsertIdFileApiResponse,
        DeleteInsertsByInsertIdFileApiArg
      >({
        query: (queryArg) => ({ url: `/Inserts/${queryArg.insertId}/file`, method: 'DELETE' }),
        invalidatesTags: ['Inserts'],
      }),
      getProjectsByProjectIdKits: build.query<
        GetProjectsByProjectIdKitsApiResponse,
        GetProjectsByProjectIdKitsApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/Kits`,
          params: {
            details: queryArg.details,
          },
        }),
        providesTags: ['Kits'],
      }),
      postProjectsByProjectIdKits: build.mutation<
        PostProjectsByProjectIdKitsApiResponse,
        PostProjectsByProjectIdKitsApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/Kits`,
          method: 'POST',
          body: queryArg.kit,
        }),
        invalidatesTags: ['Kits'],
      }),
      putProjectsByProjectIdKitsAndKitId: build.mutation<
        PutProjectsByProjectIdKitsAndKitIdApiResponse,
        PutProjectsByProjectIdKitsAndKitIdApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/Kits/${queryArg.kitId}`,
          method: 'PUT',
          body: queryArg.kit,
        }),
        invalidatesTags: ['Kits'],
      }),
      deleteProjectsByProjectIdKitsAndKitId: build.mutation<
        DeleteProjectsByProjectIdKitsAndKitIdApiResponse,
        DeleteProjectsByProjectIdKitsAndKitIdApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/Kits/${queryArg.kitId}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['Kits'],
      }),
      getProjectsByProjectIdKitsAndKitIdAssets: build.query<
        GetProjectsByProjectIdKitsAndKitIdAssetsApiResponse,
        GetProjectsByProjectIdKitsAndKitIdAssetsApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/Kits/${queryArg.kitId}/Assets`,
        }),
        providesTags: ['Kits'],
      }),
      postProjectsByProjectIdKitsAndKitIdAssets: build.mutation<
        PostProjectsByProjectIdKitsAndKitIdAssetsApiResponse,
        PostProjectsByProjectIdKitsAndKitIdAssetsApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/Kits/${queryArg.kitId}/Assets`,
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['Kits'],
      }),
      deleteProjectsByProjectIdKitsAndKitIdAssetsKitAssetId: build.mutation<
        DeleteProjectsByProjectIdKitsAndKitIdAssetsKitAssetIdApiResponse,
        DeleteProjectsByProjectIdKitsAndKitIdAssetsKitAssetIdApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/Kits/${queryArg.kitId}/Assets/${queryArg.kitAssetId}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['Kits'],
      }),
      postProjectsByProjectIdKitsAndKitIdRequestReview: build.mutation<
        PostProjectsByProjectIdKitsAndKitIdRequestReviewApiResponse,
        PostProjectsByProjectIdKitsAndKitIdRequestReviewApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/Kits/${queryArg.kitId}/$RequestReview`,
          method: 'POST',
          body: queryArg.requestReviewRequest,
        }),
        invalidatesTags: ['Kits'],
      }),
      postProjectsByProjectIdKitsAndKitIdReview: build.mutation<
        PostProjectsByProjectIdKitsAndKitIdReviewApiResponse,
        PostProjectsByProjectIdKitsAndKitIdReviewApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/Kits/${queryArg.kitId}/$Review`,
          method: 'POST',
          body: queryArg.reviewRequest,
        }),
        invalidatesTags: ['Kits'],
      }),
      postProjectsByProjectIdLinks: build.mutation<
        PostProjectsByProjectIdLinksApiResponse,
        PostProjectsByProjectIdLinksApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/Links`,
          method: 'POST',
          body: queryArg.createRequest,
        }),
        invalidatesTags: ['Links'],
      }),
      getProjectsByProjectIdLinks: build.query<
        GetProjectsByProjectIdLinksApiResponse,
        GetProjectsByProjectIdLinksApiArg
      >({
        query: (queryArg) => ({ url: `/Projects/${queryArg.projectId}/Links` }),
        providesTags: ['Links'],
      }),
      putProjectsByProjectIdLinksAndProjectLinkId: build.mutation<
        PutProjectsByProjectIdLinksAndProjectLinkIdApiResponse,
        PutProjectsByProjectIdLinksAndProjectLinkIdApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/Links/${queryArg.projectLinkId}`,
          method: 'PUT',
          body: queryArg.projectLink,
        }),
        invalidatesTags: ['Links'],
      }),
      deleteProjectsByProjectIdLinksAndProjectLinkId: build.mutation<
        DeleteProjectsByProjectIdLinksAndProjectLinkIdApiResponse,
        DeleteProjectsByProjectIdLinksAndProjectLinkIdApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/Links/${queryArg.projectLinkId}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['Links'],
      }),
      getProjectsByProjectIdSurveysManual: build.query<
        GetProjectsByProjectIdSurveysManualApiResponse,
        GetProjectsByProjectIdSurveysManualApiArg
      >({
        query: (queryArg) => ({ url: `/Projects/${queryArg.projectId}/Surveys/Manual` }),
        providesTags: ['ManualSurveys'],
      }),
      postProjectsByProjectIdSurveysManual: build.mutation<
        PostProjectsByProjectIdSurveysManualApiResponse,
        PostProjectsByProjectIdSurveysManualApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/Surveys/Manual`,
          method: 'POST',
          body: queryArg.createManualSurveyRequest,
        }),
        invalidatesTags: ['ManualSurveys'],
      }),
      patchProjectsByProjectIdSurveysManualAndSurveyId: build.mutation<
        PatchProjectsByProjectIdSurveysManualAndSurveyIdApiResponse,
        PatchProjectsByProjectIdSurveysManualAndSurveyIdApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/Surveys/Manual/${queryArg.surveyId}`,
          method: 'PATCH',
          body: queryArg.updateManualSurveyRequest,
        }),
        invalidatesTags: ['ManualSurveys'],
      }),
      postModulesByModuleIdBlocksAssign: build.mutation<
        PostModulesByModuleIdBlocksAssignApiResponse,
        PostModulesByModuleIdBlocksAssignApiArg
      >({
        query: (queryArg) => ({
          url: `/Modules/${queryArg.moduleId}/Blocks/$assign`,
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['ModuleBlocks'],
      }),
      getModuleConfigurations: build.query<
        GetModuleConfigurationsApiResponse,
        GetModuleConfigurationsApiArg
      >({
        query: (queryArg) => ({
          url: `/ModuleConfigurations`,
          params: {
            solutionId: queryArg.solutionId,
            surveyRoleId: queryArg.surveyRoleId,
            testCategoryId: queryArg.testCategoryId,
            subject: queryArg.subject,
          },
        }),
        providesTags: ['ModuleConfigurations'],
      }),
      postModuleConfigurations: build.mutation<
        PostModuleConfigurationsApiResponse,
        PostModuleConfigurationsApiArg
      >({
        query: (queryArg) => ({
          url: `/ModuleConfigurations`,
          method: 'POST',
          body: queryArg.moduleConfiguration,
        }),
        invalidatesTags: ['ModuleConfigurations'],
      }),
      postModuleConfigurationsAssign: build.mutation<
        PostModuleConfigurationsAssignApiResponse,
        PostModuleConfigurationsAssignApiArg
      >({
        query: (queryArg) => ({
          url: `/ModuleConfigurations/$assign`,
          method: 'POST',
          body: queryArg.assignModuleConfigurationsToBlueprintRequest,
        }),
        invalidatesTags: ['ModuleConfigurations'],
      }),
      getModulesByModuleId: build.query<
        GetModulesByModuleIdApiResponse,
        GetModulesByModuleIdApiArg
      >({
        query: (queryArg) => ({ url: `/Modules/${queryArg.moduleId}` }),
        providesTags: ['Modules'],
      }),
      getModules: build.query<GetModulesApiResponse, GetModulesApiArg>({
        query: (queryArg) => ({
          url: `/Modules`,
          params: {
            projectId: queryArg.projectId,
            moduleType: queryArg.moduleType,
            surveyRoleId: queryArg.surveyRoleId,
            excludeArchived: queryArg.excludeArchived,
            subject: queryArg.subject,
            testCategoryId: queryArg.testCategoryId,
          },
        }),
        providesTags: ['Modules'],
      }),
      postModules: build.mutation<PostModulesApiResponse, PostModulesApiArg>({
        query: (queryArg) => ({ url: `/Modules`, method: 'POST', body: queryArg.module }),
        invalidatesTags: ['Modules'],
      }),
      putModules: build.mutation<PutModulesApiResponse, PutModulesApiArg>({
        query: (queryArg) => ({ url: `/Modules`, method: 'PUT', body: queryArg.module }),
        invalidatesTags: ['Modules'],
      }),
      getBlocksByBlockIdModules: build.query<
        GetBlocksByBlockIdModulesApiResponse,
        GetBlocksByBlockIdModulesApiArg
      >({
        query: (queryArg) => ({ url: `/Blocks/${queryArg.blockId}/Modules` }),
        providesTags: ['Modules'],
      }),
      getProjectsByProjectIdNotificationUnsubscriptions: build.query<
        GetProjectsByProjectIdNotificationUnsubscriptionsApiResponse,
        GetProjectsByProjectIdNotificationUnsubscriptionsApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/NotificationUnsubscriptions`,
        }),
        providesTags: ['NotificationUnsubscriptions'],
      }),
      postProjectsByProjectIdNotificationUnsubscriptions: build.mutation<
        PostProjectsByProjectIdNotificationUnsubscriptionsApiResponse,
        PostProjectsByProjectIdNotificationUnsubscriptionsApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/NotificationUnsubscriptions`,
          method: 'POST',
          body: queryArg.notificationUnsubscription,
        }),
        invalidatesTags: ['NotificationUnsubscriptions'],
      }),
      deleteProjectsByProjectIdNotificationUnsubscriptions: build.mutation<
        DeleteProjectsByProjectIdNotificationUnsubscriptionsApiResponse,
        DeleteProjectsByProjectIdNotificationUnsubscriptionsApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/NotificationUnsubscriptions`,
          method: 'DELETE',
          body: queryArg.notificationUnsubscription,
        }),
        invalidatesTags: ['NotificationUnsubscriptions'],
      }),
      postOrganizations: build.mutation<PostOrganizationsApiResponse, PostOrganizationsApiArg>({
        query: (queryArg) => ({
          url: `/Organizations`,
          method: 'POST',
          body: queryArg.organization,
        }),
        invalidatesTags: ['Organizations'],
      }),
      getOrganizations: build.query<GetOrganizationsApiResponse, GetOrganizationsApiArg>({
        query: (queryArg) => ({
          url: `/Organizations`,
          params: {
            includeDeleted: queryArg.includeDeleted,
          },
        }),
        providesTags: ['Organizations'],
      }),
      putOrganizations: build.mutation<PutOrganizationsApiResponse, PutOrganizationsApiArg>({
        query: (queryArg) => ({
          url: `/Organizations`,
          method: 'PUT',
          body: queryArg.organization,
        }),
        invalidatesTags: ['Organizations'],
      }),
      getOrganizationsByOrgIdEntitlementDefn: build.query<
        GetOrganizationsByOrgIdEntitlementDefnApiResponse,
        GetOrganizationsByOrgIdEntitlementDefnApiArg
      >({
        query: (queryArg) => ({ url: `/Organizations/${queryArg.orgId}/EntitlementDefn` }),
        providesTags: ['Organizations'],
      }),
      getOrganizationsByOrgIdCommunities: build.query<
        GetOrganizationsByOrgIdCommunitiesApiResponse,
        GetOrganizationsByOrgIdCommunitiesApiArg
      >({
        query: (queryArg) => ({ url: `/Organizations/${queryArg.orgId}/communities` }),
        providesTags: ['Organizations'],
      }),
      getProjectsByProjectIdPackingListBoxConfigurations: build.query<
        GetProjectsByProjectIdPackingListBoxConfigurationsApiResponse,
        GetProjectsByProjectIdPackingListBoxConfigurationsApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/PackingList/$boxConfigurations`,
          params: {
            kitId: queryArg.kitId,
          },
        }),
        providesTags: ['PackingList'],
      }),
      getProjectsByProjectIdPackingListSimplifiedBoxList: build.query<
        GetProjectsByProjectIdPackingListSimplifiedBoxListApiResponse,
        GetProjectsByProjectIdPackingListSimplifiedBoxListApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/PackingList/$simplifiedBoxList`,
          params: {
            kitId: queryArg.kitId,
          },
        }),
        providesTags: ['PackingList'],
      }),
      postOrganizationsByOrgIdPersonaPanelsAndPersonaPanelIdChatConversationsConversationIdMessages:
        build.mutation<
          PostOrganizationsByOrgIdPersonaPanelsAndPersonaPanelIdChatConversationsConversationIdMessagesApiResponse,
          PostOrganizationsByOrgIdPersonaPanelsAndPersonaPanelIdChatConversationsConversationIdMessagesApiArg
        >({
          query: (queryArg) => ({
            url: `/Organizations/${queryArg.orgId}/PersonaPanels/${queryArg.personaPanelId}/ChatConversations/${queryArg.conversationId}/Messages`,
            method: 'POST',
            body: queryArg.appendChatMessageRequest,
          }),
          invalidatesTags: ['PersonaChatConversations'],
        }),
      getOrganizationsByOrgIdPersonaPanelsAndPersonaPanelIdChatConversationsConversationId:
        build.query<
          GetOrganizationsByOrgIdPersonaPanelsAndPersonaPanelIdChatConversationsConversationIdApiResponse,
          GetOrganizationsByOrgIdPersonaPanelsAndPersonaPanelIdChatConversationsConversationIdApiArg
        >({
          query: (queryArg) => ({
            url: `/Organizations/${queryArg.orgId}/PersonaPanels/${queryArg.personaPanelId}/ChatConversations/${queryArg.conversationId}`,
          }),
          providesTags: ['PersonaChatConversations'],
        }),
      patchOrganizationsByOrgIdPersonaPanelsAndPersonaPanelIdChatConversationsConversationId:
        build.mutation<
          PatchOrganizationsByOrgIdPersonaPanelsAndPersonaPanelIdChatConversationsConversationIdApiResponse,
          PatchOrganizationsByOrgIdPersonaPanelsAndPersonaPanelIdChatConversationsConversationIdApiArg
        >({
          query: (queryArg) => ({
            url: `/Organizations/${queryArg.orgId}/PersonaPanels/${queryArg.personaPanelId}/ChatConversations/${queryArg.conversationId}`,
            method: 'PATCH',
            body: queryArg.updateChatConversationRequest,
          }),
          invalidatesTags: ['PersonaChatConversations'],
        }),
      deleteOrganizationsByOrgIdPersonaPanelsAndPersonaPanelIdChatConversationsConversationId:
        build.mutation<
          DeleteOrganizationsByOrgIdPersonaPanelsAndPersonaPanelIdChatConversationsConversationIdApiResponse,
          DeleteOrganizationsByOrgIdPersonaPanelsAndPersonaPanelIdChatConversationsConversationIdApiArg
        >({
          query: (queryArg) => ({
            url: `/Organizations/${queryArg.orgId}/PersonaPanels/${queryArg.personaPanelId}/ChatConversations/${queryArg.conversationId}`,
            method: 'DELETE',
          }),
          invalidatesTags: ['PersonaChatConversations'],
        }),
      getOrganizationsByOrgIdPersonaPanelsAndPersonaPanelIdChatConversations: build.query<
        GetOrganizationsByOrgIdPersonaPanelsAndPersonaPanelIdChatConversationsApiResponse,
        GetOrganizationsByOrgIdPersonaPanelsAndPersonaPanelIdChatConversationsApiArg
      >({
        query: (queryArg) => ({
          url: `/Organizations/${queryArg.orgId}/PersonaPanels/${queryArg.personaPanelId}/ChatConversations`,
          params: {
            limit: queryArg.limit,
          },
        }),
        providesTags: ['PersonaChatConversations'],
      }),
      getProjectsByProjectIdPresentationrules: build.query<
        GetProjectsByProjectIdPresentationrulesApiResponse,
        GetProjectsByProjectIdPresentationrulesApiArg
      >({
        query: (queryArg) => ({ url: `/projects/${queryArg.projectId}/presentationrules` }),
        providesTags: ['PresentationRules'],
      }),
      putProjectsByProjectIdPresentationrulesAndSlug: build.mutation<
        PutProjectsByProjectIdPresentationrulesAndSlugApiResponse,
        PutProjectsByProjectIdPresentationrulesAndSlugApiArg
      >({
        query: (queryArg) => ({
          url: `/projects/${queryArg.projectId}/presentationrules/${queryArg.slug}`,
          method: 'PUT',
          body: queryArg.editPresentationRuleRequest,
        }),
        invalidatesTags: ['PresentationRules'],
      }),
      deleteProjectsByProjectIdPresentationrulesAndSlug: build.mutation<
        DeleteProjectsByProjectIdPresentationrulesAndSlugApiResponse,
        DeleteProjectsByProjectIdPresentationrulesAndSlugApiArg
      >({
        query: (queryArg) => ({
          url: `/projects/${queryArg.projectId}/presentationrules/${queryArg.slug}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['PresentationRules'],
      }),
      getProjectsByProjectIdProductLists: build.query<
        GetProjectsByProjectIdProductListsApiResponse,
        GetProjectsByProjectIdProductListsApiArg
      >({
        query: (queryArg) => ({ url: `/Projects/${queryArg.projectId}/ProductLists` }),
        providesTags: ['ProductLists'],
      }),
      postProjectsByProjectIdProductLists: build.mutation<
        PostProjectsByProjectIdProductListsApiResponse,
        PostProjectsByProjectIdProductListsApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/ProductLists`,
          method: 'POST',
          body: queryArg.productList,
        }),
        invalidatesTags: ['ProductLists'],
      }),
      putProjectsByProjectIdProductListsAndId: build.mutation<
        PutProjectsByProjectIdProductListsAndIdApiResponse,
        PutProjectsByProjectIdProductListsAndIdApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/ProductLists/${queryArg.id}`,
          method: 'PUT',
          body: queryArg.productList,
        }),
        invalidatesTags: ['ProductLists'],
      }),
      deleteProjectsByProjectIdProductListsAndId: build.mutation<
        DeleteProjectsByProjectIdProductListsAndIdApiResponse,
        DeleteProjectsByProjectIdProductListsAndIdApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/ProductLists/${queryArg.id}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['ProductLists'],
      }),
      getProjectsByProjectIdProductProjectAssets: build.query<
        GetProjectsByProjectIdProductProjectAssetsApiResponse,
        GetProjectsByProjectIdProductProjectAssetsApiArg
      >({
        query: (queryArg) => ({ url: `/Projects/${queryArg.projectId}/ProductProjectAssets` }),
        providesTags: ['ProductProjectAssets'],
      }),
      postProjectsByProjectIdProductsAndProductIdProductProjectAssets: build.mutation<
        PostProjectsByProjectIdProductsAndProductIdProductProjectAssetsApiResponse,
        PostProjectsByProjectIdProductsAndProductIdProductProjectAssetsApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/Products/${queryArg.productId}/ProductProjectAssets`,
          method: 'POST',
          body: queryArg.productProjectAssetRequest,
        }),
        invalidatesTags: ['ProductProjectAssets'],
      }),
      deleteProductProjectAssetsByProductProjectAssetId: build.mutation<
        DeleteProductProjectAssetsByProductProjectAssetIdApiResponse,
        DeleteProductProjectAssetsByProductProjectAssetIdApiArg
      >({
        query: (queryArg) => ({
          url: `/ProductProjectAssets/${queryArg.productProjectAssetId}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['ProductProjectAssets'],
      }),
      getProductsByProductId: build.query<
        GetProductsByProductIdApiResponse,
        GetProductsByProductIdApiArg
      >({
        query: (queryArg) => ({
          url: `/Products/${queryArg.productId}`,
          params: {
            projectId: queryArg.projectId,
          },
        }),
        providesTags: ['Products'],
      }),
      putProductsByProductId: build.mutation<
        PutProductsByProductIdApiResponse,
        PutProductsByProductIdApiArg
      >({
        query: (queryArg) => ({
          url: `/Products/${queryArg.productId}`,
          method: 'PUT',
          body: queryArg.product,
          params: {
            projectId: queryArg.projectId,
          },
        }),
        invalidatesTags: ['Products'],
      }),
      postProjectsByProjectIdProducts: build.mutation<
        PostProjectsByProjectIdProductsApiResponse,
        PostProjectsByProjectIdProductsApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/Products`,
          method: 'POST',
          body: queryArg.product,
        }),
        invalidatesTags: ['Products'],
      }),
      getProjectsByProjectIdProducts: build.query<
        GetProjectsByProjectIdProductsApiResponse,
        GetProjectsByProjectIdProductsApiArg
      >({
        query: (queryArg) => ({ url: `/Projects/${queryArg.projectId}/Products` }),
        providesTags: ['Products'],
      }),
      putProjectsByProjectIdProducts: build.mutation<
        PutProjectsByProjectIdProductsApiResponse,
        PutProjectsByProjectIdProductsApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/Products`,
          method: 'PUT',
          body: queryArg.product,
        }),
        invalidatesTags: ['Products'],
      }),
      deleteProjectsByProjectIdProducts: build.mutation<
        DeleteProjectsByProjectIdProductsApiResponse,
        DeleteProjectsByProjectIdProductsApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/Products`,
          method: 'DELETE',
          body: queryArg.product,
        }),
        invalidatesTags: ['Products'],
      }),
      postProjectsByProjectIdProductsBulk: build.mutation<
        PostProjectsByProjectIdProductsBulkApiResponse,
        PostProjectsByProjectIdProductsBulkApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/Products/$bulk`,
          method: 'POST',
          body: queryArg.bulkProductRequest,
        }),
        invalidatesTags: ['Products', 'TestGroupV10s'],
      }),
      postProjectsByProjectIdProductsSurveyRenamePlan: build.mutation<
        PostProjectsByProjectIdProductsSurveyRenamePlanApiResponse,
        PostProjectsByProjectIdProductsSurveyRenamePlanApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/Products/$surveyRenamePlan`,
          method: 'POST',
          body: queryArg.productSurveyRenamePlanRequest,
        }),
        invalidatesTags: ['Products'],
      }),
      getProjectCategories: build.query<
        GetProjectCategoriesApiResponse,
        GetProjectCategoriesApiArg
      >({
        query: () => ({ url: `/ProjectCategories` }),
        providesTags: ['ProjectCategories'],
      }),
      getProjectFinalReportsByProjectId: build.query<
        GetProjectFinalReportsByProjectIdApiResponse,
        GetProjectFinalReportsByProjectIdApiArg
      >({
        query: (queryArg) => ({ url: `/ProjectFinalReports/${queryArg.projectId}` }),
        providesTags: ['ProjectFinalReports'],
      }),
      putProjectFinalReportsByProjectId: build.mutation<
        PutProjectFinalReportsByProjectIdApiResponse,
        PutProjectFinalReportsByProjectIdApiArg
      >({
        query: (queryArg) => ({
          url: `/ProjectFinalReports/${queryArg.projectId}`,
          method: 'PUT',
          body: queryArg.projectFinalReports,
        }),
        invalidatesTags: ['ProjectFinalReports'],
      }),
      postProjectFinalReportsUploadFile: build.mutation<
        PostProjectFinalReportsUploadFileApiResponse,
        PostProjectFinalReportsUploadFileApiArg
      >({
        query: (queryArg) => ({
          url: `/ProjectFinalReports/$uploadFile`,
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['ProjectFinalReports'],
      }),
      getProjectsByProjectIdProjectIntakeAnswers: build.query<
        GetProjectsByProjectIdProjectIntakeAnswersApiResponse,
        GetProjectsByProjectIdProjectIntakeAnswersApiArg
      >({
        query: (queryArg) => ({ url: `/projects/${queryArg.projectId}/ProjectIntakeAnswers` }),
        providesTags: ['ProjectIntakeAnswers'],
      }),
      postAdminProcessAllProjects: build.mutation<
        PostAdminProcessAllProjectsApiResponse,
        PostAdminProcessAllProjectsApiArg
      >({
        query: () => ({ url: `/admin/$processAllProjects`, method: 'POST' }),
        invalidatesTags: ['ProjectOrchestrator'],
      }),
      postProjectsByProjectIdAiReview: build.mutation<
        PostProjectsByProjectIdAiReviewApiResponse,
        PostProjectsByProjectIdAiReviewApiArg
      >({
        query: (queryArg) => ({ url: `/projects/${queryArg.projectId}/ai-review`, method: 'POST' }),
        invalidatesTags: ['ProjectReview'],
      }),
      getProjectsByProjectIdAiReview: build.query<
        GetProjectsByProjectIdAiReviewApiResponse,
        GetProjectsByProjectIdAiReviewApiArg
      >({
        query: (queryArg) => ({ url: `/projects/${queryArg.projectId}/ai-review` }),
        providesTags: ['ProjectReview'],
      }),
      postProjectsByProjectIdAiSummary: build.mutation<
        PostProjectsByProjectIdAiSummaryApiResponse,
        PostProjectsByProjectIdAiSummaryApiArg
      >({
        query: (queryArg) => ({
          url: `/projects/${queryArg.projectId}/ai-summary`,
          method: 'POST',
        }),
        invalidatesTags: ['ProjectReview'],
      }),
      getProjectsByProjectIdAiSummary: build.query<
        GetProjectsByProjectIdAiSummaryApiResponse,
        GetProjectsByProjectIdAiSummaryApiArg
      >({
        query: (queryArg) => ({ url: `/projects/${queryArg.projectId}/ai-summary` }),
        providesTags: ['ProjectReview'],
      }),
      postProjects: build.mutation<PostProjectsApiResponse, PostProjectsApiArg>({
        query: (queryArg) => ({ url: `/projects`, method: 'POST', body: queryArg.project }),
        invalidatesTags: ['Projects'],
      }),
      postProjectsConfigure: build.mutation<
        PostProjectsConfigureApiResponse,
        PostProjectsConfigureApiArg
      >({
        query: (queryArg) => ({
          url: `/projects/$configure`,
          method: 'POST',
          body: queryArg.projectConfigurationDto,
        }),
        invalidatesTags: ['Projects'],
      }),
      postProjectsConfigureV2: build.mutation<
        PostProjectsConfigureV2ApiResponse,
        PostProjectsConfigureV2ApiArg
      >({
        query: (queryArg) => ({
          url: `/projects/$configureV2`,
          method: 'POST',
          body: queryArg.configureProjectV2Request,
        }),
        invalidatesTags: ['Projects'],
      }),
      putProjects: build.mutation<PutProjectsApiResponse, PutProjectsApiArg>({
        query: (queryArg) => ({ url: `/Projects`, method: 'PUT', body: queryArg.project }),
        invalidatesTags: ['Projects'],
      }),
      getProjects: build.query<GetProjectsApiResponse, GetProjectsApiArg>({
        query: (queryArg) => ({
          url: `/Projects`,
          params: {
            publicId: queryArg.publicId,
            type: queryArg['type'],
            teamId: queryArg.teamId,
          },
        }),
        providesTags: ['Projects'],
      }),
      patchProjectsByProjectId: build.mutation<
        PatchProjectsByProjectIdApiResponse,
        PatchProjectsByProjectIdApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}`,
          method: 'PATCH',
          body: queryArg.updateProjectRequest,
        }),
        invalidatesTags: ['Projects'],
      }),
      getProjectsByProjectId: build.query<
        GetProjectsByProjectIdApiResponse,
        GetProjectsByProjectIdApiArg
      >({
        query: (queryArg) => ({ url: `/Projects/${queryArg.projectId}` }),
        providesTags: ['Projects'],
      }),
      deleteProjectsByProjectId: build.mutation<
        DeleteProjectsByProjectIdApiResponse,
        DeleteProjectsByProjectIdApiArg
      >({
        query: (queryArg) => ({ url: `/Projects/${queryArg.projectId}`, method: 'DELETE' }),
        invalidatesTags: ['Projects'],
      }),
      getProjectsByProjectIdNotificationEntitlements: build.query<
        GetProjectsByProjectIdNotificationEntitlementsApiResponse,
        GetProjectsByProjectIdNotificationEntitlementsApiArg
      >({
        query: (queryArg) => ({ url: `/Projects/${queryArg.projectId}/NotificationEntitlements` }),
        providesTags: ['Projects'],
      }),
      getProjectsByProjectIdStatus: build.query<
        GetProjectsByProjectIdStatusApiResponse,
        GetProjectsByProjectIdStatusApiArg
      >({
        query: (queryArg) => ({ url: `/Projects/${queryArg.projectId}/$status` }),
        providesTags: ['Projects'],
      }),
      getProjectsByProjectIdProductSurveyConfigIds: build.query<
        GetProjectsByProjectIdProductSurveyConfigIdsApiResponse,
        GetProjectsByProjectIdProductSurveyConfigIdsApiArg
      >({
        query: (queryArg) => ({ url: `/Projects/${queryArg.projectId}/ProductSurveyConfigIds` }),
        providesTags: ['Projects'],
      }),
      getProjectsByProjectIdProductSurveyConfigMap: build.query<
        GetProjectsByProjectIdProductSurveyConfigMapApiResponse,
        GetProjectsByProjectIdProductSurveyConfigMapApiArg
      >({
        query: (queryArg) => ({ url: `/Projects/${queryArg.projectId}/product-survey-config-map` }),
        providesTags: ['Projects'],
      }),
      getProjectsByProjectIdInserts: build.query<
        GetProjectsByProjectIdInsertsApiResponse,
        GetProjectsByProjectIdInsertsApiArg
      >({
        query: (queryArg) => ({ url: `/Projects/${queryArg.projectId}/inserts` }),
        providesTags: ['Projects'],
      }),
      getProjectsAdminProjects: build.query<
        GetProjectsAdminProjectsApiResponse,
        GetProjectsAdminProjectsApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/$adminProjects`,
          params: {
            status: queryArg.status,
            text: queryArg.text,
            ids: queryArg.ids,
            details: queryArg.details,
            type: queryArg['type'],
          },
        }),
        providesTags: ['Projects'],
      }),
      postProjectsByProjectIdAssignAdmins: build.mutation<
        PostProjectsByProjectIdAssignAdminsApiResponse,
        PostProjectsByProjectIdAssignAdminsApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/$assignAdmins`,
          method: 'POST',
          body: queryArg.assignProjectAdminsRequest,
        }),
        invalidatesTags: ['Projects'],
      }),
      getProjectsAutomaticRecruiting: build.query<
        GetProjectsAutomaticRecruitingApiResponse,
        GetProjectsAutomaticRecruitingApiArg
      >({
        query: () => ({ url: `/Projects/$automaticRecruiting` }),
        providesTags: ['Projects'],
      }),
      patchProjectsByProjectIdStatus: build.mutation<
        PatchProjectsByProjectIdStatusApiResponse,
        PatchProjectsByProjectIdStatusApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/status`,
          method: 'PATCH',
          body: queryArg.projectStatusRequest,
        }),
        invalidatesTags: ['Projects'],
      }),
      patchProjectsByProjectIdTeam: build.mutation<
        PatchProjectsByProjectIdTeamApiResponse,
        PatchProjectsByProjectIdTeamApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/team`,
          method: 'PATCH',
          body: queryArg.projectTeamRequest,
        }),
        invalidatesTags: ['Projects'],
      }),
      patchProjectsByProjectIdProductBlindingMethod: build.mutation<
        PatchProjectsByProjectIdProductBlindingMethodApiResponse,
        PatchProjectsByProjectIdProductBlindingMethodApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/productBlindingMethod`,
          method: 'PATCH',
          body: queryArg.projectProductBlindingMethodRequest,
        }),
        invalidatesTags: ['Projects'],
      }),
      patchProjectsByProjectIdName: build.mutation<
        PatchProjectsByProjectIdNameApiResponse,
        PatchProjectsByProjectIdNameApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/name`,
          method: 'PATCH',
          body: queryArg.projectNameRequest,
        }),
        invalidatesTags: ['Projects'],
      }),
      postProjectsByProjectIdUploadBoxTracking: build.mutation<
        PostProjectsByProjectIdUploadBoxTrackingApiResponse,
        PostProjectsByProjectIdUploadBoxTrackingApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/$uploadBoxTracking`,
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['Projects'],
      }),
      postProjectsByProjectIdSyncKits: build.mutation<
        PostProjectsByProjectIdSyncKitsApiResponse,
        PostProjectsByProjectIdSyncKitsApiArg
      >({
        query: (queryArg) => ({ url: `/Projects/${queryArg.projectId}/$syncKits`, method: 'POST' }),
        invalidatesTags: ['Projects'],
      }),
      postProjectsCreateFromExisting: build.mutation<
        PostProjectsCreateFromExistingApiResponse,
        PostProjectsCreateFromExistingApiArg
      >({
        query: (queryArg) => ({
          url: `/projects/$createFromExisting`,
          method: 'POST',
          body: queryArg.createProjectFromExistingProjectsRequest,
        }),
        invalidatesTags: ['Projects'],
      }),
      postProjectsByProjectIdDisableAutomations: build.mutation<
        PostProjectsByProjectIdDisableAutomationsApiResponse,
        PostProjectsByProjectIdDisableAutomationsApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/$disableAutomations`,
          method: 'POST',
        }),
        invalidatesTags: ['Projects'],
      }),
      postProjectsByProjectIdLaunchProject: build.mutation<
        PostProjectsByProjectIdLaunchProjectApiResponse,
        PostProjectsByProjectIdLaunchProjectApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/$LaunchProject`,
          method: 'POST',
        }),
        invalidatesTags: ['Projects'],
      }),
      putProjectsByProjectIdTimeline: build.mutation<
        PutProjectsByProjectIdTimelineApiResponse,
        PutProjectsByProjectIdTimelineApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/timeline`,
          method: 'PUT',
          body: queryArg.updateTimelineRequest,
        }),
        invalidatesTags: ['Projects'],
      }),
      postProjectsByProjectIdQuestionsAutoLink: build.mutation<
        PostProjectsByProjectIdQuestionsAutoLinkApiResponse,
        PostProjectsByProjectIdQuestionsAutoLinkApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/questions/$auto-link`,
          method: 'POST',
        }),
        invalidatesTags: ['Projects'],
      }),
      postProjectsByProjectIdScorecardPopulate: build.mutation<
        PostProjectsByProjectIdScorecardPopulateApiResponse,
        PostProjectsByProjectIdScorecardPopulateApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/scorecard/$populate`,
          method: 'POST',
        }),
        invalidatesTags: ['Projects'],
      }),
      getProjectsGetActiveParticipantGuidanceProjectIds: build.query<
        GetProjectsGetActiveParticipantGuidanceProjectIdsApiResponse,
        GetProjectsGetActiveParticipantGuidanceProjectIdsApiArg
      >({
        query: () => ({ url: `/Projects/$getActiveParticipantGuidanceProjectIds` }),
        providesTags: ['Projects'],
      }),
      postProjectsByProjectIdUpdateDashboard: build.mutation<
        PostProjectsByProjectIdUpdateDashboardApiResponse,
        PostProjectsByProjectIdUpdateDashboardApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/$updateDashboard`,
          method: 'POST',
          body: queryArg.updateDashboardRequest,
        }),
        invalidatesTags: ['Projects'],
      }),
      getProjectsByProjectIdConfigurations: build.query<
        GetProjectsByProjectIdConfigurationsApiResponse,
        GetProjectsByProjectIdConfigurationsApiArg
      >({
        query: (queryArg) => ({ url: `/projects/${queryArg.projectId}/configurations` }),
        providesTags: ['ProjectsConfiguration'],
      }),
      getProjectsByProjectIdExperiences: build.query<
        GetProjectsByProjectIdExperiencesApiResponse,
        GetProjectsByProjectIdExperiencesApiArg
      >({
        query: (queryArg) => ({ url: `/projects/${queryArg.projectId}/experiences` }),
        providesTags: ['ProjectsConfiguration'],
      }),
      postProjectsHackyconfigure: build.mutation<
        PostProjectsHackyconfigureApiResponse,
        PostProjectsHackyconfigureApiArg
      >({
        query: (queryArg) => ({
          url: `/projects/$hackyconfigure`,
          method: 'POST',
          body: queryArg.projectHackyConfigurationDto,
        }),
        invalidatesTags: ['ProjectsHacky'],
      }),
      deleteProjectsByProjectIdSurveysAndSurveyId: build.mutation<
        DeleteProjectsByProjectIdSurveysAndSurveyIdApiResponse,
        DeleteProjectsByProjectIdSurveysAndSurveyIdApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/Surveys/${queryArg.surveyId}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['ProjectSurveys'],
      }),
      deleteProjectsByProjectIdSurveysAndSurveyIdFile: build.mutation<
        DeleteProjectsByProjectIdSurveysAndSurveyIdFileApiResponse,
        DeleteProjectsByProjectIdSurveysAndSurveyIdFileApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/Surveys/${queryArg.surveyId}/file`,
          method: 'DELETE',
        }),
        invalidatesTags: ['ProjectSurveys'],
      }),
      getProjectsByProjectIdSurveysAndSurveyIdFile: build.query<
        GetProjectsByProjectIdSurveysAndSurveyIdFileApiResponse,
        GetProjectsByProjectIdSurveysAndSurveyIdFileApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/Surveys/${queryArg.surveyId}/file`,
        }),
        providesTags: ['ProjectSurveys'],
      }),
      postProjectsByProjectIdSurveysAndSurveyIdFile: build.mutation<
        PostProjectsByProjectIdSurveysAndSurveyIdFileApiResponse,
        PostProjectsByProjectIdSurveysAndSurveyIdFileApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/Surveys/${queryArg.surveyId}/file`,
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['ProjectSurveys'],
      }),
      getProjectsByProjectIdSurveys: build.query<
        GetProjectsByProjectIdSurveysApiResponse,
        GetProjectsByProjectIdSurveysApiArg
      >({
        query: (queryArg) => ({ url: `/Projects/${queryArg.projectId}/Surveys` }),
        providesTags: ['ProjectSurveys'],
      }),
      patchProjectsByProjectIdSurveysAndSurveyIdSurveyStatus: build.mutation<
        PatchProjectsByProjectIdSurveysAndSurveyIdSurveyStatusApiResponse,
        PatchProjectsByProjectIdSurveysAndSurveyIdSurveyStatusApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/Surveys/${queryArg.surveyId}/SurveyStatus`,
          method: 'PATCH',
          body: queryArg.setSurveyStatusRequest,
        }),
        invalidatesTags: ['ProjectSurveys'],
      }),
      patchProjectsByProjectIdSurveysAndSurveyIdResultsStatus: build.mutation<
        PatchProjectsByProjectIdSurveysAndSurveyIdResultsStatusApiResponse,
        PatchProjectsByProjectIdSurveysAndSurveyIdResultsStatusApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/Surveys/${queryArg.surveyId}/ResultsStatus`,
          method: 'PATCH',
          body: queryArg.setResultsStatusRequest,
        }),
        invalidatesTags: ['ProjectSurveys'],
      }),
      getProjectsByProjectIdQualityControlReport: build.query<
        GetProjectsByProjectIdQualityControlReportApiResponse,
        GetProjectsByProjectIdQualityControlReportApiArg
      >({
        query: (queryArg) => ({ url: `/Projects/${queryArg.projectId}/QualityControlReport` }),
        providesTags: ['QualityControlReport'],
      }),
      getQualityControlReport: build.query<
        GetQualityControlReportApiResponse,
        GetQualityControlReportApiArg
      >({
        query: (queryArg) => ({
          url: `/qualityControlReport`,
          params: {
            surveyId: queryArg.surveyId,
            surveyName: queryArg.surveyName,
          },
        }),
        providesTags: ['QualityControlReport'],
      }),
      postQualityControlReportSubmitreview: build.mutation<
        PostQualityControlReportSubmitreviewApiResponse,
        PostQualityControlReportSubmitreviewApiArg
      >({
        query: (queryArg) => ({
          url: `/qualityControlReport/$submitreview`,
          method: 'POST',
          body: queryArg.submitReviewRequest,
        }),
        invalidatesTags: ['QualityControlReport'],
      }),
      getProjectsByProjectIdQualityControlReportAndResponseId: build.query<
        GetProjectsByProjectIdQualityControlReportAndResponseIdApiResponse,
        GetProjectsByProjectIdQualityControlReportAndResponseIdApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/QualityControlReport/${queryArg.responseId}`,
        }),
        providesTags: ['QualityControlReport'],
      }),
      postProjectsByProjectIdQualityControlReportSetAnswerExcluded: build.mutation<
        PostProjectsByProjectIdQualityControlReportSetAnswerExcludedApiResponse,
        PostProjectsByProjectIdQualityControlReportSetAnswerExcludedApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/QualityControlReport/$setAnswerExcluded`,
          method: 'POST',
          body: queryArg.setAnswerExcludedPayload,
        }),
        invalidatesTags: ['QualityControlReport'],
      }),
      getProjectsByProjectIdQualityControlReportFullCompletesBreakdown: build.query<
        GetProjectsByProjectIdQualityControlReportFullCompletesBreakdownApiResponse,
        GetProjectsByProjectIdQualityControlReportFullCompletesBreakdownApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/QualityControlReport/full-completes-breakdown`,
        }),
        providesTags: ['QualityControlReport'],
      }),
      getProjectsByProjectIdRecommendation: build.query<
        GetProjectsByProjectIdRecommendationApiResponse,
        GetProjectsByProjectIdRecommendationApiArg
      >({
        query: (queryArg) => ({ url: `/projects/${queryArg.projectId}/recommendation` }),
        providesTags: ['Recommendations'],
      }),
      postProjectsByProjectIdRecommendation: build.mutation<
        PostProjectsByProjectIdRecommendationApiResponse,
        PostProjectsByProjectIdRecommendationApiArg
      >({
        query: (queryArg) => ({
          url: `/projects/${queryArg.projectId}/recommendation`,
          method: 'POST',
        }),
        invalidatesTags: ['Recommendations'],
      }),
      postProjectsByProjectIdRecruitCount: build.mutation<
        PostProjectsByProjectIdRecruitCountApiResponse,
        PostProjectsByProjectIdRecruitCountApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/RecruitCount`,
          method: 'POST',
          body: queryArg.feasibilityRecruitCountRequest,
        }),
        invalidatesTags: ['RecruitCount'],
      }),
      getProjectsByProjectIdRecruitingData: build.query<
        GetProjectsByProjectIdRecruitingDataApiResponse,
        GetProjectsByProjectIdRecruitingDataApiArg
      >({
        query: (queryArg) => ({ url: `/Projects/${queryArg.projectId}/RecruitingData` }),
        providesTags: ['RecruitingData'],
      }),
      postProjectsByProjectIdRecruitingData: build.mutation<
        PostProjectsByProjectIdRecruitingDataApiResponse,
        PostProjectsByProjectIdRecruitingDataApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/RecruitingData`,
          method: 'POST',
          body: queryArg.recruitingData,
        }),
        invalidatesTags: ['RecruitingData'],
      }),
      putProjectsByProjectIdRecruitingData: build.mutation<
        PutProjectsByProjectIdRecruitingDataApiResponse,
        PutProjectsByProjectIdRecruitingDataApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/RecruitingData`,
          method: 'PUT',
          body: queryArg.recruitingData,
        }),
        invalidatesTags: ['RecruitingData'],
      }),
      patchProjectsByProjectIdRecruitingData: build.mutation<
        PatchProjectsByProjectIdRecruitingDataApiResponse,
        PatchProjectsByProjectIdRecruitingDataApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/RecruitingData`,
          method: 'PATCH',
          body: queryArg.updateRecruitingDataStatusRequest,
        }),
        invalidatesTags: ['RecruitingData'],
      }),
      patchProjectsByProjectIdRecruitingDataPlacements: build.mutation<
        PatchProjectsByProjectIdRecruitingDataPlacementsApiResponse,
        PatchProjectsByProjectIdRecruitingDataPlacementsApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/RecruitingData/placements`,
          method: 'PATCH',
          body: queryArg.updateProjectPlacementsRequest,
        }),
        invalidatesTags: ['RecruitingData'],
      }),
      postProjectsByProjectIdRecruitingDataBoost: build.mutation<
        PostProjectsByProjectIdRecruitingDataBoostApiResponse,
        PostProjectsByProjectIdRecruitingDataBoostApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/RecruitingData/$boost`,
          method: 'POST',
          body: queryArg.boostRecruitingRequest,
        }),
        invalidatesTags: ['RecruitingData'],
      }),
      postProjectsByProjectIdRecruitingDataImport: build.mutation<
        PostProjectsByProjectIdRecruitingDataImportApiResponse,
        PostProjectsByProjectIdRecruitingDataImportApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/RecruitingData/$import`,
          method: 'POST',
        }),
        invalidatesTags: ['RecruitingData'],
      }),
      postProjectsByProjectIdReport: build.mutation<
        PostProjectsByProjectIdReportApiResponse,
        PostProjectsByProjectIdReportApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/Report`,
          method: 'POST',
          body: queryArg.reportParams,
        }),
        invalidatesTags: ['Report'],
      }),
      getProjectsByProjectIdReport: build.query<
        GetProjectsByProjectIdReportApiResponse,
        GetProjectsByProjectIdReportApiArg
      >({
        query: (queryArg) => ({ url: `/Projects/${queryArg.projectId}/Report` }),
        providesTags: ['Report'],
      }),
      getProjectsByProjectIdReportCustomerreports: build.query<
        GetProjectsByProjectIdReportCustomerreportsApiResponse,
        GetProjectsByProjectIdReportCustomerreportsApiArg
      >({
        query: (queryArg) => ({ url: `/Projects/${queryArg.projectId}/Report/customerreports` }),
        providesTags: ['Report'],
      }),
      postProjectsByProjectIdReportAndGeneratedReportIdDownloadReportDownloadType: build.mutation<
        PostProjectsByProjectIdReportAndGeneratedReportIdDownloadReportDownloadTypeApiResponse,
        PostProjectsByProjectIdReportAndGeneratedReportIdDownloadReportDownloadTypeApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/Report/${queryArg.generatedReportId}/$download/${queryArg.reportDownloadType}`,
          method: 'POST',
        }),
        invalidatesTags: ['Report'],
      }),
      deleteProjectsByProjectIdReportAndGeneratedReportId: build.mutation<
        DeleteProjectsByProjectIdReportAndGeneratedReportIdApiResponse,
        DeleteProjectsByProjectIdReportAndGeneratedReportIdApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/Report/${queryArg.generatedReportId}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['Report'],
      }),
      getProjectsByProjectIdResultContexts: build.query<
        GetProjectsByProjectIdResultContextsApiResponse,
        GetProjectsByProjectIdResultContextsApiArg
      >({
        query: (queryArg) => ({
          url: `/projects/${queryArg.projectId}/ResultContexts`,
          params: {
            includeCandidateContexts: queryArg.includeCandidateContexts,
          },
        }),
        providesTags: ['ResultContexts'],
      }),
      postProjectsByProjectIdSurveyconfigsAndSurveyConfigIdResultContexts: build.mutation<
        PostProjectsByProjectIdSurveyconfigsAndSurveyConfigIdResultContextsApiResponse,
        PostProjectsByProjectIdSurveyconfigsAndSurveyConfigIdResultContextsApiArg
      >({
        query: (queryArg) => ({
          url: `/projects/${queryArg.projectId}/surveyconfigs/${queryArg.surveyConfigId}/ResultContexts`,
          method: 'POST',
        }),
        invalidatesTags: ['ResultContexts'],
      }),
      getProjectsByProjectIdResultsDownloadcsv: build.query<
        GetProjectsByProjectIdResultsDownloadcsvApiResponse,
        GetProjectsByProjectIdResultsDownloadcsvApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/Results/$downloadcsv`,
          params: {
            positionFilter: queryArg.positionFilter,
            surveyGroupIds: queryArg.surveyGroupIds,
            selectedSurveyConfigIds: queryArg.selectedSurveyConfigIds,
          },
        }),
        providesTags: ['Results'],
      }),
      getProjectsByProjectIdResultsDownloadcodedcsv: build.query<
        GetProjectsByProjectIdResultsDownloadcodedcsvApiResponse,
        GetProjectsByProjectIdResultsDownloadcodedcsvApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/Results/$downloadcodedcsv`,
          params: {
            positionFilter: queryArg.positionFilter,
            surveyGroupIds: queryArg.surveyGroupIds,
            selectedSurveyConfigIds: queryArg.selectedSurveyConfigIds,
          },
        }),
        providesTags: ['Results'],
      }),
      getProjectsByProjectIdResultsDownloadcsvallrespondents: build.query<
        GetProjectsByProjectIdResultsDownloadcsvallrespondentsApiResponse,
        GetProjectsByProjectIdResultsDownloadcsvallrespondentsApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/Results/$downloadcsvallrespondents`,
          params: {
            positionFilter: queryArg.positionFilter,
            surveyGroupIds: queryArg.surveyGroupIds,
            selectedSurveyConfigIds: queryArg.selectedSurveyConfigIds,
          },
        }),
        providesTags: ['Results'],
      }),
      getProjectsByProjectIdResultsDownloadcodedcsvallrespondents: build.query<
        GetProjectsByProjectIdResultsDownloadcodedcsvallrespondentsApiResponse,
        GetProjectsByProjectIdResultsDownloadcodedcsvallrespondentsApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/Results/$downloadcodedcsvallrespondents`,
          params: {
            positionFilter: queryArg.positionFilter,
            surveyGroupIds: queryArg.surveyGroupIds,
            selectedSurveyConfigIds: queryArg.selectedSurveyConfigIds,
          },
        }),
        providesTags: ['Results'],
      }),
      postProjectsByProjectIdResultsDownloadcrosstabs: build.mutation<
        PostProjectsByProjectIdResultsDownloadcrosstabsApiResponse,
        PostProjectsByProjectIdResultsDownloadcrosstabsApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/Results/$downloadcrosstabs`,
          method: 'POST',
          body: queryArg.crossTabParams,
        }),
        invalidatesTags: ['Results'],
      }),
      postProjectsByProjectIdResultsDownloadscorecardcsv: build.mutation<
        PostProjectsByProjectIdResultsDownloadscorecardcsvApiResponse,
        PostProjectsByProjectIdResultsDownloadscorecardcsvApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/Results/$downloadscorecardcsv`,
          method: 'POST',
          body: queryArg.downloadScorecardParams,
        }),
        invalidatesTags: ['Results'],
      }),
      postProjectsByProjectIdResultsGetcrosstabdata: build.mutation<
        PostProjectsByProjectIdResultsGetcrosstabdataApiResponse,
        PostProjectsByProjectIdResultsGetcrosstabdataApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/Results/$getcrosstabdata`,
          method: 'POST',
          body: queryArg.crossTabParams,
        }),
        invalidatesTags: ['Results'],
      }),
      getProjectsByProjectIdResultsGetcrosstabdata: build.query<
        GetProjectsByProjectIdResultsGetcrosstabdataApiResponse,
        GetProjectsByProjectIdResultsGetcrosstabdataApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/Results/$getcrosstabdata`,
          params: {
            resultContextId: queryArg.resultContextId,
            segmentIds: queryArg.segmentIds,
            surveyGroupIds: queryArg.surveyGroupIds,
            lineItemIds: queryArg.lineItemIds,
            fullCompletesOnly: queryArg.fullCompletesOnly,
            positionFilter: queryArg.positionFilter,
            significanceLevel: queryArg.significanceLevel,
            secondarySignificanceLevel: queryArg.secondarySignificanceLevel,
          },
        }),
        providesTags: ['Results'],
      }),
      postProjectsByProjectIdResultsGetscorecarddata: build.mutation<
        PostProjectsByProjectIdResultsGetscorecarddataApiResponse,
        PostProjectsByProjectIdResultsGetscorecarddataApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/Results/$getscorecarddata`,
          method: 'POST',
          body: queryArg.scorecardParams,
        }),
        invalidatesTags: ['Results'],
      }),
      getProjectsByProjectIdResultsGetscorecarddata: build.query<
        GetProjectsByProjectIdResultsGetscorecarddataApiResponse,
        GetProjectsByProjectIdResultsGetscorecarddataApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/Results/$getscorecarddata`,
          params: {
            ResultContextId: queryArg.resultContextId,
            SegmentIds: queryArg.segmentIds,
            SurveyGroupIds: queryArg.surveyGroupIds,
            FullCompletesOnly: queryArg.fullCompletesOnly,
            PositionFilter: queryArg.positionFilter,
            SignificanceLevel: queryArg.significanceLevel,
            SecondarySignificanceLevel: queryArg.secondarySignificanceLevel,
          },
        }),
        providesTags: ['Results'],
      }),
      postProjectsByProjectIdResultsExploreresults: build.mutation<
        PostProjectsByProjectIdResultsExploreresultsApiResponse,
        PostProjectsByProjectIdResultsExploreresultsApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/Results/$exploreresults`,
          method: 'POST',
          body: queryArg.exploreProjectApiRequest,
        }),
        invalidatesTags: ['Results'],
      }),
      getProjectsByProjectIdResultsExploreresults: build.query<
        GetProjectsByProjectIdResultsExploreresultsApiResponse,
        GetProjectsByProjectIdResultsExploreresultsApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/Results/$exploreresults`,
          params: {
            resultContextId: queryArg.resultContextId,
            segmentIds: queryArg.segmentIds,
            surveyGroupIds: queryArg.surveyGroupIds,
            fullCompletesOnly: queryArg.fullCompletesOnly,
            positionFilter: queryArg.positionFilter,
          },
        }),
        providesTags: ['Results'],
      }),
      postProjectsByProjectIdResultsGetsummary: build.mutation<
        PostProjectsByProjectIdResultsGetsummaryApiResponse,
        PostProjectsByProjectIdResultsGetsummaryApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/Results/$getsummary`,
          method: 'POST',
          body: queryArg.getSummaryProjectApiRequest,
        }),
        invalidatesTags: ['Results'],
      }),
      postProjectsByProjectIdResultsGetbatchsummary: build.mutation<
        PostProjectsByProjectIdResultsGetbatchsummaryApiResponse,
        PostProjectsByProjectIdResultsGetbatchsummaryApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/Results/$getbatchsummary`,
          method: 'POST',
          body: queryArg.getBatchSummaryProjectApiRequest,
        }),
        invalidatesTags: ['Results'],
      }),
      getProjectsByProjectIdResultsPenaltyanalysis: build.query<
        GetProjectsByProjectIdResultsPenaltyanalysisApiResponse,
        GetProjectsByProjectIdResultsPenaltyanalysisApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/Results/penaltyanalysis`,
          params: {
            ResultContextId: queryArg.resultContextId,
            SegmentIds: queryArg.segmentIds,
            SurveyGroupIds: queryArg.surveyGroupIds,
            FullCompletesOnly: queryArg.fullCompletesOnly,
            PositionFilter: queryArg.positionFilter,
            SignificanceLevel: queryArg.significanceLevel,
          },
        }),
        providesTags: ['Results'],
      }),
      postProjectsByProjectIdResultsGetpenaltyanalysis: build.mutation<
        PostProjectsByProjectIdResultsGetpenaltyanalysisApiResponse,
        PostProjectsByProjectIdResultsGetpenaltyanalysisApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/Results/$getpenaltyanalysis`,
          method: 'POST',
          body: queryArg.penaltyParams,
        }),
        invalidatesTags: ['Results'],
      }),
      postProjectsByProjectIdResultsDownloadpenaltyanalysis: build.mutation<
        PostProjectsByProjectIdResultsDownloadpenaltyanalysisApiResponse,
        PostProjectsByProjectIdResultsDownloadpenaltyanalysisApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/Results/$downloadpenaltyanalysis`,
          method: 'POST',
          body: queryArg.penaltyParams,
        }),
        invalidatesTags: ['Results'],
      }),
      postProjectsByProjectIdResultsAlienationanalysis: build.mutation<
        PostProjectsByProjectIdResultsAlienationanalysisApiResponse,
        PostProjectsByProjectIdResultsAlienationanalysisApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/Results/$alienationanalysis`,
          method: 'POST',
          params: {
            resultContextId: queryArg.resultContextId,
            controlSurveyGroupId: queryArg.controlSurveyGroupId,
            testSurveyGroupId: queryArg.testSurveyGroupId,
            segmentIds: queryArg.segmentIds,
            fullCompletesOnly: queryArg.fullCompletesOnly,
            positionFilter: queryArg.positionFilter,
          },
        }),
        invalidatesTags: ['Results'],
      }),
      getProjectsByProjectIdResultsAlienationanalysis: build.query<
        GetProjectsByProjectIdResultsAlienationanalysisApiResponse,
        GetProjectsByProjectIdResultsAlienationanalysisApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/Results/alienationanalysis`,
          params: {
            resultContextId: queryArg.resultContextId,
            controlSurveyGroupId: queryArg.controlSurveyGroupId,
            testSurveyGroupId: queryArg.testSurveyGroupId,
            segmentIds: queryArg.segmentIds,
            fullCompletesOnly: queryArg.fullCompletesOnly,
            positionFilter: queryArg.positionFilter,
          },
        }),
        providesTags: ['Results'],
      }),
      getProjectsByProjectIdResultsDescribe: build.query<
        GetProjectsByProjectIdResultsDescribeApiResponse,
        GetProjectsByProjectIdResultsDescribeApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/Results/$describe`,
          params: {
            resultContextId: queryArg.resultContextId,
          },
        }),
        providesTags: ['Results'],
      }),
      getProjectsByProjectIdResultsmeta: build.query<
        GetProjectsByProjectIdResultsmetaApiResponse,
        GetProjectsByProjectIdResultsmetaApiArg
      >({
        query: (queryArg) => ({ url: `/projects/${queryArg.projectId}/resultsmeta` }),
        providesTags: ['ResultsMeta'],
      }),
      putProjectsByProjectIdResultsmeta: build.mutation<
        PutProjectsByProjectIdResultsmetaApiResponse,
        PutProjectsByProjectIdResultsmetaApiArg
      >({
        query: (queryArg) => ({
          url: `/projects/${queryArg.projectId}/resultsmeta`,
          method: 'PUT',
          body: queryArg.resultsMeta,
        }),
        invalidatesTags: ['ResultsMeta'],
      }),
      getProjectsByProjectIdSegmentsAllowedops: build.query<
        GetProjectsByProjectIdSegmentsAllowedopsApiResponse,
        GetProjectsByProjectIdSegmentsAllowedopsApiArg
      >({
        query: (queryArg) => ({ url: `/projects/${queryArg.projectId}/segments/allowedops` }),
        providesTags: ['Segment'],
      }),
      getProjectsByProjectIdSegments: build.query<
        GetProjectsByProjectIdSegmentsApiResponse,
        GetProjectsByProjectIdSegmentsApiArg
      >({
        query: (queryArg) => ({ url: `/projects/${queryArg.projectId}/segments` }),
        providesTags: ['Segment'],
      }),
      getProjectsByProjectIdSegmentsEnabled: build.query<
        GetProjectsByProjectIdSegmentsEnabledApiResponse,
        GetProjectsByProjectIdSegmentsEnabledApiArg
      >({
        query: (queryArg) => ({ url: `/projects/${queryArg.projectId}/segments/enabled` }),
        providesTags: ['Segment'],
      }),
      getProjectsByProjectIdSegmentsAndSegmentIdCounts: build.query<
        GetProjectsByProjectIdSegmentsAndSegmentIdCountsApiResponse,
        GetProjectsByProjectIdSegmentsAndSegmentIdCountsApiArg
      >({
        query: (queryArg) => ({
          url: `/projects/${queryArg.projectId}/segments/${queryArg.segmentId}/counts`,
        }),
        providesTags: ['Segment'],
      }),
      putProjectsByProjectIdSegmentsUpsert: build.mutation<
        PutProjectsByProjectIdSegmentsUpsertApiResponse,
        PutProjectsByProjectIdSegmentsUpsertApiArg
      >({
        query: (queryArg) => ({
          url: `/projects/${queryArg.projectId}/segments/$upsert`,
          method: 'PUT',
          body: queryArg.segment,
        }),
        invalidatesTags: ['Segment'],
      }),
      postProjectsByProjectIdSegmentsBackfillDefaultSegments: build.mutation<
        PostProjectsByProjectIdSegmentsBackfillDefaultSegmentsApiResponse,
        PostProjectsByProjectIdSegmentsBackfillDefaultSegmentsApiArg
      >({
        query: (queryArg) => ({
          url: `/projects/${queryArg.projectId}/segments/$backfillDefaultSegments`,
          method: 'POST',
        }),
        invalidatesTags: ['Segment'],
      }),
      deleteProjectsByProjectIdSegmentsAndId: build.mutation<
        DeleteProjectsByProjectIdSegmentsAndIdApiResponse,
        DeleteProjectsByProjectIdSegmentsAndIdApiArg
      >({
        query: (queryArg) => ({
          url: `/projects/${queryArg.projectId}/segments/${queryArg.id}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['Segment'],
      }),
      postProjectsByProjectIdShareLinks: build.mutation<
        PostProjectsByProjectIdShareLinksApiResponse,
        PostProjectsByProjectIdShareLinksApiArg
      >({
        query: (queryArg) => ({
          url: `/projects/${queryArg.projectId}/ShareLinks`,
          method: 'POST',
        }),
        invalidatesTags: ['ShareLinks'],
      }),
      getProjectsByProjectIdShareLinks: build.query<
        GetProjectsByProjectIdShareLinksApiResponse,
        GetProjectsByProjectIdShareLinksApiArg
      >({
        query: (queryArg) => ({ url: `/projects/${queryArg.projectId}/ShareLinks` }),
        providesTags: ['ShareLinks'],
      }),
      deleteProjectsByProjectIdShareLinks: build.mutation<
        DeleteProjectsByProjectIdShareLinksApiResponse,
        DeleteProjectsByProjectIdShareLinksApiArg
      >({
        query: (queryArg) => ({
          url: `/projects/${queryArg.projectId}/ShareLinks`,
          method: 'DELETE',
        }),
        invalidatesTags: ['ShareLinks'],
      }),
      getShareLinksByPublicId: build.query<
        GetShareLinksByPublicIdApiResponse,
        GetShareLinksByPublicIdApiArg
      >({
        query: (queryArg) => ({ url: `/ShareLinks/${queryArg.publicId}` }),
        providesTags: ['ShareLinks'],
      }),
      patchShareLinksById: build.mutation<
        PatchShareLinksByIdApiResponse,
        PatchShareLinksByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/ShareLinks/${queryArg.id}`,
          method: 'PATCH',
          body: queryArg.patchShareLinkRequest,
        }),
        invalidatesTags: ['ShareLinks'],
      }),
      postShipments: build.mutation<PostShipmentsApiResponse, PostShipmentsApiArg>({
        query: (queryArg) => ({ url: `/Shipments`, method: 'POST', body: queryArg.shipment }),
        invalidatesTags: ['Shipments'],
      }),
      putShipments: build.mutation<PutShipmentsApiResponse, PutShipmentsApiArg>({
        query: (queryArg) => ({ url: `/Shipments`, method: 'PUT', body: queryArg.shipment }),
        invalidatesTags: ['Shipments'],
      }),
      postShipmentsByShipmentIdDeliveryConfirmation: build.mutation<
        PostShipmentsByShipmentIdDeliveryConfirmationApiResponse,
        PostShipmentsByShipmentIdDeliveryConfirmationApiArg
      >({
        query: (queryArg) => ({
          url: `/Shipments/${queryArg.shipmentId}/DeliveryConfirmation`,
          method: 'POST',
          body: queryArg.deliveryConfirmationRequest,
        }),
        invalidatesTags: ['Shipments'],
      }),
      postShipmentsByShipmentIdAssets: build.mutation<
        PostShipmentsByShipmentIdAssetsApiResponse,
        PostShipmentsByShipmentIdAssetsApiArg
      >({
        query: (queryArg) => ({
          url: `/Shipments/${queryArg.shipmentId}/Assets`,
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['Shipments'],
      }),
      getShipmentsByShipmentIdAssets: build.query<
        GetShipmentsByShipmentIdAssetsApiResponse,
        GetShipmentsByShipmentIdAssetsApiArg
      >({
        query: (queryArg) => ({ url: `/Shipments/${queryArg.shipmentId}/Assets` }),
        providesTags: ['Shipments'],
      }),
      deleteShipmentsByShipmentIdAssetsAndShipmentAssetId: build.mutation<
        DeleteShipmentsByShipmentIdAssetsAndShipmentAssetIdApiResponse,
        DeleteShipmentsByShipmentIdAssetsAndShipmentAssetIdApiArg
      >({
        query: (queryArg) => ({
          url: `/Shipments/${queryArg.shipmentId}/Assets/${queryArg.shipmentAssetId}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['Shipments'],
      }),
      getShowlogicsAllowedops: build.query<
        GetShowlogicsAllowedopsApiResponse,
        GetShowlogicsAllowedopsApiArg
      >({
        query: () => ({ url: `/showlogics/allowedops` }),
        providesTags: ['ShowLogics'],
      }),
      getSurveyconfigsBySurveyConfigIdShowlogics: build.query<
        GetSurveyconfigsBySurveyConfigIdShowlogicsApiResponse,
        GetSurveyconfigsBySurveyConfigIdShowlogicsApiArg
      >({
        query: (queryArg) => ({ url: `/surveyconfigs/${queryArg.surveyConfigId}/showlogics` }),
        providesTags: ['ShowLogics'],
      }),
      getSurveyconfigsBySurveyConfigIdShowlogicsAndId: build.query<
        GetSurveyconfigsBySurveyConfigIdShowlogicsAndIdApiResponse,
        GetSurveyconfigsBySurveyConfigIdShowlogicsAndIdApiArg
      >({
        query: (queryArg) => ({
          url: `/surveyconfigs/${queryArg.surveyConfigId}/showlogics/${queryArg.id}`,
        }),
        providesTags: ['ShowLogics'],
      }),
      putSurveyconfigsBySurveyConfigIdShowlogicsAndId: build.mutation<
        PutSurveyconfigsBySurveyConfigIdShowlogicsAndIdApiResponse,
        PutSurveyconfigsBySurveyConfigIdShowlogicsAndIdApiArg
      >({
        query: (queryArg) => ({
          url: `/surveyconfigs/${queryArg.surveyConfigId}/showlogics/${queryArg.id}`,
          method: 'PUT',
          body: queryArg.showLogic,
        }),
        invalidatesTags: ['ShowLogics'],
      }),
      deleteSurveyconfigsBySurveyConfigIdShowlogicsAndId: build.mutation<
        DeleteSurveyconfigsBySurveyConfigIdShowlogicsAndIdApiResponse,
        DeleteSurveyconfigsBySurveyConfigIdShowlogicsAndIdApiArg
      >({
        query: (queryArg) => ({
          url: `/surveyconfigs/${queryArg.surveyConfigId}/showlogics/${queryArg.id}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['ShowLogics'],
      }),
      getSurveyconfigsBySurveyConfigIdShowlogicsValidation: build.query<
        GetSurveyconfigsBySurveyConfigIdShowlogicsValidationApiResponse,
        GetSurveyconfigsBySurveyConfigIdShowlogicsValidationApiArg
      >({
        query: (queryArg) => ({
          url: `/surveyconfigs/${queryArg.surveyConfigId}/showlogics/$validation`,
        }),
        providesTags: ['ShowLogics'],
      }),
      postProjectsByProjectIdSurveyConfigBlocksAndSurveyConfigBlockIdSlotValuesV2: build.mutation<
        PostProjectsByProjectIdSurveyConfigBlocksAndSurveyConfigBlockIdSlotValuesV2ApiResponse,
        PostProjectsByProjectIdSurveyConfigBlocksAndSurveyConfigBlockIdSlotValuesV2ApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/SurveyConfigBlocks/${queryArg.surveyConfigBlockId}/SlotValues/v2`,
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['SlotValues'],
      }),
      postProjectsByProjectIdSurveyConfigBlocksAndSurveyConfigBlockIdSlotValuesBulkAssign:
        build.mutation<
          PostProjectsByProjectIdSurveyConfigBlocksAndSurveyConfigBlockIdSlotValuesBulkAssignApiResponse,
          PostProjectsByProjectIdSurveyConfigBlocksAndSurveyConfigBlockIdSlotValuesBulkAssignApiArg
        >({
          query: (queryArg) => ({
            url: `/Projects/${queryArg.projectId}/SurveyConfigBlocks/${queryArg.surveyConfigBlockId}/SlotValues/$bulkAssign`,
            method: 'POST',
            body: queryArg.body,
          }),
          invalidatesTags: ['SlotValues'],
        }),
      postProjectsByProjectIdSurveyConfigsAndSurveyConfigIdSlotValues: build.mutation<
        PostProjectsByProjectIdSurveyConfigsAndSurveyConfigIdSlotValuesApiResponse,
        PostProjectsByProjectIdSurveyConfigsAndSurveyConfigIdSlotValuesApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/SurveyConfigs/${queryArg.surveyConfigId}/SlotValues`,
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['SlotValues'],
      }),
      deleteProjectsByProjectIdSurveyConfigBlocksAndSurveyConfigBlockIdSlotValuesSlotValueId:
        build.mutation<
          DeleteProjectsByProjectIdSurveyConfigBlocksAndSurveyConfigBlockIdSlotValuesSlotValueIdApiResponse,
          DeleteProjectsByProjectIdSurveyConfigBlocksAndSurveyConfigBlockIdSlotValuesSlotValueIdApiArg
        >({
          query: (queryArg) => ({
            url: `/Projects/${queryArg.projectId}/SurveyConfigBlocks/${queryArg.surveyConfigBlockId}/SlotValues/${queryArg.slotValueId}`,
            method: 'DELETE',
          }),
          invalidatesTags: ['SlotValues'],
        }),
      postSolutions: build.mutation<PostSolutionsApiResponse, PostSolutionsApiArg>({
        query: (queryArg) => ({ url: `/Solutions`, method: 'POST', body: queryArg.solution }),
        invalidatesTags: ['Solutions'],
      }),
      getSolutions: build.query<GetSolutionsApiResponse, GetSolutionsApiArg>({
        query: (queryArg) => ({
          url: `/Solutions`,
          params: {
            hasTrialSurveys: queryArg.hasTrialSurveys,
            experienceId: queryArg.experienceId,
          },
        }),
        providesTags: ['Solutions'],
      }),
      getProjectsByProjectIdSolutions: build.query<
        GetProjectsByProjectIdSolutionsApiResponse,
        GetProjectsByProjectIdSolutionsApiArg
      >({
        query: (queryArg) => ({ url: `/projects/${queryArg.projectId}/solutions` }),
        providesTags: ['Solutions'],
      }),
      patchSolutionsBySolutionId: build.mutation<
        PatchSolutionsBySolutionIdApiResponse,
        PatchSolutionsBySolutionIdApiArg
      >({
        query: (queryArg) => ({
          url: `/Solutions/${queryArg.solutionId}`,
          method: 'PATCH',
          body: queryArg.updateSolutionRequest,
        }),
        invalidatesTags: ['Solutions'],
      }),
      getSolutionsBySolutionIdOrgAndOrgIdCount: build.query<
        GetSolutionsBySolutionIdOrgAndOrgIdCountApiResponse,
        GetSolutionsBySolutionIdOrgAndOrgIdCountApiArg
      >({
        query: (queryArg) => ({
          url: `/Solutions/${queryArg.solutionId}/org/${queryArg.orgId}/count`,
        }),
        providesTags: ['Solutions'],
      }),
      getSolutionsBySolutionIdCount: build.query<
        GetSolutionsBySolutionIdCountApiResponse,
        GetSolutionsBySolutionIdCountApiArg
      >({
        query: (queryArg) => ({
          url: `/Solutions/${queryArg.solutionId}/count`,
          params: {
            includeHighlightOrgProjects: queryArg.includeHighlightOrgProjects,
          },
        }),
        providesTags: ['Solutions'],
      }),
      getSolutionsUseCases: build.query<
        GetSolutionsUseCasesApiResponse,
        GetSolutionsUseCasesApiArg
      >({
        query: () => ({ url: `/Solutions/use-cases` }),
        providesTags: ['Solutions'],
      }),
      getSolutionsBySolutionIdSurveyDesigns: build.query<
        GetSolutionsBySolutionIdSurveyDesignsApiResponse,
        GetSolutionsBySolutionIdSurveyDesignsApiArg
      >({
        query: (queryArg) => ({ url: `/Solutions/${queryArg.solutionId}/SurveyDesigns` }),
        providesTags: ['SolutionSurveyDesigns'],
      }),
      postSolutionsBySolutionIdSurveyDesignsAssign: build.mutation<
        PostSolutionsBySolutionIdSurveyDesignsAssignApiResponse,
        PostSolutionsBySolutionIdSurveyDesignsAssignApiArg
      >({
        query: (queryArg) => ({
          url: `/Solutions/${queryArg.solutionId}/SurveyDesigns/$assign`,
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['SolutionSurveyDesigns'],
      }),
      postFieldingGroupsByFieldingGroupIdSteps: build.mutation<
        PostFieldingGroupsByFieldingGroupIdStepsApiResponse,
        PostFieldingGroupsByFieldingGroupIdStepsApiArg
      >({
        query: (queryArg) => ({
          url: `/FieldingGroups/${queryArg.fieldingGroupId}/Steps`,
          method: 'POST',
          body: queryArg.stepBase,
        }),
        invalidatesTags: ['Steps'],
      }),
      getFieldingGroupsByFieldingGroupIdSteps: build.query<
        GetFieldingGroupsByFieldingGroupIdStepsApiResponse,
        GetFieldingGroupsByFieldingGroupIdStepsApiArg
      >({
        query: (queryArg) => ({ url: `/FieldingGroups/${queryArg.fieldingGroupId}/Steps` }),
        providesTags: ['Steps'],
      }),
      patchFieldingGroupsByFieldingGroupIdStepsAndStepId: build.mutation<
        PatchFieldingGroupsByFieldingGroupIdStepsAndStepIdApiResponse,
        PatchFieldingGroupsByFieldingGroupIdStepsAndStepIdApiArg
      >({
        query: (queryArg) => ({
          url: `/FieldingGroups/${queryArg.fieldingGroupId}/Steps/${queryArg.stepId}`,
          method: 'PATCH',
          body: queryArg.stepBase,
        }),
        invalidatesTags: ['Steps'],
      }),
      deleteFieldingGroupsByFieldingGroupIdStepsAndStepId: build.mutation<
        DeleteFieldingGroupsByFieldingGroupIdStepsAndStepIdApiResponse,
        DeleteFieldingGroupsByFieldingGroupIdStepsAndStepIdApiArg
      >({
        query: (queryArg) => ({
          url: `/FieldingGroups/${queryArg.fieldingGroupId}/Steps/${queryArg.stepId}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['Steps'],
      }),
      patchFieldingGroupsByFieldingGroupIdStepsUpdateOrdinals: build.mutation<
        PatchFieldingGroupsByFieldingGroupIdStepsUpdateOrdinalsApiResponse,
        PatchFieldingGroupsByFieldingGroupIdStepsUpdateOrdinalsApiArg
      >({
        query: (queryArg) => ({
          url: `/FieldingGroups/${queryArg.fieldingGroupId}/Steps/$updateOrdinals`,
          method: 'PATCH',
          body: queryArg.body,
        }),
        invalidatesTags: ['Steps'],
      }),
      postFieldingGroupsByFieldingGroupIdStepsGroup: build.mutation<
        PostFieldingGroupsByFieldingGroupIdStepsGroupApiResponse,
        PostFieldingGroupsByFieldingGroupIdStepsGroupApiArg
      >({
        query: (queryArg) => ({
          url: `/FieldingGroups/${queryArg.fieldingGroupId}/Steps/$group`,
          method: 'POST',
          body: queryArg.createGroupRequest,
        }),
        invalidatesTags: ['Steps'],
      }),
      getProjectsByProjectIdSurveyBundles: build.query<
        GetProjectsByProjectIdSurveyBundlesApiResponse,
        GetProjectsByProjectIdSurveyBundlesApiArg
      >({
        query: (queryArg) => ({ url: `/Projects/${queryArg.projectId}/SurveyBundles` }),
        providesTags: ['SurveyBundles'],
      }),
      postProjectsByProjectIdSurveyBundles: build.mutation<
        PostProjectsByProjectIdSurveyBundlesApiResponse,
        PostProjectsByProjectIdSurveyBundlesApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/SurveyBundles`,
          method: 'POST',
          body: queryArg.surveyBundle,
        }),
        invalidatesTags: ['SurveyBundles'],
      }),
      putProjectsByProjectIdSurveyBundlesAndSurveyBundleId: build.mutation<
        PutProjectsByProjectIdSurveyBundlesAndSurveyBundleIdApiResponse,
        PutProjectsByProjectIdSurveyBundlesAndSurveyBundleIdApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/SurveyBundles/${queryArg.surveyBundleId}`,
          method: 'PUT',
          body: queryArg.surveyBundle,
        }),
        invalidatesTags: ['SurveyBundles'],
      }),
      getSurveyConfigBlockGroups: build.query<
        GetSurveyConfigBlockGroupsApiResponse,
        GetSurveyConfigBlockGroupsApiArg
      >({
        query: (queryArg) => ({
          url: `/SurveyConfigBlockGroups`,
          params: {
            surveyConfigId: queryArg.surveyConfigId,
          },
        }),
        providesTags: ['SurveyConfigBlockGroups'],
      }),
      postSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsCreateAndReorder: build.mutation<
        PostSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsCreateAndReorderApiResponse,
        PostSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsCreateAndReorderApiArg
      >({
        query: (queryArg) => ({
          url: `/surveyConfigs/${queryArg.surveyConfigId}/surveyConfigBlockGroups/$createAndReorder`,
          method: 'POST',
          body: queryArg.surveyConfigBlockGroup,
        }),
        invalidatesTags: ['SurveyConfigBlockGroups'],
      }),
      postSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsCreateMatrixGroup: build.mutation<
        PostSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsCreateMatrixGroupApiResponse,
        PostSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsCreateMatrixGroupApiArg
      >({
        query: (queryArg) => ({
          url: `/surveyConfigs/${queryArg.surveyConfigId}/surveyConfigBlockGroups/$createMatrixGroup`,
          method: 'POST',
          body: queryArg.matrixBlockRequest,
        }),
        invalidatesTags: ['SurveyConfigBlockGroups'],
      }),
      postSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdAddMatrixBlock:
        build.mutation<
          PostSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdAddMatrixBlockApiResponse,
          PostSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdAddMatrixBlockApiArg
        >({
          query: (queryArg) => ({
            url: `/surveyConfigs/${queryArg.surveyConfigId}/surveyConfigBlockGroups/${queryArg.surveyConfigBlockGroupId}/$addMatrixBlock`,
            method: 'POST',
            body: queryArg.addMatrixBlockRequest,
          }),
          invalidatesTags: ['SurveyConfigBlockGroups'],
        }),
      postSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdPreview:
        build.mutation<
          PostSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdPreviewApiResponse,
          PostSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdPreviewApiArg
        >({
          query: (queryArg) => ({
            url: `/surveyConfigs/${queryArg.surveyConfigId}/surveyConfigBlockGroups/${queryArg.surveyConfigBlockGroupId}/$preview`,
            method: 'POST',
          }),
          invalidatesTags: ['SurveyConfigBlockGroups'],
        }),
      deleteSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupId:
        build.mutation<
          DeleteSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdApiResponse,
          DeleteSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdApiArg
        >({
          query: (queryArg) => ({
            url: `/surveyConfigs/${queryArg.surveyConfigId}/surveyConfigBlockGroups/${queryArg.surveyConfigBlockGroupId}`,
            method: 'DELETE',
          }),
          invalidatesTags: ['SurveyConfigBlockGroups'],
        }),
      patchSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdName:
        build.mutation<
          PatchSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdNameApiResponse,
          PatchSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdNameApiArg
        >({
          query: (queryArg) => ({
            url: `/surveyConfigs/${queryArg.surveyConfigId}/surveyConfigBlockGroups/${queryArg.surveyConfigBlockGroupId}/name`,
            method: 'PATCH',
            body: queryArg.updateNameRequest,
          }),
          invalidatesTags: ['SurveyConfigBlockGroups'],
        }),
      patchSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdAreQuestionsRequired:
        build.mutation<
          PatchSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdAreQuestionsRequiredApiResponse,
          PatchSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdAreQuestionsRequiredApiArg
        >({
          query: (queryArg) => ({
            url: `/surveyConfigs/${queryArg.surveyConfigId}/surveyConfigBlockGroups/${queryArg.surveyConfigBlockGroupId}/areQuestionsRequired`,
            method: 'PATCH',
            body: queryArg.updateAreQuestionsRequiredRequest,
          }),
          invalidatesTags: ['SurveyConfigBlockGroups'],
        }),
      patchSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdBehaviors:
        build.mutation<
          PatchSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdBehaviorsApiResponse,
          PatchSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdBehaviorsApiArg
        >({
          query: (queryArg) => ({
            url: `/surveyConfigs/${queryArg.surveyConfigId}/surveyConfigBlockGroups/${queryArg.surveyConfigBlockGroupId}/behaviors`,
            method: 'PATCH',
            body: queryArg.body,
          }),
          invalidatesTags: ['SurveyConfigBlockGroups'],
        }),
      patchSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdBlockIds:
        build.mutation<
          PatchSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdBlockIdsApiResponse,
          PatchSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdBlockIdsApiArg
        >({
          query: (queryArg) => ({
            url: `/surveyConfigs/${queryArg.surveyConfigId}/surveyConfigBlockGroups/${queryArg.surveyConfigBlockGroupId}/blockIds`,
            method: 'PATCH',
            body: queryArg.body,
          }),
          invalidatesTags: ['SurveyConfigBlockGroups'],
        }),
      postSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdClone:
        build.mutation<
          PostSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdCloneApiResponse,
          PostSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdCloneApiArg
        >({
          query: (queryArg) => ({
            url: `/surveyConfigs/${queryArg.surveyConfigId}/surveyConfigBlockGroups/${queryArg.surveyConfigBlockGroupId}/$clone`,
            method: 'POST',
          }),
          invalidatesTags: ['SurveyConfigBlockGroups'],
        }),
      getProjectsByProjectIdSurveyConfigsAndSurveyConfigIdBlocks: build.query<
        GetProjectsByProjectIdSurveyConfigsAndSurveyConfigIdBlocksApiResponse,
        GetProjectsByProjectIdSurveyConfigsAndSurveyConfigIdBlocksApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/SurveyConfigs/${queryArg.surveyConfigId}/Blocks`,
        }),
        providesTags: ['SurveyConfigBlocks'],
      }),
      putProjectsByProjectIdSurveyConfigsAndSurveyConfigIdBlocks: build.mutation<
        PutProjectsByProjectIdSurveyConfigsAndSurveyConfigIdBlocksApiResponse,
        PutProjectsByProjectIdSurveyConfigsAndSurveyConfigIdBlocksApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/SurveyConfigs/${queryArg.surveyConfigId}/Blocks`,
          method: 'PUT',
          body: queryArg.body,
        }),
        invalidatesTags: ['SurveyConfigBlocks'],
      }),
      putProjectsByProjectIdSurveyConfigsAndSurveyConfigIdBlocksSurveyConfigBlockId: build.mutation<
        PutProjectsByProjectIdSurveyConfigsAndSurveyConfigIdBlocksSurveyConfigBlockIdApiResponse,
        PutProjectsByProjectIdSurveyConfigsAndSurveyConfigIdBlocksSurveyConfigBlockIdApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/SurveyConfigs/${queryArg.surveyConfigId}/Blocks/${queryArg.surveyConfigBlockId}`,
          method: 'PUT',
          body: queryArg.surveyConfigBlock,
        }),
        invalidatesTags: ['SurveyConfigBlocks'],
      }),
      postProjectsByProjectIdSurveyConfigsAndSurveyConfigIdBlocksAssign: build.mutation<
        PostProjectsByProjectIdSurveyConfigsAndSurveyConfigIdBlocksAssignApiResponse,
        PostProjectsByProjectIdSurveyConfigsAndSurveyConfigIdBlocksAssignApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/SurveyConfigs/${queryArg.surveyConfigId}/Blocks/$assign`,
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['SurveyConfigBlocks'],
      }),
      postProjectsByProjectIdSurveyConfigsAndSurveyConfigIdBlocksSurveyConfigBlockIdCustomize:
        build.mutation<
          PostProjectsByProjectIdSurveyConfigsAndSurveyConfigIdBlocksSurveyConfigBlockIdCustomizeApiResponse,
          PostProjectsByProjectIdSurveyConfigsAndSurveyConfigIdBlocksSurveyConfigBlockIdCustomizeApiArg
        >({
          query: (queryArg) => ({
            url: `/Projects/${queryArg.projectId}/SurveyConfigs/${queryArg.surveyConfigId}/Blocks/${queryArg.surveyConfigBlockId}/$customize`,
            method: 'POST',
            body: queryArg.customizeSurveyConfigBlockRequest,
          }),
          invalidatesTags: ['SurveyConfigBlocks'],
        }),
      postProjectsByProjectIdSurveyConfigsAndSurveyConfigIdBlocksSurveyConfigBlockIdPreview:
        build.mutation<
          PostProjectsByProjectIdSurveyConfigsAndSurveyConfigIdBlocksSurveyConfigBlockIdPreviewApiResponse,
          PostProjectsByProjectIdSurveyConfigsAndSurveyConfigIdBlocksSurveyConfigBlockIdPreviewApiArg
        >({
          query: (queryArg) => ({
            url: `/Projects/${queryArg.projectId}/SurveyConfigs/${queryArg.surveyConfigId}/Blocks/${queryArg.surveyConfigBlockId}/$preview`,
            method: 'POST',
          }),
          invalidatesTags: ['SurveyConfigBlocks'],
        }),
      postSurveyConfigsBySurveyConfigIdBlocksAndSurveyConfigBlockIdClone: build.mutation<
        PostSurveyConfigsBySurveyConfigIdBlocksAndSurveyConfigBlockIdCloneApiResponse,
        PostSurveyConfigsBySurveyConfigIdBlocksAndSurveyConfigBlockIdCloneApiArg
      >({
        query: (queryArg) => ({
          url: `/SurveyConfigs/${queryArg.surveyConfigId}/Blocks/${queryArg.surveyConfigBlockId}/$clone`,
          method: 'POST',
        }),
        invalidatesTags: ['SurveyConfigBlocks'],
      }),
      patchProjectsByProjectIdSurveyConfigsAndSurveyConfigIdBlocksOrdinals: build.mutation<
        PatchProjectsByProjectIdSurveyConfigsAndSurveyConfigIdBlocksOrdinalsApiResponse,
        PatchProjectsByProjectIdSurveyConfigsAndSurveyConfigIdBlocksOrdinalsApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/SurveyConfigs/${queryArg.surveyConfigId}/Blocks/ordinals`,
          method: 'PATCH',
          body: queryArg.body,
        }),
        invalidatesTags: ['SurveyConfigBlocks'],
      }),
      postProjectsByProjectIdSurveyConfigsAndSurveyConfigIdQuestionsSurveyConfigQuestionIdChoicesSurveyConfigQuestionChoiceId:
        build.mutation<
          PostProjectsByProjectIdSurveyConfigsAndSurveyConfigIdQuestionsSurveyConfigQuestionIdChoicesSurveyConfigQuestionChoiceIdApiResponse,
          PostProjectsByProjectIdSurveyConfigsAndSurveyConfigIdQuestionsSurveyConfigQuestionIdChoicesSurveyConfigQuestionChoiceIdApiArg
        >({
          query: (queryArg) => ({
            url: `/Projects/${queryArg.projectId}/SurveyConfigs/${queryArg.surveyConfigId}/Questions/${queryArg.surveyConfigQuestionId}/Choices/${queryArg.surveyConfigQuestionChoiceId}`,
            method: 'POST',
            body: queryArg.body,
          }),
          invalidatesTags: ['SurveyConfigQuestionChoices'],
        }),
      getProjectsByProjectIdSurveyConfigsAndSurveyConfigIdQuestionsSurveyConfigQuestionIdRoutings:
        build.query<
          GetProjectsByProjectIdSurveyConfigsAndSurveyConfigIdQuestionsSurveyConfigQuestionIdRoutingsApiResponse,
          GetProjectsByProjectIdSurveyConfigsAndSurveyConfigIdQuestionsSurveyConfigQuestionIdRoutingsApiArg
        >({
          query: (queryArg) => ({
            url: `/Projects/${queryArg.projectId}/SurveyConfigs/${queryArg.surveyConfigId}/Questions/${queryArg.surveyConfigQuestionId}/Routings`,
          }),
          providesTags: ['SurveyConfigRouting'],
        }),
      getProjectsByProjectIdSurveyConfigsAndSurveyConfigIdRoutings: build.query<
        GetProjectsByProjectIdSurveyConfigsAndSurveyConfigIdRoutingsApiResponse,
        GetProjectsByProjectIdSurveyConfigsAndSurveyConfigIdRoutingsApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/SurveyConfigs/${queryArg.surveyConfigId}/Routings`,
        }),
        providesTags: ['SurveyConfigRouting'],
      }),
      getProjectsByProjectIdSurveyConfigs: build.query<
        GetProjectsByProjectIdSurveyConfigsApiResponse,
        GetProjectsByProjectIdSurveyConfigsApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/SurveyConfigs`,
          params: {
            surveyType: queryArg.surveyType,
          },
        }),
        providesTags: ['SurveyConfigs'],
      }),
      getSurveyConfigs: build.query<GetSurveyConfigsApiResponse, GetSurveyConfigsApiArg>({
        query: (queryArg) => ({
          url: `/SurveyConfigs`,
          params: {
            surveyType: queryArg.surveyType,
            projectType: queryArg.projectType,
            teamId: queryArg.teamId,
          },
        }),
        providesTags: ['SurveyConfigs'],
      }),
      postProjectsByProjectIdSurveyConfigsConfigure: build.mutation<
        PostProjectsByProjectIdSurveyConfigsConfigureApiResponse,
        PostProjectsByProjectIdSurveyConfigsConfigureApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/SurveyConfigs/$configure`,
          method: 'POST',
          body: queryArg.configureSurveyByTypeRequest,
        }),
        invalidatesTags: ['SurveyConfigs'],
      }),
      postProjectsByProjectIdSurveyConfigsConfigurescreenerv2: build.mutation<
        PostProjectsByProjectIdSurveyConfigsConfigurescreenerv2ApiResponse,
        PostProjectsByProjectIdSurveyConfigsConfigurescreenerv2ApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/SurveyConfigs/$configurescreenerv2`,
          method: 'POST',
          body: queryArg.configureScreenerSurveyV2Request,
        }),
        invalidatesTags: ['SurveyConfigs'],
      }),
      postProjectsByProjectIdSurveyConfigsAndSurveyConfigIdMaterialize: build.mutation<
        PostProjectsByProjectIdSurveyConfigsAndSurveyConfigIdMaterializeApiResponse,
        PostProjectsByProjectIdSurveyConfigsAndSurveyConfigIdMaterializeApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/SurveyConfigs/${queryArg.surveyConfigId}/$materialize`,
          method: 'POST',
          body: queryArg.materializeSurveyRequest,
        }),
        invalidatesTags: ['SurveyConfigs'],
      }),
      postProjectsByProjectIdSurveyConfigsAndSurveyConfigIdPreview: build.mutation<
        PostProjectsByProjectIdSurveyConfigsAndSurveyConfigIdPreviewApiResponse,
        PostProjectsByProjectIdSurveyConfigsAndSurveyConfigIdPreviewApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/SurveyConfigs/${queryArg.surveyConfigId}/$preview`,
          method: 'POST',
          body: queryArg.materializeSurveyRequest,
        }),
        invalidatesTags: ['SurveyConfigs'],
      }),
      postProjectsByProjectIdSurveyConfigsCopySurveyContent: build.mutation<
        PostProjectsByProjectIdSurveyConfigsCopySurveyContentApiResponse,
        PostProjectsByProjectIdSurveyConfigsCopySurveyContentApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/SurveyConfigs/$copySurveyContent`,
          method: 'POST',
          body: queryArg.surveyConfigContentCopyRequest,
        }),
        invalidatesTags: ['SurveyConfigs'],
      }),
      putProjectsByProjectIdSurveyConfigsAndSurveyConfigId: build.mutation<
        PutProjectsByProjectIdSurveyConfigsAndSurveyConfigIdApiResponse,
        PutProjectsByProjectIdSurveyConfigsAndSurveyConfigIdApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/SurveyConfigs/${queryArg.surveyConfigId}`,
          method: 'PUT',
          body: queryArg.surveyConfig,
        }),
        invalidatesTags: ['SurveyConfigs'],
      }),
      getProjectsByProjectIdFileAnswers: build.query<
        GetProjectsByProjectIdFileAnswersApiResponse,
        GetProjectsByProjectIdFileAnswersApiArg
      >({
        query: (queryArg) => ({ url: `/Projects/${queryArg.projectId}/FileAnswers` }),
        providesTags: ['SurveyFileAnswers'],
      }),
      postProjectsByProjectIdFileAnswers: build.mutation<
        PostProjectsByProjectIdFileAnswersApiResponse,
        PostProjectsByProjectIdFileAnswersApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/FileAnswers`,
          method: 'POST',
          body: queryArg.createFileAnswerZipRequest,
        }),
        invalidatesTags: ['SurveyFileAnswers'],
      }),
      getProjectsByProjectIdSurveyGroups: build.query<
        GetProjectsByProjectIdSurveyGroupsApiResponse,
        GetProjectsByProjectIdSurveyGroupsApiArg
      >({
        query: (queryArg) => ({ url: `/Projects/${queryArg.projectId}/SurveyGroups` }),
        providesTags: ['SurveyGroups'],
      }),
      putProjectsByProjectIdSurveyGroups: build.mutation<
        PutProjectsByProjectIdSurveyGroupsApiResponse,
        PutProjectsByProjectIdSurveyGroupsApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/SurveyGroups`,
          method: 'PUT',
          body: queryArg.body,
        }),
        invalidatesTags: ['SurveyGroups'],
      }),
      getProjectsByProjectIdSurveyGroupsEnabled: build.query<
        GetProjectsByProjectIdSurveyGroupsEnabledApiResponse,
        GetProjectsByProjectIdSurveyGroupsEnabledApiArg
      >({
        query: (queryArg) => ({ url: `/Projects/${queryArg.projectId}/SurveyGroups/enabled` }),
        providesTags: ['SurveyGroups'],
      }),
      getProjectsByProjectIdSurveyGroupsSeparable: build.query<
        GetProjectsByProjectIdSurveyGroupsSeparableApiResponse,
        GetProjectsByProjectIdSurveyGroupsSeparableApiArg
      >({
        query: (queryArg) => ({ url: `/Projects/${queryArg.projectId}/SurveyGroups/separable` }),
        providesTags: ['SurveyGroups'],
      }),
      getProjectsByProjectIdSurveyGroupsProductGroups: build.query<
        GetProjectsByProjectIdSurveyGroupsProductGroupsApiResponse,
        GetProjectsByProjectIdSurveyGroupsProductGroupsApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/SurveyGroups/productGroups`,
        }),
        providesTags: ['SurveyGroups'],
      }),
      putProjectsByProjectIdSurveyGroupsProductGroups: build.mutation<
        PutProjectsByProjectIdSurveyGroupsProductGroupsApiResponse,
        PutProjectsByProjectIdSurveyGroupsProductGroupsApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/SurveyGroups/productGroups`,
          method: 'PUT',
          body: queryArg.productGroupDto,
        }),
        invalidatesTags: ['SurveyGroups'],
      }),
      deleteProjectsByProjectIdSurveyGroupsProductGroupsAndProductGroupId: build.mutation<
        DeleteProjectsByProjectIdSurveyGroupsProductGroupsAndProductGroupIdApiResponse,
        DeleteProjectsByProjectIdSurveyGroupsProductGroupsAndProductGroupIdApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/SurveyGroups/productGroups/${queryArg.productGroupId}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['SurveyGroups'],
      }),
      patchProjectsByProjectIdSurveyGroupsAndSurveyGroupIdColor: build.mutation<
        PatchProjectsByProjectIdSurveyGroupsAndSurveyGroupIdColorApiResponse,
        PatchProjectsByProjectIdSurveyGroupsAndSurveyGroupIdColorApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/SurveyGroups/${queryArg.surveyGroupId}/color`,
          method: 'PATCH',
          body: queryArg.setSurveyGroupColorRequest,
        }),
        invalidatesTags: ['SurveyGroups'],
      }),
      getProjectsByProjectIdSurveyGroupsProjectIndexLegend: build.query<
        GetProjectsByProjectIdSurveyGroupsProjectIndexLegendApiResponse,
        GetProjectsByProjectIdSurveyGroupsProjectIndexLegendApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/SurveyGroups/projectIndexLegend`,
        }),
        providesTags: ['SurveyGroups'],
      }),
      getProjectsByProjectIdSurveyQuestionsProfilequestions: build.query<
        GetProjectsByProjectIdSurveyQuestionsProfilequestionsApiResponse,
        GetProjectsByProjectIdSurveyQuestionsProfilequestionsApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/SurveyQuestions/profilequestions`,
          params: {
            visibleOnly: queryArg.visibleOnly,
          },
        }),
        providesTags: ['SurveyQuestions'],
      }),
      getProjectsByProjectIdSurveyQuestionsResponsetags: build.query<
        GetProjectsByProjectIdSurveyQuestionsResponsetagsApiResponse,
        GetProjectsByProjectIdSurveyQuestionsResponsetagsApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/SurveyQuestions/responsetags`,
        }),
        providesTags: ['SurveyQuestions'],
      }),
      getProjectsByProjectIdSurveyQuestionsQuestiongroups: build.query<
        GetProjectsByProjectIdSurveyQuestionsQuestiongroupsApiResponse,
        GetProjectsByProjectIdSurveyQuestionsQuestiongroupsApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/SurveyQuestions/questiongroups`,
        }),
        providesTags: ['SurveyQuestions'],
      }),
      postTeams: build.mutation<PostTeamsApiResponse, PostTeamsApiArg>({
        query: (queryArg) => ({ url: `/Teams`, method: 'POST', body: queryArg.team }),
        invalidatesTags: ['Teams'],
      }),
      getTeams: build.query<GetTeamsApiResponse, GetTeamsApiArg>({
        query: (queryArg) => ({
          url: `/Teams`,
          params: {
            organizationId: queryArg.organizationId,
            includeDeleted: queryArg.includeDeleted,
          },
        }),
        providesTags: ['Teams'],
      }),
      getTeamsByTeamId: build.query<GetTeamsByTeamIdApiResponse, GetTeamsByTeamIdApiArg>({
        query: (queryArg) => ({ url: `/Teams/${queryArg.teamId}` }),
        providesTags: ['Teams'],
      }),
      putTeamsByTeamId: build.mutation<PutTeamsByTeamIdApiResponse, PutTeamsByTeamIdApiArg>({
        query: (queryArg) => ({
          url: `/Teams/${queryArg.teamId}`,
          method: 'PUT',
          body: queryArg.team,
        }),
        invalidatesTags: ['Teams'],
      }),
      deleteTeamsByTeamId: build.mutation<
        DeleteTeamsByTeamIdApiResponse,
        DeleteTeamsByTeamIdApiArg
      >({
        query: (queryArg) => ({ url: `/Teams/${queryArg.teamId}`, method: 'DELETE' }),
        invalidatesTags: ['Teams'],
      }),
      getTeamsByTeamIdSubscriptions: build.query<
        GetTeamsByTeamIdSubscriptionsApiResponse,
        GetTeamsByTeamIdSubscriptionsApiArg
      >({
        query: (queryArg) => ({ url: `/Teams/${queryArg.teamId}/Subscriptions` }),
        providesTags: ['Teams'],
      }),
      postTeamsByTeamIdSubscriptions: build.mutation<
        PostTeamsByTeamIdSubscriptionsApiResponse,
        PostTeamsByTeamIdSubscriptionsApiArg
      >({
        query: (queryArg) => ({
          url: `/Teams/${queryArg.teamId}/Subscriptions`,
          method: 'POST',
          body: queryArg.subscriptionRequest,
        }),
        invalidatesTags: ['Teams'],
      }),
      putTeamsByTeamIdSubscriptionsAndSubscriptionId: build.mutation<
        PutTeamsByTeamIdSubscriptionsAndSubscriptionIdApiResponse,
        PutTeamsByTeamIdSubscriptionsAndSubscriptionIdApiArg
      >({
        query: (queryArg) => ({
          url: `/Teams/${queryArg.teamId}/Subscriptions/${queryArg.subscriptionId}`,
          method: 'PUT',
          body: queryArg.subscriptionRequest,
        }),
        invalidatesTags: ['Teams'],
      }),
      deleteTeamsByTeamIdSubscriptionsAndSubscriptionId: build.mutation<
        DeleteTeamsByTeamIdSubscriptionsAndSubscriptionIdApiResponse,
        DeleteTeamsByTeamIdSubscriptionsAndSubscriptionIdApiArg
      >({
        query: (queryArg) => ({
          url: `/Teams/${queryArg.teamId}/Subscriptions/${queryArg.subscriptionId}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['Teams'],
      }),
      getTeamsByTeamIdSubscriptionBalance: build.query<
        GetTeamsByTeamIdSubscriptionBalanceApiResponse,
        GetTeamsByTeamIdSubscriptionBalanceApiArg
      >({
        query: (queryArg) => ({ url: `/Teams/${queryArg.teamId}/SubscriptionBalance` }),
        providesTags: ['Teams'],
      }),
      getTestCategories: build.query<GetTestCategoriesApiResponse, GetTestCategoriesApiArg>({
        query: () => ({ url: `/TestCategories` }),
        providesTags: ['TestCategories'],
      }),
      getTestClassifications: build.query<
        GetTestClassificationsApiResponse,
        GetTestClassificationsApiArg
      >({
        query: (queryArg) => ({
          url: `/TestClassifications`,
          params: {
            testCategoryId: queryArg.testCategoryId,
          },
        }),
        providesTags: ['TestClassifications'],
      }),
      getProjectsByProjectIdTestDesign: build.query<
        GetProjectsByProjectIdTestDesignApiResponse,
        GetProjectsByProjectIdTestDesignApiArg
      >({
        query: (queryArg) => ({ url: `/projects/${queryArg.projectId}/TestDesign` }),
        providesTags: ['TestDesign'],
      }),
      putProjectsByProjectIdTestDesign: build.mutation<
        PutProjectsByProjectIdTestDesignApiResponse,
        PutProjectsByProjectIdTestDesignApiArg
      >({
        query: (queryArg) => ({
          url: `/projects/${queryArg.projectId}/TestDesign`,
          method: 'PUT',
          body: queryArg.upsertTestDesignRequest,
        }),
        invalidatesTags: ['TestDesign', 'SurveyConfigs', 'SurveyBundles', 'HighlighterExperiences'],
      }),
      getProjectsByProjectIdTestGroups: build.query<
        GetProjectsByProjectIdTestGroupsApiResponse,
        GetProjectsByProjectIdTestGroupsApiArg
      >({
        query: (queryArg) => ({ url: `/Projects/${queryArg.projectId}/TestGroups` }),
        providesTags: ['TestGroupV10s'],
      }),
      postProjectsByProjectIdTestGroups: build.mutation<
        PostProjectsByProjectIdTestGroupsApiResponse,
        PostProjectsByProjectIdTestGroupsApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/TestGroups`,
          method: 'POST',
          body: queryArg.createTestGroupV10Request,
        }),
        invalidatesTags: ['TestGroupV10s'],
      }),
      patchProjectsByProjectIdTestGroupsAndTestGroupId: build.mutation<
        PatchProjectsByProjectIdTestGroupsAndTestGroupIdApiResponse,
        PatchProjectsByProjectIdTestGroupsAndTestGroupIdApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/TestGroups/${queryArg.testGroupId}`,
          method: 'PATCH',
          body: queryArg.updateTestGroupV10Request,
        }),
        invalidatesTags: ['TestGroupV10s'],
      }),
      deleteProjectsByProjectIdTestGroupsAndTestGroupId: build.mutation<
        DeleteProjectsByProjectIdTestGroupsAndTestGroupIdApiResponse,
        DeleteProjectsByProjectIdTestGroupsAndTestGroupIdApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/TestGroups/${queryArg.testGroupId}`,
          method: 'DELETE',
          body: queryArg.deleteTestGroupV10Request,
        }),
        invalidatesTags: ['TestGroupV10s'],
      }),
      postProjectsByProjectIdTestGroupsBulk: build.mutation<
        PostProjectsByProjectIdTestGroupsBulkApiResponse,
        PostProjectsByProjectIdTestGroupsBulkApiArg
      >({
        query: (queryArg) => ({
          url: `/Projects/${queryArg.projectId}/TestGroups/$bulk`,
          method: 'POST',
          body: queryArg.bulkTestGroupV10Request,
        }),
        invalidatesTags: ['TestGroupV10s'],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as projectApi };
export type GetAdminsApiResponse = /** status 200 Success */ Admin[];
export type GetAdminsApiArg = {
  emailAddress?: string;
};
export type PostAdminsApiResponse = /** status 200 Success */ Admin;
export type PostAdminsApiArg = {
  createAdminRequest: CreateAdminRequest;
};
export type PostByIdDisableApiResponse = /** status 200 Success */ number;
export type PostByIdDisableApiArg = {
  id: number;
};
export type GetProjectsByProjectIdAdminsApiResponse = /** status 200 Success */ Admin[];
export type GetProjectsByProjectIdAdminsApiArg = {
  projectId: number;
};
export type GetAggregationtypesApiResponse = /** status 200 Success */ AggregationType[];
export type GetAggregationtypesApiArg = void;
export type GetProjectsByProjectIdAttachmentsApiResponse =
  /** status 200 Success */ ProjectAttachment[];
export type GetProjectsByProjectIdAttachmentsApiArg = {
  projectId: number;
};
export type PostProjectsByProjectIdAttachmentsApiResponse =
  /** status 200 Success */ ProjectAttachment;
export type PostProjectsByProjectIdAttachmentsApiArg = {
  projectId: number;
  body: {
    ContentType?: string;
    ContentDisposition?: string;
    Headers?: {
      [key: string]: string[];
    };
    Length?: number;
    Name?: string;
    FileName?: string;
  };
};
export type PutProjectsByProjectIdAttachmentsAndAttachmentIdApiResponse =
  /** status 200 Success */ ProjectAttachment;
export type PutProjectsByProjectIdAttachmentsAndAttachmentIdApiArg = {
  projectId: number;
  attachmentId: string;
  projectAttachment: ProjectAttachment;
};
export type DeleteProjectsByProjectIdAttachmentsAndProjectAttachmentIdApiResponse = unknown;
export type DeleteProjectsByProjectIdAttachmentsAndProjectAttachmentIdApiArg = {
  projectId: number;
  projectAttachmentId: string;
};
export type GetProjectsByProjectIdAudienceBuilderAudienceApiResponse =
  /** status 200 Success */ AudienceBuilderAudienceBuilderAudience;
export type GetProjectsByProjectIdAudienceBuilderAudienceApiArg = {
  projectId: number;
};
export type PutProjectsByProjectIdAudienceBuilderAudienceApiResponse =
  /** status 200 Success */ AudienceBuilderAudienceBuilderAudience;
export type PutProjectsByProjectIdAudienceBuilderAudienceApiArg = {
  projectId: number;
  audienceBuilderAudienceBuilderAudience: AudienceBuilderAudienceBuilderAudience;
};
export type PostProjectsByProjectIdAudienceAttachmentsApiResponse =
  /** status 200 Success */ AudienceAttachmentResponse;
export type PostProjectsByProjectIdAudienceAttachmentsApiArg = {
  projectId: number;
  body: {
    ContentType?: string;
    ContentDisposition?: string;
    Headers?: {
      [key: string]: string[];
    };
    Length?: number;
    Name?: string;
    FileName?: string;
  };
};
export type GetProjectsByProjectIdAudienceAttachmentsAndAttachmentIdApiResponse =
  /** status 200 Success */ AssetWithUrls;
export type GetProjectsByProjectIdAudienceAttachmentsAndAttachmentIdApiArg = {
  projectId: number;
  attachmentId: string;
};
export type GetProjectsByProjectIdAudiencesApiResponse = /** status 200 Success */ AudienceV10[];
export type GetProjectsByProjectIdAudiencesApiArg = {
  projectId: number;
};
export type PostProjectsByProjectIdAudiencesApiResponse = /** status 200 Success */ AudienceV10;
export type PostProjectsByProjectIdAudiencesApiArg = {
  projectId: number;
  createAudienceV10Request: CreateAudienceV10Request;
};
export type PatchProjectsByProjectIdAudiencesAndAudienceIdApiResponse =
  /** status 200 Success */ AudienceV10;
export type PatchProjectsByProjectIdAudiencesAndAudienceIdApiArg = {
  projectId: number;
  audienceId: string;
  updateAudienceV10Request: UpdateAudienceV10Request;
};
export type DeleteProjectsByProjectIdAudiencesAndAudienceIdApiResponse = unknown;
export type DeleteProjectsByProjectIdAudiencesAndAudienceIdApiArg = {
  projectId: number;
  audienceId: string;
  deleteAudienceV10Request: DeleteAudienceV10Request;
};
export type PostProjectsByProjectIdAudiencesBulkApiResponse =
  /** status 200 Success */ AudienceV10[];
export type PostProjectsByProjectIdAudiencesBulkApiArg = {
  projectId: number;
  bulkAudienceV10Request: BulkAudienceV10Request;
};
export type GetBlueprintCatalogExportApiResponse = /** status 200 Success */ BlueprintCatalog;
export type GetBlueprintCatalogExportApiArg = void;
export type GetBlueprintCatalogApplyJobsApiResponse =
  /** status 200 Success */ BlueprintCatalogApplyJob[];
export type GetBlueprintCatalogApplyJobsApiArg = void;
export type PostBlueprintCatalogApplyApiResponse =
  /** status 200 Success */ BlueprintCatalogApplyJob;
export type PostBlueprintCatalogApplyApiArg = {
  blueprintCatalog: BlueprintCatalog;
};
export type PostBlueprintsModuleconfigurationsApiResponse = unknown;
export type PostBlueprintsModuleconfigurationsApiArg = {
  body: {
    file?: Blob;
  };
};
export type PostBlueprintsApiResponse = /** status 200 Success */ CreateModuleBlockResult;
export type PostBlueprintsApiArg = {
  body: {
    file?: Blob;
  };
};
export type GetBlueprintsApiResponse = unknown;
export type GetBlueprintsApiArg = {
  solutionId?: string;
  surveyRoleId?: string;
  testCategoryId?: string;
  subject?: string;
};
export type PostProjectsByProjectIdChatConversationsAndConversationIdMessagesApiResponse =
  /** status 200 Success */ ChatConversationResponse;
export type PostProjectsByProjectIdChatConversationsAndConversationIdMessagesApiArg = {
  projectId: number;
  conversationId: string;
  appendChatMessageRequest: AppendChatMessageRequest;
};
export type GetProjectsByProjectIdChatConversationsAndConversationIdApiResponse =
  /** status 200 Success */ ChatConversationResponse;
export type GetProjectsByProjectIdChatConversationsAndConversationIdApiArg = {
  projectId: number;
  conversationId: string;
};
export type PatchProjectsByProjectIdChatConversationsAndConversationIdApiResponse =
  /** status 200 Success */ ChatConversationResponse;
export type PatchProjectsByProjectIdChatConversationsAndConversationIdApiArg = {
  projectId: number;
  conversationId: string;
  updateChatConversationRequest: UpdateChatConversationRequest;
};
export type DeleteProjectsByProjectIdChatConversationsAndConversationIdApiResponse = unknown;
export type DeleteProjectsByProjectIdChatConversationsAndConversationIdApiArg = {
  projectId: number;
  conversationId: string;
};
export type GetProjectsByProjectIdChatConversationsApiResponse =
  /** status 200 Success */ ChatConversationSummary[];
export type GetProjectsByProjectIdChatConversationsApiArg = {
  projectId: number;
  limit?: number;
};
export type GetCommunitiesApiResponse = /** status 200 Success */ Community[];
export type GetCommunitiesApiArg = void;
export type GetCommunitiesBySlugApiResponse = /** status 200 Success */ CommunityDto;
export type GetCommunitiesBySlugApiArg = {
  slug: string;
};
export type GetCommunitiesBySlugStudyEventsApiResponse = unknown;
export type GetCommunitiesBySlugStudyEventsApiArg = {
  slug: string;
  from?: string;
  to?: string;
};
export type GetCommunitiesStudyEventsSchemaApiResponse = unknown;
export type GetCommunitiesStudyEventsSchemaApiArg = void;
export type PostCommunitiesBySlugRecruitCountApiResponse = /** status 200 Success */ number;
export type PostCommunitiesBySlugRecruitCountApiArg = {
  slug: string;
  feasibilityRecruitCountRequest: FeasibilityRecruitCountRequest;
};
export type PostCustomerRegistrationSelfServeApiResponse =
  /** status 200 Success */ CustomerRegistrationResponse;
export type PostCustomerRegistrationSelfServeApiArg = {
  customerRegistrationRequest: CustomerRegistrationRequest;
};
export type GetCustomersApiResponse = /** status 200 Success */ Customer[];
export type GetCustomersApiArg = {
  emailAddress?: string;
  organizationId?: number;
};
export type PostCustomersApiResponse = /** status 200 Success */ Customer;
export type PostCustomersApiArg = {
  createCustomerRequest: CreateCustomerRequest;
};
export type PutCustomersApiResponse = /** status 200 Success */ Customer;
export type PutCustomersApiArg = {
  updateCustomerRequest: UpdateCustomerRequest;
};
export type PostCustomersBulkApiResponse = /** status 200 Success */ CustomerBatchOperationResult;
export type PostCustomersBulkApiArg = {
  createCustomersBulkRequest: CreateCustomersBulkRequest;
};
export type GetCustomersByCustomerIdApiResponse = /** status 200 Success */ Customer;
export type GetCustomersByCustomerIdApiArg = {
  customerId: number;
};
export type GetTeamsByTeamIdCustomersApiResponse = /** status 200 Success */ Customer[];
export type GetTeamsByTeamIdCustomersApiArg = {
  teamId: number;
  includeDisabled?: boolean;
};
export type PostTeamsByTeamIdCustomersAndCustomerIdApiResponse = unknown;
export type PostTeamsByTeamIdCustomersAndCustomerIdApiArg = {
  teamId: number;
  customerId: number;
};
export type DeleteTeamsByTeamIdCustomersAndCustomerIdApiResponse = unknown;
export type DeleteTeamsByTeamIdCustomersAndCustomerIdApiArg = {
  teamId: number;
  customerId: number;
};
export type PostCustomersByCustomerIdDisableApiResponse = unknown;
export type PostCustomersByCustomerIdDisableApiArg = {
  customerId: number;
};
export type PostCustomersByCustomerIdEnableApiResponse = /** status 200 Success */ Customer;
export type PostCustomersByCustomerIdEnableApiArg = {
  customerId: number;
};
export type PostCustomersByCustomerIdTrackloginApiResponse = unknown;
export type PostCustomersByCustomerIdTrackloginApiArg = {
  customerId: number;
};
export type GetProjectsByProjectIdResultsCustomTopicsApiResponse =
  /** status 200 Success */ CustomTopic[];
export type GetProjectsByProjectIdResultsCustomTopicsApiArg = {
  projectId: number;
  resultContextId?: string;
  lineItemId?: string;
};
export type PostProjectsByProjectIdResultsCustomTopicsApiResponse =
  /** status 200 Success */ CustomTopic;
export type PostProjectsByProjectIdResultsCustomTopicsApiArg = {
  projectId: number;
  resultContextId?: string;
  lineItemId?: string;
  createCustomTopicRequest: CreateCustomTopicRequest;
};
export type DeleteProjectsByProjectIdResultsCustomTopicsAndIdApiResponse = unknown;
export type DeleteProjectsByProjectIdResultsCustomTopicsAndIdApiArg = {
  projectId: number;
  id: string;
  resultContextId?: string;
  lineItemId?: string;
};
export type GetDisqualificationlogicsAllowedopsApiResponse =
  /** status 200 Success */ DisqualificationLogicAllowedOpsResponse;
export type GetDisqualificationlogicsAllowedopsApiArg = void;
export type GetSurveyconfigsBySurveyConfigIdDisqualificationlogicsApiResponse =
  /** status 200 Success */ DisqualificationLogic[];
export type GetSurveyconfigsBySurveyConfigIdDisqualificationlogicsApiArg = {
  surveyConfigId: string;
};
export type PutSurveyconfigsBySurveyConfigIdDisqualificationlogicsAndIdApiResponse =
  /** status 200 Success */ DisqualificationLogic;
export type PutSurveyconfigsBySurveyConfigIdDisqualificationlogicsAndIdApiArg = {
  surveyConfigId: string;
  id: string;
  disqualificationLogic: DisqualificationLogic;
};
export type DeleteSurveyconfigsBySurveyConfigIdDisqualificationlogicsAndIdApiResponse = unknown;
export type DeleteSurveyconfigsBySurveyConfigIdDisqualificationlogicsAndIdApiArg = {
  surveyConfigId: string;
  id: string;
};
export type GetSurveyconfigsBySurveyConfigIdDisqualificationlogicsValidationApiResponse =
  /** status 200 Success */ DisqualificationLogicValidationResults;
export type GetSurveyconfigsBySurveyConfigIdDisqualificationlogicsValidationApiArg = {
  surveyConfigId: string;
};
export type GetExperiencesApiResponse = /** status 200 Success */ Experience[];
export type GetExperiencesApiArg = void;
export type GetProjectsByProjectIdFeasibilityEstimateApiResponse =
  /** status 200 Success */ FeasibilityEstimateResponse;
export type GetProjectsByProjectIdFeasibilityEstimateApiArg = {
  projectId: number;
};
export type PutProjectsByProjectIdFeasibilityEstimateApiResponse =
  /** status 200 Success */ FeasibilityEstimateResponse;
export type PutProjectsByProjectIdFeasibilityEstimateApiArg = {
  projectId: number;
  upsertFeasibilityEstimateRequest: UpsertFeasibilityEstimateRequest;
};
export type PutProjectsByProjectIdFieldingGroupAssignHighlightersApiResponse =
  /** status 200 Success */ FieldingGroupRead[];
export type PutProjectsByProjectIdFieldingGroupAssignHighlightersApiArg = {
  projectId: number;
  bulkCreateFieldingGroupRequest: BulkCreateFieldingGroupRequest;
};
export type PatchProjectsByProjectIdFieldingGroupAndFieldingGroupIdApiResponse =
  /** status 200 Success */ FieldingGroupRead;
export type PatchProjectsByProjectIdFieldingGroupAndFieldingGroupIdApiArg = {
  projectId: number;
  fieldingGroupId: string;
  fieldingGroup: FieldingGroup;
};
export type DeleteProjectsByProjectIdFieldingGroupAndFieldingGroupIdApiResponse = unknown;
export type DeleteProjectsByProjectIdFieldingGroupAndFieldingGroupIdApiArg = {
  projectId: number;
  fieldingGroupId: string;
};
export type DeleteProjectsByProjectIdFieldingGroupApiResponse = unknown;
export type DeleteProjectsByProjectIdFieldingGroupApiArg = {
  projectId: number;
};
export type GetProjectsByProjectIdFieldingGroupApiResponse =
  /** status 200 Success */ FieldingGroupRead[];
export type GetProjectsByProjectIdFieldingGroupApiArg = {
  projectId: number;
  highlighterId?: string;
  expand?: boolean;
};
export type GetFieldingGroupApiResponse = /** status 200 Success */ FieldingGroupRead[];
export type GetFieldingGroupApiArg = {
  highlighterId?: string;
  expand?: boolean;
};
export type PostProjectsByProjectIdFieldingGroupFromKitsApiResponse =
  /** status 200 Success */ FieldingGroupRead[];
export type PostProjectsByProjectIdFieldingGroupFromKitsApiArg = {
  projectId: number;
  createFromKitsRequest: CreateFromKitsRequest;
};
export type PostProjectsByProjectIdFieldingGroupFromTestGroupsApiResponse =
  /** status 200 Success */ FieldingGroupRead[];
export type PostProjectsByProjectIdFieldingGroupFromTestGroupsApiArg = {
  projectId: number;
};
export type PostProjectsByProjectIdFieldingGroupDeleteAllEntitiesApiResponse = unknown;
export type PostProjectsByProjectIdFieldingGroupDeleteAllEntitiesApiArg = {
  projectId: number;
};
export type PostFieldingGroupsByFieldingGroupIdFieldingGroupAssignmentsApiResponse =
  /** status 200 Success */ FieldingGroupAssignment[];
export type PostFieldingGroupsByFieldingGroupIdFieldingGroupAssignmentsApiArg = {
  fieldingGroupId: string;
  body: FieldingGroupAssignment[];
};
export type DeleteFieldingGroupsByFieldingGroupIdFieldingGroupAssignmentsApiResponse = unknown;
export type DeleteFieldingGroupsByFieldingGroupIdFieldingGroupAssignmentsApiArg = {
  fieldingGroupId: string;
  body: FieldingGroupAssignment[];
};
export type GetProjectsByProjectIdHighlighterExperiencesApiResponse =
  /** status 200 Success */ HighlighterExperienceRead[];
export type GetProjectsByProjectIdHighlighterExperiencesApiArg = {
  projectId: number;
};
export type PostProjectsByProjectIdHighlighterExperiencesApiResponse =
  /** status 200 Success */ HighlighterExperience[];
export type PostProjectsByProjectIdHighlighterExperiencesApiArg = {
  projectId: number;
  body: HighlighterExperience[];
};
export type GetProjectsByProjectIdHighlighterExperiencesOverviewApiResponse =
  /** status 200 Success */ HighlighterExperienceOverviewResponse;
export type GetProjectsByProjectIdHighlighterExperiencesOverviewApiArg = {
  projectId: number;
};
export type GetProjectsByProjectIdHighlighterExperiencesAndExperienceIdAssignmentsApiResponse =
  /** status 200 Success */ HighlighterExperienceAssignment[];
export type GetProjectsByProjectIdHighlighterExperiencesAndExperienceIdAssignmentsApiArg = {
  projectId: number;
  experienceId: string;
};
export type PostProjectsByProjectIdHighlighterExperiencesAndExperienceIdInitializeApiResponse =
  /** status 200 Success */ HighlighterExperienceAssignment[];
export type PostProjectsByProjectIdHighlighterExperiencesAndExperienceIdInitializeApiArg = {
  projectId: number;
  experienceId: string;
  initializeHighlighterExperienceRequest: InitializeHighlighterExperienceRequest;
};
export type PostProjectsByProjectIdHighlighterExperiencesAndExperienceIdActivateApiResponse =
  /** status 200 Success */ HighlighterExperienceAssignment[];
export type PostProjectsByProjectIdHighlighterExperiencesAndExperienceIdActivateApiArg = {
  projectId: number;
  experienceId: string;
  body: HighlighterBeginOn[];
};
export type GetHubSpotDealsByDealIdApiResponse = /** status 200 Success */ EnrichedHubSpotDeal;
export type GetHubSpotDealsByDealIdApiArg = {
  dealId: string;
};
export type PostInsertsApiResponse = /** status 200 Success */ Insert;
export type PostInsertsApiArg = {
  createInsertRequest: CreateInsertRequest;
};
export type PutInsertsByInsertIdApiResponse = /** status 200 Success */ Insert;
export type PutInsertsByInsertIdApiArg = {
  insertId: number;
  insert: Insert;
};
export type DeleteInsertsByInsertIdApiResponse = unknown;
export type DeleteInsertsByInsertIdApiArg = {
  insertId: number;
};
export type PostInsertsByInsertIdFileApiResponse = /** status 200 Success */ Insert;
export type PostInsertsByInsertIdFileApiArg = {
  insertId: number;
  body: {
    ContentType?: string;
    ContentDisposition?: string;
    Headers?: {
      [key: string]: string[];
    };
    Length?: number;
    Name?: string;
    FileName?: string;
  };
};
export type DeleteInsertsByInsertIdFileApiResponse = unknown;
export type DeleteInsertsByInsertIdFileApiArg = {
  insertId: number;
};
export type GetProjectsByProjectIdKitsApiResponse = /** status 200 Success */ KitRead[];
export type GetProjectsByProjectIdKitsApiArg = {
  projectId: number;
  details?: boolean;
};
export type PostProjectsByProjectIdKitsApiResponse = /** status 200 Success */ KitRead;
export type PostProjectsByProjectIdKitsApiArg = {
  projectId: number;
  kit: Kit;
};
export type PutProjectsByProjectIdKitsAndKitIdApiResponse = /** status 200 Success */ KitRead;
export type PutProjectsByProjectIdKitsAndKitIdApiArg = {
  projectId: number;
  kitId: number;
  kit: Kit;
};
export type DeleteProjectsByProjectIdKitsAndKitIdApiResponse = unknown;
export type DeleteProjectsByProjectIdKitsAndKitIdApiArg = {
  projectId: number;
  kitId: number;
};
export type GetProjectsByProjectIdKitsAndKitIdAssetsApiResponse =
  /** status 200 Success */ KitAsset[];
export type GetProjectsByProjectIdKitsAndKitIdAssetsApiArg = {
  projectId: number;
  kitId: number;
};
export type PostProjectsByProjectIdKitsAndKitIdAssetsApiResponse =
  /** status 200 Success */ KitAsset[];
export type PostProjectsByProjectIdKitsAndKitIdAssetsApiArg = {
  projectId: number;
  kitId: number;
  body: {
    Files?: Blob[];
    Description?: string;
    BoxLengthInches?: number;
    BoxWidthInches?: number;
    BoxHeightInches?: number;
  };
};
export type DeleteProjectsByProjectIdKitsAndKitIdAssetsKitAssetIdApiResponse = unknown;
export type DeleteProjectsByProjectIdKitsAndKitIdAssetsKitAssetIdApiArg = {
  projectId: number;
  kitId: number;
  kitAssetId: string;
};
export type PostProjectsByProjectIdKitsAndKitIdRequestReviewApiResponse =
  /** status 200 Success */ KitRead;
export type PostProjectsByProjectIdKitsAndKitIdRequestReviewApiArg = {
  projectId: number;
  kitId: number;
  requestReviewRequest: RequestReviewRequest;
};
export type PostProjectsByProjectIdKitsAndKitIdReviewApiResponse =
  /** status 200 Success */ KitRead;
export type PostProjectsByProjectIdKitsAndKitIdReviewApiArg = {
  projectId: number;
  kitId: number;
  reviewRequest: ReviewRequest;
};
export type PostProjectsByProjectIdLinksApiResponse = /** status 200 Success */ ProjectLink;
export type PostProjectsByProjectIdLinksApiArg = {
  projectId: number;
  createRequest: CreateRequest;
};
export type GetProjectsByProjectIdLinksApiResponse = /** status 200 Success */ ProjectLink[];
export type GetProjectsByProjectIdLinksApiArg = {
  projectId: number;
};
export type PutProjectsByProjectIdLinksAndProjectLinkIdApiResponse =
  /** status 200 Success */ ProjectLink;
export type PutProjectsByProjectIdLinksAndProjectLinkIdApiArg = {
  projectId: number;
  projectLinkId: string;
  projectLink: ProjectLink;
};
export type DeleteProjectsByProjectIdLinksAndProjectLinkIdApiResponse = unknown;
export type DeleteProjectsByProjectIdLinksAndProjectLinkIdApiArg = {
  projectId: number;
  projectLinkId: string;
};
export type GetProjectsByProjectIdSurveysManualApiResponse =
  /** status 200 Success */ ManualSurvey[];
export type GetProjectsByProjectIdSurveysManualApiArg = {
  projectId: number;
};
export type PostProjectsByProjectIdSurveysManualApiResponse =
  /** status 200 Success */ ManualSurvey;
export type PostProjectsByProjectIdSurveysManualApiArg = {
  projectId: number;
  createManualSurveyRequest: CreateManualSurveyRequest;
};
export type PatchProjectsByProjectIdSurveysManualAndSurveyIdApiResponse =
  /** status 200 Success */ ManualSurvey;
export type PatchProjectsByProjectIdSurveysManualAndSurveyIdApiArg = {
  projectId: number;
  surveyId: number;
  updateManualSurveyRequest: UpdateManualSurveyRequest;
};
export type PostModulesByModuleIdBlocksAssignApiResponse = unknown;
export type PostModulesByModuleIdBlocksAssignApiArg = {
  moduleId: string;
  body: string[];
};
export type GetModuleConfigurationsApiResponse = /** status 200 Success */ ModuleConfiguration[];
export type GetModuleConfigurationsApiArg = {
  solutionId?: string;
  surveyRoleId?: string;
  testCategoryId?: string;
  subject?: string;
};
export type PostModuleConfigurationsApiResponse = /** status 200 Success */ ModuleConfiguration;
export type PostModuleConfigurationsApiArg = {
  moduleConfiguration: ModuleConfiguration;
};
export type PostModuleConfigurationsAssignApiResponse =
  /** status 200 Success */ ModuleConfiguration[];
export type PostModuleConfigurationsAssignApiArg = {
  assignModuleConfigurationsToBlueprintRequest: AssignModuleConfigurationsToBlueprintRequest;
};
export type GetModulesByModuleIdApiResponse = /** status 200 Success */ Module;
export type GetModulesByModuleIdApiArg = {
  moduleId: string;
};
export type GetModulesApiResponse = /** status 200 Success */ Module[];
export type GetModulesApiArg = {
  projectId?: number;
  moduleType?: string;
  surveyRoleId?: string;
  excludeArchived?: boolean;
  subject?: string;
  testCategoryId?: string;
};
export type PostModulesApiResponse = /** status 200 Success */ Module;
export type PostModulesApiArg = {
  module: Module;
};
export type PutModulesApiResponse = /** status 200 Success */ Module;
export type PutModulesApiArg = {
  module: Module;
};
export type GetBlocksByBlockIdModulesApiResponse = /** status 200 Success */ Module[];
export type GetBlocksByBlockIdModulesApiArg = {
  blockId: string;
};
export type GetProjectsByProjectIdNotificationUnsubscriptionsApiResponse =
  /** status 200 Success */ NotificationUnsubscription[];
export type GetProjectsByProjectIdNotificationUnsubscriptionsApiArg = {
  projectId: number;
};
export type PostProjectsByProjectIdNotificationUnsubscriptionsApiResponse =
  /** status 200 Success */ NotificationUnsubscription;
export type PostProjectsByProjectIdNotificationUnsubscriptionsApiArg = {
  projectId: string;
  notificationUnsubscription: NotificationUnsubscription;
};
export type DeleteProjectsByProjectIdNotificationUnsubscriptionsApiResponse = unknown;
export type DeleteProjectsByProjectIdNotificationUnsubscriptionsApiArg = {
  projectId: string;
  notificationUnsubscription: NotificationUnsubscription;
};
export type PostOrganizationsApiResponse = /** status 200 Success */ Organization;
export type PostOrganizationsApiArg = {
  organization: Organization;
};
export type GetOrganizationsApiResponse = /** status 200 Success */ Organization[];
export type GetOrganizationsApiArg = {
  includeDeleted?: boolean;
};
export type PutOrganizationsApiResponse = /** status 200 Success */ Organization;
export type PutOrganizationsApiArg = {
  organization: Organization;
};
export type GetOrganizationsByOrgIdEntitlementDefnApiResponse =
  /** status 200 Success */ EntitlementsDefn;
export type GetOrganizationsByOrgIdEntitlementDefnApiArg = {
  orgId: number;
};
export type GetOrganizationsByOrgIdCommunitiesApiResponse = /** status 200 Success */ Community[];
export type GetOrganizationsByOrgIdCommunitiesApiArg = {
  orgId: number;
};
export type GetProjectsByProjectIdPackingListBoxConfigurationsApiResponse = unknown;
export type GetProjectsByProjectIdPackingListBoxConfigurationsApiArg = {
  /** Project ID */
  projectId: number;
  /** Optional kit ID to filter by specific kit */
  kitId?: number;
};
export type GetProjectsByProjectIdPackingListSimplifiedBoxListApiResponse = unknown;
export type GetProjectsByProjectIdPackingListSimplifiedBoxListApiArg = {
  /** Project ID */
  projectId: number;
  /** Optional kit ID to filter by specific kit */
  kitId?: number;
};
export type PostOrganizationsByOrgIdPersonaPanelsAndPersonaPanelIdChatConversationsConversationIdMessagesApiResponse =
  /** status 200 Success */ ChatConversationResponse;
export type PostOrganizationsByOrgIdPersonaPanelsAndPersonaPanelIdChatConversationsConversationIdMessagesApiArg =
  {
    orgId: number;
    personaPanelId: string;
    conversationId: string;
    appendChatMessageRequest: AppendChatMessageRequest;
  };
export type GetOrganizationsByOrgIdPersonaPanelsAndPersonaPanelIdChatConversationsConversationIdApiResponse =
  /** status 200 Success */ ChatConversationResponse;
export type GetOrganizationsByOrgIdPersonaPanelsAndPersonaPanelIdChatConversationsConversationIdApiArg =
  {
    orgId: number;
    personaPanelId: string;
    conversationId: string;
  };
export type PatchOrganizationsByOrgIdPersonaPanelsAndPersonaPanelIdChatConversationsConversationIdApiResponse =
  /** status 200 Success */ ChatConversationResponse;
export type PatchOrganizationsByOrgIdPersonaPanelsAndPersonaPanelIdChatConversationsConversationIdApiArg =
  {
    orgId: number;
    personaPanelId: string;
    conversationId: string;
    updateChatConversationRequest: UpdateChatConversationRequest;
  };
export type DeleteOrganizationsByOrgIdPersonaPanelsAndPersonaPanelIdChatConversationsConversationIdApiResponse =
  unknown;
export type DeleteOrganizationsByOrgIdPersonaPanelsAndPersonaPanelIdChatConversationsConversationIdApiArg =
  {
    orgId: number;
    personaPanelId: string;
    conversationId: string;
  };
export type GetOrganizationsByOrgIdPersonaPanelsAndPersonaPanelIdChatConversationsApiResponse =
  /** status 200 Success */ ChatConversationSummary[];
export type GetOrganizationsByOrgIdPersonaPanelsAndPersonaPanelIdChatConversationsApiArg = {
  orgId: number;
  personaPanelId: string;
  limit?: number;
};
export type GetProjectsByProjectIdPresentationrulesApiResponse =
  /** status 200 Success */ PresentationRuleDto[];
export type GetProjectsByProjectIdPresentationrulesApiArg = {
  projectId: number;
};
export type PutProjectsByProjectIdPresentationrulesAndSlugApiResponse = unknown;
export type PutProjectsByProjectIdPresentationrulesAndSlugApiArg = {
  projectId: number;
  slug: string;
  editPresentationRuleRequest: EditPresentationRuleRequest;
};
export type DeleteProjectsByProjectIdPresentationrulesAndSlugApiResponse = unknown;
export type DeleteProjectsByProjectIdPresentationrulesAndSlugApiArg = {
  projectId: number;
  slug: string;
};
export type GetProjectsByProjectIdProductListsApiResponse = /** status 200 Success */ ProductList[];
export type GetProjectsByProjectIdProductListsApiArg = {
  projectId: number;
};
export type PostProjectsByProjectIdProductListsApiResponse = /** status 200 Success */ ProductList;
export type PostProjectsByProjectIdProductListsApiArg = {
  projectId: number;
  productList: ProductList;
};
export type PutProjectsByProjectIdProductListsAndIdApiResponse =
  /** status 200 Success */ ProductList;
export type PutProjectsByProjectIdProductListsAndIdApiArg = {
  projectId: number;
  id: number;
  productList: ProductList;
};
export type DeleteProjectsByProjectIdProductListsAndIdApiResponse = unknown;
export type DeleteProjectsByProjectIdProductListsAndIdApiArg = {
  projectId: number;
  id: number;
};
export type GetProjectsByProjectIdProductProjectAssetsApiResponse =
  /** status 200 Success */ ProductProjectAsset[];
export type GetProjectsByProjectIdProductProjectAssetsApiArg = {
  projectId: number;
};
export type PostProjectsByProjectIdProductsAndProductIdProductProjectAssetsApiResponse =
  /** status 200 Success */ ProductProjectAsset;
export type PostProjectsByProjectIdProductsAndProductIdProductProjectAssetsApiArg = {
  /** The ID of the project */
  projectId: number;
  /** The ID of the product */
  productId: number;
  /** The product project asset request */
  productProjectAssetRequest: ProductProjectAssetRequest;
};
export type DeleteProductProjectAssetsByProductProjectAssetIdApiResponse = unknown;
export type DeleteProductProjectAssetsByProductProjectAssetIdApiArg = {
  /** The ID of the product project asset to delete */
  productProjectAssetId: string;
};
export type GetProductsByProductIdApiResponse = /** status 200 Success */ Product;
export type GetProductsByProductIdApiArg = {
  projectId?: number;
  productId: number;
};
export type PutProductsByProductIdApiResponse = /** status 200 Success */ Product;
export type PutProductsByProductIdApiArg = {
  productId: number;
  projectId?: number;
  product: Product;
};
export type PostProjectsByProjectIdProductsApiResponse = /** status 200 Success */ Product;
export type PostProjectsByProjectIdProductsApiArg = {
  projectId: number;
  product: Product;
};
export type GetProjectsByProjectIdProductsApiResponse = /** status 200 Success */ Product[];
export type GetProjectsByProjectIdProductsApiArg = {
  projectId: number;
};
export type PutProjectsByProjectIdProductsApiResponse = /** status 200 Success */ Product;
export type PutProjectsByProjectIdProductsApiArg = {
  projectId: string;
  product: Product;
};
export type DeleteProjectsByProjectIdProductsApiResponse = unknown;
export type DeleteProjectsByProjectIdProductsApiArg = {
  projectId: string;
  product: Product;
};
export type PostProjectsByProjectIdProductsBulkApiResponse = /** status 200 Success */ Product[];
export type PostProjectsByProjectIdProductsBulkApiArg = {
  projectId: number;
  bulkProductRequest: BulkProductRequest;
};
export type PostProjectsByProjectIdProductsSurveyRenamePlanApiResponse =
  /** status 200 Success */ ProductSurveyRenamePlan;
export type PostProjectsByProjectIdProductsSurveyRenamePlanApiArg = {
  projectId: number;
  productSurveyRenamePlanRequest: ProductSurveyRenamePlanRequest;
};
export type GetProjectCategoriesApiResponse = /** status 200 Success */ ProjectCategory[];
export type GetProjectCategoriesApiArg = void;
export type GetProjectFinalReportsByProjectIdApiResponse =
  /** status 200 Success */ ProjectFinalReports;
export type GetProjectFinalReportsByProjectIdApiArg = {
  projectId: number;
};
export type PutProjectFinalReportsByProjectIdApiResponse =
  /** status 200 Success */ ProjectFinalReports;
export type PutProjectFinalReportsByProjectIdApiArg = {
  projectId: number;
  projectFinalReports: ProjectFinalReports;
};
export type PostProjectFinalReportsUploadFileApiResponse = /** status 200 Success */ AssetWithUrls;
export type PostProjectFinalReportsUploadFileApiArg = {
  body: {
    ContentType?: string;
    ContentDisposition?: string;
    Headers?: {
      [key: string]: string[];
    };
    Length?: number;
    Name?: string;
    FileName?: string;
  };
};
export type GetProjectsByProjectIdProjectIntakeAnswersApiResponse =
  /** status 200 Success */ ProjectIntakeAnswers;
export type GetProjectsByProjectIdProjectIntakeAnswersApiArg = {
  projectId: number;
};
export type PostAdminProcessAllProjectsApiResponse = unknown;
export type PostAdminProcessAllProjectsApiArg = void;
export type PostProjectsByProjectIdAiReviewApiResponse =
  /** status 200 Success */ ProjectReviewResult;
export type PostProjectsByProjectIdAiReviewApiArg = {
  projectId: number;
};
export type GetProjectsByProjectIdAiReviewApiResponse = unknown;
export type GetProjectsByProjectIdAiReviewApiArg = {
  projectId: number;
};
export type PostProjectsByProjectIdAiSummaryApiResponse =
  /** status 200 Success */ ProjectSummaryResponse;
export type PostProjectsByProjectIdAiSummaryApiArg = {
  projectId: number;
};
export type GetProjectsByProjectIdAiSummaryApiResponse = unknown;
export type GetProjectsByProjectIdAiSummaryApiArg = {
  projectId: number;
};
export type PostProjectsApiResponse = /** status 200 Success */ Project;
export type PostProjectsApiArg = {
  project: Project;
};
export type PostProjectsConfigureApiResponse = /** status 200 Success */ Project;
export type PostProjectsConfigureApiArg = {
  projectConfigurationDto: ProjectConfigurationDto;
};
export type PostProjectsConfigureV2ApiResponse = /** status 200 Success */ Project;
export type PostProjectsConfigureV2ApiArg = {
  configureProjectV2Request: ConfigureProjectV2Request;
};
export type PutProjectsApiResponse = /** status 200 Success */ Project;
export type PutProjectsApiArg = {
  project: Project;
};
export type GetProjectsApiResponse = /** status 200 Success */ Project[];
export type GetProjectsApiArg = {
  publicId?: string;
  type?: string;
  teamId?: number;
};
export type PatchProjectsByProjectIdApiResponse = /** status 200 Success */ Project;
export type PatchProjectsByProjectIdApiArg = {
  projectId: number;
  updateProjectRequest: UpdateProjectRequest;
};
export type GetProjectsByProjectIdApiResponse = /** status 200 Success */ Project;
export type GetProjectsByProjectIdApiArg = {
  projectId: number;
};
export type DeleteProjectsByProjectIdApiResponse = unknown;
export type DeleteProjectsByProjectIdApiArg = {
  projectId: number;
};
export type GetProjectsByProjectIdNotificationEntitlementsApiResponse =
  /** status 200 Success */ ProjectNotificationEntitlements;
export type GetProjectsByProjectIdNotificationEntitlementsApiArg = {
  projectId: number;
};
export type GetProjectsByProjectIdStatusApiResponse =
  /** status 200 Success */ ProjectStatusResponse;
export type GetProjectsByProjectIdStatusApiArg = {
  projectId: number;
};
export type GetProjectsByProjectIdProductSurveyConfigIdsApiResponse =
  /** status 200 Success */ string[];
export type GetProjectsByProjectIdProductSurveyConfigIdsApiArg = {
  projectId: number;
};
export type GetProjectsByProjectIdProductSurveyConfigMapApiResponse =
  /** status 200 Success */ ProductSurveyConfig[];
export type GetProjectsByProjectIdProductSurveyConfigMapApiArg = {
  projectId: number;
};
export type GetProjectsByProjectIdInsertsApiResponse = /** status 200 Success */ Insert[];
export type GetProjectsByProjectIdInsertsApiArg = {
  projectId: number;
};
export type GetProjectsAdminProjectsApiResponse = /** status 200 Success */ AdminProjectRead[];
export type GetProjectsAdminProjectsApiArg = {
  /** Optional comma-separated list of project statuses to filter by */
  status?: string;
  /** Optional text to search for in project titles and descriptions */
  text?: string;
  /** Optional comma-separated list of project ids to limit results to */
  ids?: string;
  /** Whether to include additional project details in the response.
    This can be overridden by the details parameter at the endpoint level. */
  details?: boolean;
  /** Optional comma-separated list of project types to filter by (ihut, concept_test, insights) */
  type?: string;
};
export type PostProjectsByProjectIdAssignAdminsApiResponse =
  /** status 200 Success */ ProjectAdmin[];
export type PostProjectsByProjectIdAssignAdminsApiArg = {
  projectId: number;
  assignProjectAdminsRequest: AssignProjectAdminsRequest;
};
export type GetProjectsAutomaticRecruitingApiResponse = /** status 200 Success */ Project[];
export type GetProjectsAutomaticRecruitingApiArg = void;
export type PatchProjectsByProjectIdStatusApiResponse = /** status 200 Success */ Project;
export type PatchProjectsByProjectIdStatusApiArg = {
  projectId: number;
  projectStatusRequest: ProjectStatusRequest;
};
export type PatchProjectsByProjectIdTeamApiResponse = /** status 200 Success */ Project;
export type PatchProjectsByProjectIdTeamApiArg = {
  projectId: number;
  projectTeamRequest: ProjectTeamRequest;
};
export type PatchProjectsByProjectIdProductBlindingMethodApiResponse =
  /** status 200 Success */ Project;
export type PatchProjectsByProjectIdProductBlindingMethodApiArg = {
  projectId: number;
  projectProductBlindingMethodRequest: ProjectProductBlindingMethodRequest;
};
export type PatchProjectsByProjectIdNameApiResponse = /** status 200 Success */ Project;
export type PatchProjectsByProjectIdNameApiArg = {
  projectId: number;
  projectNameRequest: ProjectNameRequest;
};
export type PostProjectsByProjectIdUploadBoxTrackingApiResponse =
  /** status 200 Success */ BoxTrackingFileParseResult;
export type PostProjectsByProjectIdUploadBoxTrackingApiArg = {
  projectId: number;
  body: {
    file?: Blob;
  };
};
export type PostProjectsByProjectIdSyncKitsApiResponse = unknown;
export type PostProjectsByProjectIdSyncKitsApiArg = {
  projectId: number;
};
export type PostProjectsCreateFromExistingApiResponse = /** status 200 Success */ Project;
export type PostProjectsCreateFromExistingApiArg = {
  createProjectFromExistingProjectsRequest: CreateProjectFromExistingProjectsRequest;
};
export type PostProjectsByProjectIdDisableAutomationsApiResponse = unknown;
export type PostProjectsByProjectIdDisableAutomationsApiArg = {
  projectId: number;
};
export type PostProjectsByProjectIdLaunchProjectApiResponse = unknown;
export type PostProjectsByProjectIdLaunchProjectApiArg = {
  projectId: number;
};
export type PutProjectsByProjectIdTimelineApiResponse = /** status 200 Success */ Project;
export type PutProjectsByProjectIdTimelineApiArg = {
  projectId: number;
  updateTimelineRequest: UpdateTimelineRequest;
};
export type PostProjectsByProjectIdQuestionsAutoLinkApiResponse =
  /** status 200 Success */ QuestionLinkingResult;
export type PostProjectsByProjectIdQuestionsAutoLinkApiArg = {
  projectId: number;
};
export type PostProjectsByProjectIdScorecardPopulateApiResponse =
  /** status 200 Success */ ScoreCardPopulationResult;
export type PostProjectsByProjectIdScorecardPopulateApiArg = {
  projectId: number;
};
export type GetProjectsGetActiveParticipantGuidanceProjectIdsApiResponse =
  /** status 200 Success */ number[];
export type GetProjectsGetActiveParticipantGuidanceProjectIdsApiArg = void;
export type PostProjectsByProjectIdUpdateDashboardApiResponse =
  /** status 200 Success */ UpdateDashboardResponse;
export type PostProjectsByProjectIdUpdateDashboardApiArg = {
  projectId: number;
  updateDashboardRequest: UpdateDashboardRequest;
};
export type GetProjectsByProjectIdConfigurationsApiResponse =
  /** status 200 Success */ ProjectConfigurationDto;
export type GetProjectsByProjectIdConfigurationsApiArg = {
  projectId: number;
};
export type GetProjectsByProjectIdExperiencesApiResponse = /** status 200 Success */ Experience;
export type GetProjectsByProjectIdExperiencesApiArg = {
  projectId: number;
};
export type PostProjectsHackyconfigureApiResponse = /** status 200 Success */ Project;
export type PostProjectsHackyconfigureApiArg = {
  projectHackyConfigurationDto: ProjectHackyConfigurationDto;
};
export type DeleteProjectsByProjectIdSurveysAndSurveyIdApiResponse = unknown;
export type DeleteProjectsByProjectIdSurveysAndSurveyIdApiArg = {
  projectId: number;
  surveyId: number;
};
export type DeleteProjectsByProjectIdSurveysAndSurveyIdFileApiResponse = unknown;
export type DeleteProjectsByProjectIdSurveysAndSurveyIdFileApiArg = {
  projectId: number;
  surveyId: number;
};
export type GetProjectsByProjectIdSurveysAndSurveyIdFileApiResponse =
  /** status 200 Success */ AssetWithUrls;
export type GetProjectsByProjectIdSurveysAndSurveyIdFileApiArg = {
  projectId: number;
  surveyId: number;
};
export type PostProjectsByProjectIdSurveysAndSurveyIdFileApiResponse =
  /** status 200 Success */ AssetWithUrls;
export type PostProjectsByProjectIdSurveysAndSurveyIdFileApiArg = {
  projectId: number;
  surveyId: number;
  body: {
    ContentType?: string;
    ContentDisposition?: string;
    Headers?: {
      [key: string]: string[];
    };
    Length?: number;
    Name?: string;
    FileName?: string;
  };
};
export type GetProjectsByProjectIdSurveysApiResponse = /** status 200 Success */ ProjectSurvey[];
export type GetProjectsByProjectIdSurveysApiArg = {
  projectId: number;
};
export type PatchProjectsByProjectIdSurveysAndSurveyIdSurveyStatusApiResponse =
  /** status 200 Success */ ProjectSurvey;
export type PatchProjectsByProjectIdSurveysAndSurveyIdSurveyStatusApiArg = {
  projectId: number;
  surveyId: number;
  setSurveyStatusRequest: SetSurveyStatusRequest;
};
export type PatchProjectsByProjectIdSurveysAndSurveyIdResultsStatusApiResponse =
  /** status 200 Success */ ProjectSurvey;
export type PatchProjectsByProjectIdSurveysAndSurveyIdResultsStatusApiArg = {
  projectId: number;
  surveyId: number;
  setResultsStatusRequest: SetResultsStatusRequest;
};
export type GetProjectsByProjectIdQualityControlReportApiResponse =
  /** status 200 Success */ QualityControlReport;
export type GetProjectsByProjectIdQualityControlReportApiArg = {
  projectId: number;
};
export type GetQualityControlReportApiResponse = /** status 200 Success */ QualityControlReport;
export type GetQualityControlReportApiArg = {
  surveyId?: string;
  surveyName?: string;
};
export type PostQualityControlReportSubmitreviewApiResponse = unknown;
export type PostQualityControlReportSubmitreviewApiArg = {
  submitReviewRequest: SubmitReviewRequest;
};
export type GetProjectsByProjectIdQualityControlReportAndResponseIdApiResponse =
  /** status 200 Success */ ResponseDetails;
export type GetProjectsByProjectIdQualityControlReportAndResponseIdApiArg = {
  responseId: string;
  projectId: string;
};
export type PostProjectsByProjectIdQualityControlReportSetAnswerExcludedApiResponse = unknown;
export type PostProjectsByProjectIdQualityControlReportSetAnswerExcludedApiArg = {
  projectId: number;
  setAnswerExcludedPayload: SetAnswerExcludedPayload;
};
export type GetProjectsByProjectIdQualityControlReportFullCompletesBreakdownApiResponse =
  /** status 200 Success */ FullCompletesBreakdown;
export type GetProjectsByProjectIdQualityControlReportFullCompletesBreakdownApiArg = {
  projectId: number;
};
export type GetProjectsByProjectIdRecommendationApiResponse =
  /** status 200 Success */ ProjectRecommendationResponse;
export type GetProjectsByProjectIdRecommendationApiArg = {
  projectId: number;
};
export type PostProjectsByProjectIdRecommendationApiResponse = unknown;
export type PostProjectsByProjectIdRecommendationApiArg = {
  projectId: number;
};
export type PostProjectsByProjectIdRecruitCountApiResponse = /** status 200 Success */ number;
export type PostProjectsByProjectIdRecruitCountApiArg = {
  projectId: number;
  feasibilityRecruitCountRequest: FeasibilityRecruitCountRequest;
};
export type GetProjectsByProjectIdRecruitingDataApiResponse =
  /** status 200 Success */ RecruitingData;
export type GetProjectsByProjectIdRecruitingDataApiArg = {
  projectId: number;
};
export type PostProjectsByProjectIdRecruitingDataApiResponse =
  /** status 200 Success */ RecruitingData;
export type PostProjectsByProjectIdRecruitingDataApiArg = {
  projectId: number;
  recruitingData: RecruitingData;
};
export type PutProjectsByProjectIdRecruitingDataApiResponse =
  /** status 200 Success */ RecruitingData;
export type PutProjectsByProjectIdRecruitingDataApiArg = {
  projectId: number;
  recruitingData: RecruitingData;
};
export type PatchProjectsByProjectIdRecruitingDataApiResponse =
  /** status 200 Success */ RecruitingData;
export type PatchProjectsByProjectIdRecruitingDataApiArg = {
  projectId: number;
  updateRecruitingDataStatusRequest: UpdateRecruitingDataStatusRequest;
};
export type PatchProjectsByProjectIdRecruitingDataPlacementsApiResponse =
  /** status 200 Success */ RecruitingData;
export type PatchProjectsByProjectIdRecruitingDataPlacementsApiArg = {
  projectId: number;
  updateProjectPlacementsRequest: UpdateProjectPlacementsRequest;
};
export type PostProjectsByProjectIdRecruitingDataBoostApiResponse = unknown;
export type PostProjectsByProjectIdRecruitingDataBoostApiArg = {
  projectId: number;
  boostRecruitingRequest: BoostRecruitingRequest;
};
export type PostProjectsByProjectIdRecruitingDataImportApiResponse =
  /** status 200 Success */ RecruitingData;
export type PostProjectsByProjectIdRecruitingDataImportApiArg = {
  projectId: number;
};
export type PostProjectsByProjectIdReportApiResponse = /** status 200 Success */ GeneratedReport;
export type PostProjectsByProjectIdReportApiArg = {
  projectId: number;
  reportParams: ReportParams;
};
export type GetProjectsByProjectIdReportApiResponse = /** status 200 Success */ GeneratedReport[];
export type GetProjectsByProjectIdReportApiArg = {
  projectId: number;
};
export type GetProjectsByProjectIdReportCustomerreportsApiResponse =
  /** status 200 Success */ GeneratedReport[];
export type GetProjectsByProjectIdReportCustomerreportsApiArg = {
  projectId: number;
};
export type PostProjectsByProjectIdReportAndGeneratedReportIdDownloadReportDownloadTypeApiResponse =
  unknown;
export type PostProjectsByProjectIdReportAndGeneratedReportIdDownloadReportDownloadTypeApiArg = {
  projectId: number;
  generatedReportId: string;
  reportDownloadType: string;
};
export type DeleteProjectsByProjectIdReportAndGeneratedReportIdApiResponse = unknown;
export type DeleteProjectsByProjectIdReportAndGeneratedReportIdApiArg = {
  projectId: number;
  generatedReportId: string;
};
export type GetProjectsByProjectIdResultContextsApiResponse =
  /** status 200 Success */ ResultContextRead[];
export type GetProjectsByProjectIdResultContextsApiArg = {
  projectId: number;
  includeCandidateContexts?: boolean;
};
export type PostProjectsByProjectIdSurveyconfigsAndSurveyConfigIdResultContextsApiResponse =
  unknown;
export type PostProjectsByProjectIdSurveyconfigsAndSurveyConfigIdResultContextsApiArg = {
  projectId: number;
  surveyConfigId: string;
};
export type GetProjectsByProjectIdResultsDownloadcsvApiResponse = unknown;
export type GetProjectsByProjectIdResultsDownloadcsvApiArg = {
  projectId: number;
  positionFilter?: number;
  surveyGroupIds?: string[];
  selectedSurveyConfigIds?: string[];
};
export type GetProjectsByProjectIdResultsDownloadcodedcsvApiResponse = unknown;
export type GetProjectsByProjectIdResultsDownloadcodedcsvApiArg = {
  projectId: number;
  positionFilter?: number;
  surveyGroupIds?: string[];
  selectedSurveyConfigIds?: string[];
};
export type GetProjectsByProjectIdResultsDownloadcsvallrespondentsApiResponse = unknown;
export type GetProjectsByProjectIdResultsDownloadcsvallrespondentsApiArg = {
  projectId: number;
  positionFilter?: number;
  surveyGroupIds?: string[];
  selectedSurveyConfigIds?: string[];
};
export type GetProjectsByProjectIdResultsDownloadcodedcsvallrespondentsApiResponse = unknown;
export type GetProjectsByProjectIdResultsDownloadcodedcsvallrespondentsApiArg = {
  projectId: number;
  positionFilter?: number;
  surveyGroupIds?: string[];
  selectedSurveyConfigIds?: string[];
};
export type PostProjectsByProjectIdResultsDownloadcrosstabsApiResponse = unknown;
export type PostProjectsByProjectIdResultsDownloadcrosstabsApiArg = {
  projectId: number;
  crossTabParams: CrossTabParams;
};
export type PostProjectsByProjectIdResultsDownloadscorecardcsvApiResponse = unknown;
export type PostProjectsByProjectIdResultsDownloadscorecardcsvApiArg = {
  projectId: number;
  downloadScorecardParams: DownloadScorecardParams;
};
export type PostProjectsByProjectIdResultsGetcrosstabdataApiResponse =
  /** status 200 Success */ CrossTabsDto;
export type PostProjectsByProjectIdResultsGetcrosstabdataApiArg = {
  projectId: number;
  crossTabParams: CrossTabParams;
};
export type GetProjectsByProjectIdResultsGetcrosstabdataApiResponse =
  /** status 200 Success */ CrossTabsDto;
export type GetProjectsByProjectIdResultsGetcrosstabdataApiArg = {
  projectId: number;
  resultContextId?: string;
  segmentIds?: string[];
  surveyGroupIds?: string[];
  lineItemIds?: string[];
  fullCompletesOnly?: boolean;
  positionFilter?: number;
  significanceLevel?: number;
  secondarySignificanceLevel?: number;
};
export type PostProjectsByProjectIdResultsGetscorecarddataApiResponse =
  /** status 200 Success */ ScorecardDataDto;
export type PostProjectsByProjectIdResultsGetscorecarddataApiArg = {
  projectId: number;
  scorecardParams: ScorecardParams;
};
export type GetProjectsByProjectIdResultsGetscorecarddataApiResponse =
  /** status 200 Success */ ScorecardDataDto;
export type GetProjectsByProjectIdResultsGetscorecarddataApiArg = {
  projectId: number;
  resultContextId?: string;
  segmentIds?: string[];
  surveyGroupIds?: string[];
  fullCompletesOnly?: boolean;
  /** Read Position filter sourced from the URL query (`?readPosition=N`); null = no
    filter (all positions). 1-indexed. */
  positionFilter?: number;
  significanceLevel?: number;
  /** The looser (secondary) significance level, when the user picks a second confidence level.
    Null (the default) preserves single-level behaviour; never defaulted to a value. */
  secondarySignificanceLevel?: number;
};
export type PostProjectsByProjectIdResultsExploreresultsApiResponse =
  /** status 200 Success */ ExploreResponseRead;
export type PostProjectsByProjectIdResultsExploreresultsApiArg = {
  projectId: number;
  exploreProjectApiRequest: ExploreProjectApiRequest;
};
export type GetProjectsByProjectIdResultsExploreresultsApiResponse =
  /** status 200 Success */ ExploreResponseRead;
export type GetProjectsByProjectIdResultsExploreresultsApiArg = {
  projectId: number;
  resultContextId?: string;
  segmentIds?: string[];
  surveyGroupIds?: string[];
  fullCompletesOnly?: boolean;
  positionFilter?: number;
};
export type PostProjectsByProjectIdResultsGetsummaryApiResponse =
  /** status 200 Success */ GetSummaryResponse;
export type PostProjectsByProjectIdResultsGetsummaryApiArg = {
  projectId: number;
  getSummaryProjectApiRequest: GetSummaryProjectApiRequest;
};
export type PostProjectsByProjectIdResultsGetbatchsummaryApiResponse =
  /** status 200 Success */ GetBatchSummaryResponse;
export type PostProjectsByProjectIdResultsGetbatchsummaryApiArg = {
  projectId: number;
  getBatchSummaryProjectApiRequest: GetBatchSummaryProjectApiRequest;
};
export type GetProjectsByProjectIdResultsPenaltyanalysisApiResponse =
  /** status 200 Success */ PenaltyAnalysisDto;
export type GetProjectsByProjectIdResultsPenaltyanalysisApiArg = {
  projectId: number;
  resultContextId?: string;
  segmentIds?: string[];
  surveyGroupIds?: string[];
  fullCompletesOnly?: boolean;
  /** Read Position filter sourced from the URL query (`?readPosition=N`); null = no
    filter (all positions). 1-indexed. */
  positionFilter?: number;
  significanceLevel?: number;
};
export type PostProjectsByProjectIdResultsGetpenaltyanalysisApiResponse =
  /** status 200 Success */ PenaltyAnalysisDto;
export type PostProjectsByProjectIdResultsGetpenaltyanalysisApiArg = {
  projectId: number;
  penaltyParams: PenaltyParams;
};
export type PostProjectsByProjectIdResultsDownloadpenaltyanalysisApiResponse = unknown;
export type PostProjectsByProjectIdResultsDownloadpenaltyanalysisApiArg = {
  projectId: number;
  penaltyParams: PenaltyParams;
};
export type PostProjectsByProjectIdResultsAlienationanalysisApiResponse =
  /** status 200 Success */ AlienationAnalysisResponse;
export type PostProjectsByProjectIdResultsAlienationanalysisApiArg = {
  projectId: number;
  resultContextId?: string;
  controlSurveyGroupId?: string;
  testSurveyGroupId?: string;
  segmentIds?: string[];
  fullCompletesOnly?: boolean;
  /** Read Position filter sourced from the URL query (`?readPosition=N`); null = no
    filter (all positions). 1-indexed. */
  positionFilter?: number;
};
export type GetProjectsByProjectIdResultsAlienationanalysisApiResponse =
  /** status 200 Success */ AlienationAnalysisResponse;
export type GetProjectsByProjectIdResultsAlienationanalysisApiArg = {
  projectId: number;
  resultContextId?: string;
  controlSurveyGroupId?: string;
  testSurveyGroupId?: string;
  segmentIds?: string[];
  fullCompletesOnly?: boolean;
  /** Read Position filter sourced from the URL query (`?readPosition=N`); null = no
    filter (all positions). 1-indexed. */
  positionFilter?: number;
};
export type GetProjectsByProjectIdResultsDescribeApiResponse =
  /** status 200 Success */ ProjectDescriptionResponse;
export type GetProjectsByProjectIdResultsDescribeApiArg = {
  projectId: number;
  resultContextId?: string;
};
export type GetProjectsByProjectIdResultsmetaApiResponse = /** status 200 Success */ ResultsMeta;
export type GetProjectsByProjectIdResultsmetaApiArg = {
  projectId: number;
};
export type PutProjectsByProjectIdResultsmetaApiResponse = /** status 200 Success */ ResultsMeta;
export type PutProjectsByProjectIdResultsmetaApiArg = {
  projectId: number;
  resultsMeta: ResultsMeta;
};
export type GetProjectsByProjectIdSegmentsAllowedopsApiResponse =
  /** status 200 Success */ SegmentRuleAllowedOps[];
export type GetProjectsByProjectIdSegmentsAllowedopsApiArg = {
  projectId: number;
};
export type GetProjectsByProjectIdSegmentsApiResponse = /** status 200 Success */ Segment[];
export type GetProjectsByProjectIdSegmentsApiArg = {
  projectId: number;
};
export type GetProjectsByProjectIdSegmentsEnabledApiResponse = /** status 200 Success */ Segment[];
export type GetProjectsByProjectIdSegmentsEnabledApiArg = {
  projectId: number;
};
export type GetProjectsByProjectIdSegmentsAndSegmentIdCountsApiResponse =
  /** status 200 Success */ SegmentCount;
export type GetProjectsByProjectIdSegmentsAndSegmentIdCountsApiArg = {
  projectId: number;
  segmentId: string;
};
export type PutProjectsByProjectIdSegmentsUpsertApiResponse = /** status 200 Success */ Segment;
export type PutProjectsByProjectIdSegmentsUpsertApiArg = {
  projectId: number;
  segment: Segment;
};
export type PostProjectsByProjectIdSegmentsBackfillDefaultSegmentsApiResponse = unknown;
export type PostProjectsByProjectIdSegmentsBackfillDefaultSegmentsApiArg = {
  projectId: number;
};
export type DeleteProjectsByProjectIdSegmentsAndIdApiResponse = unknown;
export type DeleteProjectsByProjectIdSegmentsAndIdApiArg = {
  projectId: number;
  id: string;
};
export type PostProjectsByProjectIdShareLinksApiResponse = /** status 200 Success */ ShareLink[];
export type PostProjectsByProjectIdShareLinksApiArg = {
  projectId: number;
};
export type GetProjectsByProjectIdShareLinksApiResponse = /** status 200 Success */ ShareLink[];
export type GetProjectsByProjectIdShareLinksApiArg = {
  projectId: number;
};
export type DeleteProjectsByProjectIdShareLinksApiResponse = unknown;
export type DeleteProjectsByProjectIdShareLinksApiArg = {
  projectId: number;
};
export type GetShareLinksByPublicIdApiResponse = /** status 200 Success */ ShareLink;
export type GetShareLinksByPublicIdApiArg = {
  publicId: string;
};
export type PatchShareLinksByIdApiResponse = unknown;
export type PatchShareLinksByIdApiArg = {
  id: string;
  patchShareLinkRequest: PatchShareLinkRequest;
};
export type PostShipmentsApiResponse = /** status 200 Success */ Shipment;
export type PostShipmentsApiArg = {
  shipment: Shipment;
};
export type PutShipmentsApiResponse = /** status 200 Success */ Shipment;
export type PutShipmentsApiArg = {
  shipment: Shipment;
};
export type PostShipmentsByShipmentIdDeliveryConfirmationApiResponse =
  /** status 200 Success */ DeliveryReceipt[];
export type PostShipmentsByShipmentIdDeliveryConfirmationApiArg = {
  shipmentId: number;
  deliveryConfirmationRequest: DeliveryConfirmationRequest;
};
export type PostShipmentsByShipmentIdAssetsApiResponse = /** status 200 Success */ ShipmentAsset[];
export type PostShipmentsByShipmentIdAssetsApiArg = {
  shipmentId: number;
  body: {
    files?: Blob[];
    description?: string;
  };
};
export type GetShipmentsByShipmentIdAssetsApiResponse = /** status 200 Success */ ShipmentAsset[];
export type GetShipmentsByShipmentIdAssetsApiArg = {
  shipmentId: number;
};
export type DeleteShipmentsByShipmentIdAssetsAndShipmentAssetIdApiResponse = unknown;
export type DeleteShipmentsByShipmentIdAssetsAndShipmentAssetIdApiArg = {
  shipmentId: number;
  shipmentAssetId: string;
};
export type GetShowlogicsAllowedopsApiResponse =
  /** status 200 Success */ ShowLogicAllowedOpsResponse;
export type GetShowlogicsAllowedopsApiArg = void;
export type GetSurveyconfigsBySurveyConfigIdShowlogicsApiResponse =
  /** status 200 Success */ ShowLogic[];
export type GetSurveyconfigsBySurveyConfigIdShowlogicsApiArg = {
  surveyConfigId: string;
};
export type GetSurveyconfigsBySurveyConfigIdShowlogicsAndIdApiResponse =
  /** status 200 Success */ ShowLogic;
export type GetSurveyconfigsBySurveyConfigIdShowlogicsAndIdApiArg = {
  surveyConfigId: string;
  id: string;
};
export type PutSurveyconfigsBySurveyConfigIdShowlogicsAndIdApiResponse =
  /** status 200 Success */ ShowLogic;
export type PutSurveyconfigsBySurveyConfigIdShowlogicsAndIdApiArg = {
  surveyConfigId: string;
  id: string;
  showLogic: ShowLogic;
};
export type DeleteSurveyconfigsBySurveyConfigIdShowlogicsAndIdApiResponse = unknown;
export type DeleteSurveyconfigsBySurveyConfigIdShowlogicsAndIdApiArg = {
  surveyConfigId: string;
  id: string;
};
export type GetSurveyconfigsBySurveyConfigIdShowlogicsValidationApiResponse =
  /** status 200 Success */ ShowLogicValidationResults;
export type GetSurveyconfigsBySurveyConfigIdShowlogicsValidationApiArg = {
  surveyConfigId: string;
};
export type PostProjectsByProjectIdSurveyConfigBlocksAndSurveyConfigBlockIdSlotValuesV2ApiResponse =
  /** status 200 Success */ SlotValue;
export type PostProjectsByProjectIdSurveyConfigBlocksAndSurveyConfigBlockIdSlotValuesV2ApiArg = {
  projectId: number;
  surveyConfigBlockId: string;
  body: {
    SurveyConfigBlockId?: string;
    SlotId?: string;
    Value?: string;
    ContentType?: string;
    ContentDisposition?: string;
    Headers?: {
      [key: string]: string[];
    };
    Length?: number;
    Name?: string;
    FileName?: string;
  };
};
export type PostProjectsByProjectIdSurveyConfigBlocksAndSurveyConfigBlockIdSlotValuesBulkAssignApiResponse =
  /** status 200 Success */ SlotValue[];
export type PostProjectsByProjectIdSurveyConfigBlocksAndSurveyConfigBlockIdSlotValuesBulkAssignApiArg =
  {
    projectId: number;
    surveyConfigBlockId: string;
    body: SlotValue[];
  };
export type PostProjectsByProjectIdSurveyConfigsAndSurveyConfigIdSlotValuesApiResponse =
  /** status 200 Success */ SurveyConfigBlockSlotValues[];
export type PostProjectsByProjectIdSurveyConfigsAndSurveyConfigIdSlotValuesApiArg = {
  projectId: number;
  surveyConfigId: string;
  body: SurveyConfigBlockSlotValues[];
};
export type DeleteProjectsByProjectIdSurveyConfigBlocksAndSurveyConfigBlockIdSlotValuesSlotValueIdApiResponse =
  unknown;
export type DeleteProjectsByProjectIdSurveyConfigBlocksAndSurveyConfigBlockIdSlotValuesSlotValueIdApiArg =
  {
    projectId: number;
    surveyConfigBlockId: string;
    slotValueId: string;
  };
export type PostSolutionsApiResponse = /** status 200 Success */ Solution;
export type PostSolutionsApiArg = {
  solution: Solution;
};
export type GetSolutionsApiResponse = /** status 200 Success */ Solution[];
export type GetSolutionsApiArg = {
  hasTrialSurveys?: boolean;
  experienceId?: string;
};
export type GetProjectsByProjectIdSolutionsApiResponse = /** status 200 Success */ Solution[];
export type GetProjectsByProjectIdSolutionsApiArg = {
  projectId: number;
};
export type PatchSolutionsBySolutionIdApiResponse = /** status 200 Success */ Solution;
export type PatchSolutionsBySolutionIdApiArg = {
  solutionId: string;
  updateSolutionRequest: UpdateSolutionRequest;
};
export type GetSolutionsBySolutionIdOrgAndOrgIdCountApiResponse = /** status 200 Success */ number;
export type GetSolutionsBySolutionIdOrgAndOrgIdCountApiArg = {
  solutionId: string;
  orgId: number;
};
export type GetSolutionsBySolutionIdCountApiResponse = /** status 200 Success */ number;
export type GetSolutionsBySolutionIdCountApiArg = {
  solutionId: string;
  includeHighlightOrgProjects?: boolean;
};
export type GetSolutionsUseCasesApiResponse = /** status 200 Success */ string[];
export type GetSolutionsUseCasesApiArg = void;
export type GetSolutionsBySolutionIdSurveyDesignsApiResponse =
  /** status 200 Success */ SolutionSurveyDesign[];
export type GetSolutionsBySolutionIdSurveyDesignsApiArg = {
  solutionId: string;
};
export type PostSolutionsBySolutionIdSurveyDesignsAssignApiResponse =
  /** status 200 Success */ SolutionSurveyDesign[];
export type PostSolutionsBySolutionIdSurveyDesignsAssignApiArg = {
  solutionId: string;
  body: AssignSolutionSurveyDesign[];
};
export type PostFieldingGroupsByFieldingGroupIdStepsApiResponse =
  /** status 200 Success */ StepBase;
export type PostFieldingGroupsByFieldingGroupIdStepsApiArg = {
  fieldingGroupId: string;
  stepBase: StepBase;
};
export type GetFieldingGroupsByFieldingGroupIdStepsApiResponse =
  /** status 200 Success */ StepBase[];
export type GetFieldingGroupsByFieldingGroupIdStepsApiArg = {
  fieldingGroupId: string;
};
export type PatchFieldingGroupsByFieldingGroupIdStepsAndStepIdApiResponse =
  /** status 200 Success */ StepBase;
export type PatchFieldingGroupsByFieldingGroupIdStepsAndStepIdApiArg = {
  fieldingGroupId: string;
  stepId: string;
  stepBase: StepBase;
};
export type DeleteFieldingGroupsByFieldingGroupIdStepsAndStepIdApiResponse = unknown;
export type DeleteFieldingGroupsByFieldingGroupIdStepsAndStepIdApiArg = {
  fieldingGroupId: string;
  stepId: string;
};
export type PatchFieldingGroupsByFieldingGroupIdStepsUpdateOrdinalsApiResponse =
  /** status 200 Success */ StepBase[];
export type PatchFieldingGroupsByFieldingGroupIdStepsUpdateOrdinalsApiArg = {
  fieldingGroupId: string;
  body: StepBase[];
};
export type PostFieldingGroupsByFieldingGroupIdStepsGroupApiResponse =
  /** status 200 Success */ StepBase;
export type PostFieldingGroupsByFieldingGroupIdStepsGroupApiArg = {
  fieldingGroupId: string;
  createGroupRequest: CreateGroupRequest;
};
export type GetProjectsByProjectIdSurveyBundlesApiResponse =
  /** status 200 Success */ SurveyBundle[];
export type GetProjectsByProjectIdSurveyBundlesApiArg = {
  projectId: number;
};
export type PostProjectsByProjectIdSurveyBundlesApiResponse =
  /** status 200 Success */ SurveyBundle;
export type PostProjectsByProjectIdSurveyBundlesApiArg = {
  projectId: number;
  surveyBundle: SurveyBundle;
};
export type PutProjectsByProjectIdSurveyBundlesAndSurveyBundleIdApiResponse =
  /** status 200 Success */ SurveyBundle;
export type PutProjectsByProjectIdSurveyBundlesAndSurveyBundleIdApiArg = {
  projectId: number;
  surveyBundleId: string;
  surveyBundle: SurveyBundle;
};
export type GetSurveyConfigBlockGroupsApiResponse =
  /** status 200 Success */ SurveyConfigBlockGroup[];
export type GetSurveyConfigBlockGroupsApiArg = {
  surveyConfigId?: string;
};
export type PostSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsCreateAndReorderApiResponse =
  /** status 200 Success */ SurveyConfigBlockGroup;
export type PostSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsCreateAndReorderApiArg = {
  surveyConfigId: string;
  surveyConfigBlockGroup: SurveyConfigBlockGroup;
};
export type PostSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsCreateMatrixGroupApiResponse =
  /** status 200 Success */ SurveyConfigBlockGroup;
export type PostSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsCreateMatrixGroupApiArg = {
  surveyConfigId: string;
  matrixBlockRequest: MatrixBlockRequest;
};
export type PostSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdAddMatrixBlockApiResponse =
  /** status 200 Success */ SurveyConfigBlockGroup;
export type PostSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdAddMatrixBlockApiArg =
  {
    surveyConfigId: string;
    surveyConfigBlockGroupId: string;
    addMatrixBlockRequest: AddMatrixBlockRequest;
  };
export type PostSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdPreviewApiResponse =
  /** status 200 Success */ PreviewResponse;
export type PostSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdPreviewApiArg =
  {
    surveyConfigId: string;
    surveyConfigBlockGroupId: string;
  };
export type DeleteSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdApiResponse =
  unknown;
export type DeleteSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdApiArg =
  {
    surveyConfigId: string;
    surveyConfigBlockGroupId: string;
  };
export type PatchSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdNameApiResponse =
  /** status 200 Success */ SurveyConfigBlockGroup;
export type PatchSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdNameApiArg =
  {
    surveyConfigId: string;
    surveyConfigBlockGroupId: string;
    updateNameRequest: UpdateNameRequest;
  };
export type PatchSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdAreQuestionsRequiredApiResponse =
  /** status 200 Success */ SurveyConfigBlockGroup;
export type PatchSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdAreQuestionsRequiredApiArg =
  {
    surveyConfigId: string;
    surveyConfigBlockGroupId: string;
    updateAreQuestionsRequiredRequest: UpdateAreQuestionsRequiredRequest;
  };
export type PatchSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdBehaviorsApiResponse =
  /** status 200 Success */ SurveyConfigBlockGroup;
export type PatchSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdBehaviorsApiArg =
  {
    surveyConfigId: string;
    surveyConfigBlockGroupId: string;
    body: BlockGroupBehaviorValue[];
  };
export type PatchSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdBlockIdsApiResponse =
  /** status 200 Success */ SurveyConfigBlockGroup;
export type PatchSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdBlockIdsApiArg =
  {
    surveyConfigId: string;
    surveyConfigBlockGroupId: string;
    body: string[];
  };
export type PostSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdCloneApiResponse =
  /** status 200 Success */ SurveyConfigBlockGroup;
export type PostSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdCloneApiArg =
  {
    surveyConfigId: string;
    surveyConfigBlockGroupId: string;
  };
export type GetProjectsByProjectIdSurveyConfigsAndSurveyConfigIdBlocksApiResponse =
  /** status 200 Success */ SurveyConfigBlock[];
export type GetProjectsByProjectIdSurveyConfigsAndSurveyConfigIdBlocksApiArg = {
  projectId: number;
  surveyConfigId: string;
};
export type PutProjectsByProjectIdSurveyConfigsAndSurveyConfigIdBlocksApiResponse =
  /** status 200 Success */ SurveyConfigBlock[];
export type PutProjectsByProjectIdSurveyConfigsAndSurveyConfigIdBlocksApiArg = {
  projectId: number;
  surveyConfigId: string;
  body: SurveyConfigBlock[];
};
export type PutProjectsByProjectIdSurveyConfigsAndSurveyConfigIdBlocksSurveyConfigBlockIdApiResponse =
  /** status 200 Success */ SurveyConfigBlock;
export type PutProjectsByProjectIdSurveyConfigsAndSurveyConfigIdBlocksSurveyConfigBlockIdApiArg = {
  projectId: number;
  surveyConfigId: string;
  surveyConfigBlockId: string;
  surveyConfigBlock: SurveyConfigBlock;
};
export type PostProjectsByProjectIdSurveyConfigsAndSurveyConfigIdBlocksAssignApiResponse =
  /** status 200 Success */ SurveyConfigBlock[];
export type PostProjectsByProjectIdSurveyConfigsAndSurveyConfigIdBlocksAssignApiArg = {
  projectId: number;
  surveyConfigId: string;
  body: AssignConfigBlockRequest[];
};
export type PostProjectsByProjectIdSurveyConfigsAndSurveyConfigIdBlocksSurveyConfigBlockIdCustomizeApiResponse =
  /** status 200 Success */ SurveyConfigBlock[];
export type PostProjectsByProjectIdSurveyConfigsAndSurveyConfigIdBlocksSurveyConfigBlockIdCustomizeApiArg =
  {
    projectId: number;
    surveyConfigId: string;
    surveyConfigBlockId: string;
    customizeSurveyConfigBlockRequest: CustomizeSurveyConfigBlockRequest;
  };
export type PostProjectsByProjectIdSurveyConfigsAndSurveyConfigIdBlocksSurveyConfigBlockIdPreviewApiResponse =
  /** status 200 Success */ PreviewResponse;
export type PostProjectsByProjectIdSurveyConfigsAndSurveyConfigIdBlocksSurveyConfigBlockIdPreviewApiArg =
  {
    projectId: number;
    surveyConfigId: string;
    surveyConfigBlockId: string;
  };
export type PostSurveyConfigsBySurveyConfigIdBlocksAndSurveyConfigBlockIdCloneApiResponse =
  /** status 200 Success */ SurveyConfigBlock;
export type PostSurveyConfigsBySurveyConfigIdBlocksAndSurveyConfigBlockIdCloneApiArg = {
  surveyConfigId: string;
  surveyConfigBlockId: string;
};
export type PatchProjectsByProjectIdSurveyConfigsAndSurveyConfigIdBlocksOrdinalsApiResponse =
  /** status 200 Success */ SurveyConfigBlock[];
export type PatchProjectsByProjectIdSurveyConfigsAndSurveyConfigIdBlocksOrdinalsApiArg = {
  projectId: number;
  surveyConfigId: string;
  body: SurveyConfigBlock[];
};
export type PostProjectsByProjectIdSurveyConfigsAndSurveyConfigIdQuestionsSurveyConfigQuestionIdChoicesSurveyConfigQuestionChoiceIdApiResponse =
  /** status 200 Success */ SurveyConfigQuestionChoice;
export type PostProjectsByProjectIdSurveyConfigsAndSurveyConfigIdQuestionsSurveyConfigQuestionIdChoicesSurveyConfigQuestionChoiceIdApiArg =
  {
    projectId: number;
    surveyConfigId: string;
    surveyConfigQuestionId: string;
    surveyConfigQuestionChoiceId: string;
    body: {
      Id?: string;
      SurveyConfigQuestionId?: string;
      'QuestionDesignChoice.Id'?: string;
      'QuestionDesignChoice.QuestionDesignId'?: string;
      'QuestionDesignChoice.Label'?: string;
      'QuestionDesignChoice.Ordinal'?: number;
      'QuestionDesignChoice.Type'?: string;
      'QuestionDesignChoice.CreatedAt'?: string;
      'QuestionDesignChoice.CreatedBy'?: string;
      'QuestionDesignChoice.UpdatedAt'?: string;
      'QuestionDesignChoice.UpdatedBy'?: string;
      AssetId?: string;
      ExternalUrl?: string;
      AltText?: string;
      ContentType?: string;
      ContentDisposition?: string;
      Headers?: {
        [key: string]: string[];
      };
      Length?: number;
      Name?: string;
      FileName?: string;
    };
  };
export type GetProjectsByProjectIdSurveyConfigsAndSurveyConfigIdQuestionsSurveyConfigQuestionIdRoutingsApiResponse =
  /** status 200 Success */ SurveyConfigQuestionRouting[];
export type GetProjectsByProjectIdSurveyConfigsAndSurveyConfigIdQuestionsSurveyConfigQuestionIdRoutingsApiArg =
  {
    projectId: number;
    surveyConfigId: string;
    surveyConfigQuestionId: string;
  };
export type GetProjectsByProjectIdSurveyConfigsAndSurveyConfigIdRoutingsApiResponse =
  /** status 200 Success */ SurveyConfigQuestionRouting[];
export type GetProjectsByProjectIdSurveyConfigsAndSurveyConfigIdRoutingsApiArg = {
  projectId: number;
  surveyConfigId: string;
};
export type GetProjectsByProjectIdSurveyConfigsApiResponse =
  /** status 200 Success */ SurveyConfigDtoRead[];
export type GetProjectsByProjectIdSurveyConfigsApiArg = {
  projectId: number;
  surveyType?: string;
};
export type GetSurveyConfigsApiResponse = /** status 200 Success */ SurveyConfigDtoRead[];
export type GetSurveyConfigsApiArg = {
  surveyType?: string;
  projectType?: string;
  teamId?: number;
};
export type PostProjectsByProjectIdSurveyConfigsConfigureApiResponse =
  /** status 200 Success */ SurveyConfigDtoRead;
export type PostProjectsByProjectIdSurveyConfigsConfigureApiArg = {
  projectId: number;
  configureSurveyByTypeRequest: ConfigureSurveyByTypeRequest;
};
export type PostProjectsByProjectIdSurveyConfigsConfigurescreenerv2ApiResponse =
  /** status 200 Success */ SurveyConfigDtoRead;
export type PostProjectsByProjectIdSurveyConfigsConfigurescreenerv2ApiArg = {
  projectId: number;
  configureScreenerSurveyV2Request: ConfigureScreenerSurveyV2Request;
};
export type PostProjectsByProjectIdSurveyConfigsAndSurveyConfigIdMaterializeApiResponse =
  /** status 200 Success */ SurveyConfigRead;
export type PostProjectsByProjectIdSurveyConfigsAndSurveyConfigIdMaterializeApiArg = {
  projectId: number;
  surveyConfigId: string;
  materializeSurveyRequest: MaterializeSurveyRequest;
};
export type PostProjectsByProjectIdSurveyConfigsAndSurveyConfigIdPreviewApiResponse =
  /** status 200 Success */ PreviewResponse;
export type PostProjectsByProjectIdSurveyConfigsAndSurveyConfigIdPreviewApiArg = {
  projectId: number;
  surveyConfigId: string;
  materializeSurveyRequest: MaterializeSurveyRequest;
};
export type PostProjectsByProjectIdSurveyConfigsCopySurveyContentApiResponse =
  /** status 200 Success */ SurveyConfigBlock[];
export type PostProjectsByProjectIdSurveyConfigsCopySurveyContentApiArg = {
  projectId: number;
  surveyConfigContentCopyRequest: SurveyConfigContentCopyRequest;
};
export type PutProjectsByProjectIdSurveyConfigsAndSurveyConfigIdApiResponse =
  /** status 200 Success */ SurveyConfigRead;
export type PutProjectsByProjectIdSurveyConfigsAndSurveyConfigIdApiArg = {
  projectId: number;
  surveyConfigId: string;
  surveyConfig: SurveyConfig;
};
export type GetProjectsByProjectIdFileAnswersApiResponse = /** status 200 Success */ ProjectZipJobs;
export type GetProjectsByProjectIdFileAnswersApiArg = {
  projectId: number;
};
export type PostProjectsByProjectIdFileAnswersApiResponse = /** status 200 Success */ ZipJobWithUrl;
export type PostProjectsByProjectIdFileAnswersApiArg = {
  projectId: number;
  createFileAnswerZipRequest: CreateFileAnswerZipRequest;
};
export type GetProjectsByProjectIdSurveyGroupsApiResponse =
  /** status 200 Success */ SurveyGroupDto[];
export type GetProjectsByProjectIdSurveyGroupsApiArg = {
  projectId: number;
};
export type PutProjectsByProjectIdSurveyGroupsApiResponse = unknown;
export type PutProjectsByProjectIdSurveyGroupsApiArg = {
  projectId: number;
  body: SurveyGroupDto[];
};
export type GetProjectsByProjectIdSurveyGroupsEnabledApiResponse =
  /** status 200 Success */ SurveyGroup[];
export type GetProjectsByProjectIdSurveyGroupsEnabledApiArg = {
  projectId: number;
};
export type GetProjectsByProjectIdSurveyGroupsSeparableApiResponse =
  /** status 200 Success */ SurveyGroupSeparabilityResponse;
export type GetProjectsByProjectIdSurveyGroupsSeparableApiArg = {
  projectId: number;
};
export type GetProjectsByProjectIdSurveyGroupsProductGroupsApiResponse =
  /** status 200 Success */ ProductGroupDto[];
export type GetProjectsByProjectIdSurveyGroupsProductGroupsApiArg = {
  projectId: number;
};
export type PutProjectsByProjectIdSurveyGroupsProductGroupsApiResponse =
  /** status 200 Success */ ProductGroupDto;
export type PutProjectsByProjectIdSurveyGroupsProductGroupsApiArg = {
  projectId: number;
  productGroupDto: ProductGroupDto;
};
export type DeleteProjectsByProjectIdSurveyGroupsProductGroupsAndProductGroupIdApiResponse =
  unknown;
export type DeleteProjectsByProjectIdSurveyGroupsProductGroupsAndProductGroupIdApiArg = {
  projectId: number;
  productGroupId: string;
};
export type PatchProjectsByProjectIdSurveyGroupsAndSurveyGroupIdColorApiResponse = unknown;
export type PatchProjectsByProjectIdSurveyGroupsAndSurveyGroupIdColorApiArg = {
  projectId: number;
  surveyGroupId: string;
  setSurveyGroupColorRequest: SetSurveyGroupColorRequest;
};
export type GetProjectsByProjectIdSurveyGroupsProjectIndexLegendApiResponse =
  /** status 200 Success */ ProjectIndexLegendItem[];
export type GetProjectsByProjectIdSurveyGroupsProjectIndexLegendApiArg = {
  projectId: number;
};
export type GetProjectsByProjectIdSurveyQuestionsProfilequestionsApiResponse =
  /** status 200 Success */ Question[];
export type GetProjectsByProjectIdSurveyQuestionsProfilequestionsApiArg = {
  projectId: number;
  visibleOnly?: boolean;
};
export type GetProjectsByProjectIdSurveyQuestionsResponsetagsApiResponse =
  /** status 200 Success */ SurveyResponseTags[];
export type GetProjectsByProjectIdSurveyQuestionsResponsetagsApiArg = {
  projectId: number;
};
export type GetProjectsByProjectIdSurveyQuestionsQuestiongroupsApiResponse =
  /** status 200 Success */ SurveyQuestionGroup[];
export type GetProjectsByProjectIdSurveyQuestionsQuestiongroupsApiArg = {
  projectId: number;
};
export type PostTeamsApiResponse = /** status 200 Success */ Team;
export type PostTeamsApiArg = {
  team: Team;
};
export type GetTeamsApiResponse = /** status 200 Success */ Team[];
export type GetTeamsApiArg = {
  organizationId?: number;
  includeDeleted?: boolean;
};
export type GetTeamsByTeamIdApiResponse = /** status 200 Success */ Team;
export type GetTeamsByTeamIdApiArg = {
  teamId: number;
};
export type PutTeamsByTeamIdApiResponse = /** status 200 Success */ Team;
export type PutTeamsByTeamIdApiArg = {
  teamId: string;
  team: Team;
};
export type DeleteTeamsByTeamIdApiResponse = unknown;
export type DeleteTeamsByTeamIdApiArg = {
  teamId: number;
};
export type GetTeamsByTeamIdSubscriptionsApiResponse =
  /** status 200 Success */ EnrichedSubscription[];
export type GetTeamsByTeamIdSubscriptionsApiArg = {
  teamId: number;
};
export type PostTeamsByTeamIdSubscriptionsApiResponse = /** status 200 Success */ Subscription;
export type PostTeamsByTeamIdSubscriptionsApiArg = {
  teamId: number;
  subscriptionRequest: SubscriptionRequest;
};
export type PutTeamsByTeamIdSubscriptionsAndSubscriptionIdApiResponse =
  /** status 200 Success */ Subscription;
export type PutTeamsByTeamIdSubscriptionsAndSubscriptionIdApiArg = {
  teamId: number;
  subscriptionId: number;
  subscriptionRequest: SubscriptionRequest;
};
export type DeleteTeamsByTeamIdSubscriptionsAndSubscriptionIdApiResponse = unknown;
export type DeleteTeamsByTeamIdSubscriptionsAndSubscriptionIdApiArg = {
  teamId: number;
  subscriptionId: number;
};
export type GetTeamsByTeamIdSubscriptionBalanceApiResponse =
  /** status 200 Success */ SubscriptionBalance;
export type GetTeamsByTeamIdSubscriptionBalanceApiArg = {
  teamId: number;
};
export type GetTestCategoriesApiResponse = /** status 200 Success */ TestCategory[];
export type GetTestCategoriesApiArg = void;
export type GetTestClassificationsApiResponse = /** status 200 Success */ TestClassification[];
export type GetTestClassificationsApiArg = {
  testCategoryId?: string;
};
export type GetProjectsByProjectIdTestDesignApiResponse = /** status 200 Success */ TestDesign;
export type GetProjectsByProjectIdTestDesignApiArg = {
  projectId: number;
};
export type PutProjectsByProjectIdTestDesignApiResponse = /** status 200 Success */ TestDesign;
export type PutProjectsByProjectIdTestDesignApiArg = {
  projectId: number;
  upsertTestDesignRequest: UpsertTestDesignRequest;
};
export type GetProjectsByProjectIdTestGroupsApiResponse = /** status 200 Success */ TestGroupV10[];
export type GetProjectsByProjectIdTestGroupsApiArg = {
  projectId: number;
};
export type PostProjectsByProjectIdTestGroupsApiResponse = /** status 200 Success */ TestGroupV10;
export type PostProjectsByProjectIdTestGroupsApiArg = {
  projectId: number;
  createTestGroupV10Request: CreateTestGroupV10Request;
};
export type PatchProjectsByProjectIdTestGroupsAndTestGroupIdApiResponse =
  /** status 200 Success */ TestGroupV10;
export type PatchProjectsByProjectIdTestGroupsAndTestGroupIdApiArg = {
  projectId: number;
  testGroupId: string;
  updateTestGroupV10Request: UpdateTestGroupV10Request;
};
export type DeleteProjectsByProjectIdTestGroupsAndTestGroupIdApiResponse = unknown;
export type DeleteProjectsByProjectIdTestGroupsAndTestGroupIdApiArg = {
  projectId: number;
  testGroupId: string;
  deleteTestGroupV10Request: DeleteTestGroupV10Request;
};
export type PostProjectsByProjectIdTestGroupsBulkApiResponse =
  /** status 200 Success */ TestGroupV10[];
export type PostProjectsByProjectIdTestGroupsBulkApiArg = {
  projectId: number;
  bulkTestGroupV10Request: BulkTestGroupV10Request;
};
export type Admin = {
  id?: number;
  emailAddress?: string | null;
  firstName?: string | null;
  lastName?: string | null;
};
export type CreateAdminRequest = {
  emailAddress?: string | null;
  firstName?: string | null;
  lastName?: string | null;
};
export type AggregationType = {
  slug?: string | null;
  display?: string | null;
  aggregationGroup?: string | null;
  showInCrossTab?: boolean;
  isProportion?: boolean;
};
export type ProjectAttachment = {
  projectAttachmentId?: string | null;
  assetId?: string;
  name?: string | null;
  description?: string | null;
  url?: string | null;
  downloadUrl?: string | null;
};
export type AudienceBuilderAnswer = {
  values?: string[] | null;
  ageMin?: number | null;
  ageMax?: number | null;
};
export type AudienceBuilderQuotaPartition = {
  answers?: AudienceBuilderAnswer;
  min?: number | null;
  max?: number | null;
};
export type AudienceBuilderQuota = {
  id?: string | null;
  type?: string | null;
  key?: string | null;
  description?: string | null;
  partitions?: AudienceBuilderQuotaPartition[] | null;
  hasCustomQuestions?: boolean;
};
export type KeyValuePair602 = {
  key?: string | null;
  value?: string | null;
};
export type AudienceBuilderTestGroupTask = {
  type?: string | null;
  target?: number;
};
export type AudienceBuilderTestGroupProduct = {
  productId?: number;
  order?: number | null;
  countPerTester?: number;
  name?: string | null;
  recipientName?: string | null;
};
export type AudienceBuilderTestGroup = {
  id?: string | null;
  name?: string | null;
  target?: number;
  placements?: number;
  status?: string | null;
  quotas?: AudienceBuilderQuota[] | null;
  customData?: KeyValuePair602[] | null;
  tasks?: AudienceBuilderTestGroupTask[] | null;
  products?: AudienceBuilderTestGroupProduct[] | null;
  surveys?: string[] | null;
  hasCriteria?: boolean;
  recruitSource?: string | null;
};
export type AudienceBuilderLegacyAudience = {
  projectId?: number;
  target?: number;
  placements?: number;
  conceptsPerRespondent?: number | null;
  testGroups?: AudienceBuilderTestGroup[] | null;
};
export type AudienceBuilderScreenerResponse = {
  responseText?: string | null;
  assetId?: string | null;
  result?: string | null;
};
export type AudienceBuilderScreenerQuestion = {
  questionText?: string | null;
  assetId?: string | null;
  order?: number;
  responses?: AudienceBuilderScreenerResponse[] | null;
};
export type AudienceBuilderScreenerQuestionGroup = {
  quotaId?: string | null;
  customTag?: string | null;
  questions?: AudienceBuilderScreenerQuestion[] | null;
  managedByHighlight?: boolean;
};
export type AudienceBuilderAudienceBuilderAudience = {
  version?: number;
  isEditDisabled?: boolean;
  legacyAudience?: AudienceBuilderLegacyAudience;
  customScreenerQuestions?: AudienceBuilderScreenerQuestionGroup[] | null;
};
export type AudienceAttachmentResponse = {
  id?: string;
};
export type AssetWithUrls = {
  id?: string | null;
  name?: string | null;
  url?: string | null;
  downloadUrl?: string | null;
};
export type AudienceV10 = {
  id: string;
  projectId: number;
  name: string;
  quotas: AudienceBuilderQuota[];
  /** Optimistic-concurrency token, incremented on every successful update. A caller must echo the
    version it last read on every update/delete; a mismatch fails the request. */
  version: number;
};
export type CreateAudienceV10Request = {
  name: string;
  quotas: AudienceBuilderQuota[];
};
export type UpdateAudienceV10Request = {
  id: string;
  name?: string | null;
  /** `[]` replaces the existing quotas. */
  quotas?: AudienceBuilderQuota[] | null;
  /** The version last read by the caller. Must match the current version or the update fails. */
  version: number;
};
export type DeleteAudienceV10Request = {
  id: string;
  /** The version last read by the caller. Must match the current version or the delete fails. */
  version: number;
};
export type BulkAudienceV10Request = {
  creates: CreateAudienceV10Request[];
  updates: UpdateAudienceV10Request[];
  deletes: DeleteAudienceV10Request[];
};
export type ExperienceType = 'old' | 'new';
export type CatalogSurveyRole = {
  name?: string | null;
};
export type CatalogSolutionSurveyDesign = {
  solutionSurveyDesignName?: string | null;
  surveyRole?: CatalogSurveyRole;
  vendorName?: string | null;
  isOptional?: boolean;
  ordinal?: number;
  isPerItem?: boolean;
};
export type SolutionSurveyDesign = {
  solutionSurveyDesignId?: string;
  isOptional?: boolean;
  isPerItem?: boolean;
  ordinal?: number;
  solutionSurveyDesignName?: string | null;
  surveyRoleId?: string | null;
  vendorName?: string | null;
};
export type Solution = {
  id?: string;
  name?: string | null;
  identifierName?: string | null;
  experienceType?: ExperienceType;
  surveyDesigns?: SolutionSurveyDesign[] | null;
  supportedExperiences?: Experience[] | null;
  createdAt?: string;
  updatedAt?: string | null;
  createdBy?: string | null;
  updatedBy?: string | null;
  isDeleted?: boolean | null;
  businessReason?: string | null;
  keyPhrases?: string[] | null;
  useCase?: string | null;
};
export type Experience = {
  id?: string | null;
  displayName?: string | null;
  internalName?: string | null;
  hasPhysicalGoods?: boolean;
  legacyCustomerExperience?: boolean;
  isChainedRecruiting?: boolean;
  supportedSolutions?: Solution[] | null;
};
export type CatalogSolution = {
  name?: string | null;
  identifierName?: string | null;
  experienceType?: ExperienceType;
  surveyDesigns?: CatalogSolutionSurveyDesign[] | null;
  supportedExperiences?: Experience[] | null;
  businessReason?: string | null;
  keyPhrases?: string[] | null;
  useCase?: string | null;
  isDeleted?: boolean | null;
};
export type CatalogQuestionChoice = {
  label?: string | null;
  ordinal?: number;
  type?: string | null;
};
export type CatalogQuestionDesign = {
  name?: string | null;
  questionType?: string | null;
  questionText?: string | null;
  descriptionText?: string | null;
  isArchived?: boolean;
  choices?: CatalogQuestionChoice[] | null;
};
export type CatalogSlot = {
  key?: string | null;
  slotType?: string | null;
  label?: string | null;
  placeholder?: string | null;
  isRequired?: boolean;
  canApplyAllWithinSurveys?: boolean;
  slotValueOptions?: string[] | null;
};
export type CatalogBlockBehavior = {
  questionBehavior?: string | null;
  canCustomerEdit?: boolean;
  defaultValue?: boolean;
  defaultNumericValue?: number | null;
  defaultStringValue?: string | null;
};
export type CatalogBlock = {
  questionDesign?: CatalogQuestionDesign;
  externalId?: string | null;
  name?: string | null;
  internalName?: string | null;
  description?: string | null;
  isArchived?: boolean;
  slots?: CatalogSlot[] | null;
  behaviors?: CatalogBlockBehavior[] | null;
};
export type CatalogModuleBlock = {
  blockInternalName?: string | null;
  ordinal?: number;
};
export type CatalogModule = {
  displayName?: string | null;
  internalName?: string | null;
  description?: string | null;
  infoLink?: string | null;
  showInConfigurator?: boolean;
  showInSurveyPanels?: boolean;
  hideInRecommendedPanel?: boolean;
  excludedSubjects?: string[] | null;
  excludedTestCategories?: string[] | null;
  blocks?: CatalogModuleBlock[] | null;
  isArchived?: boolean;
};
export type CatalogBlueprintKey = {
  solutionIdentifierName?: string | null;
  surveyRoleName?: string | null;
  testCategoryName?: string | null;
  subject?: string | null;
};
export type CatalogModuleConfigurationEntry = {
  moduleInternalName?: string | null;
  isDefault?: boolean;
  ordinal?: number;
};
export type CatalogModuleConfiguration = {
  key?: CatalogBlueprintKey;
  modules?: CatalogModuleConfigurationEntry[] | null;
};
export type BlueprintCatalog = {
  schemaVersion?: string | null;
  solutions?: CatalogSolution[] | null;
  surveyRoles?: CatalogSurveyRole[] | null;
  questionDesigns?: CatalogQuestionDesign[] | null;
  blocks?: CatalogBlock[] | null;
  modules?: CatalogModule[] | null;
  moduleConfigurations?: CatalogModuleConfiguration[] | null;
};
export type BlueprintCatalogApplyJob = {
  id?: string;
  createdAt?: string;
  createdBy?: string | null;
  status?: string | null;
  schemaVersion?: string | null;
  sourceSolutionsCount?: number;
  sourceSurveyRolesCount?: number;
  sourceQuestionDesignsCount?: number;
  sourceBlocksCount?: number;
  sourceModulesCount?: number;
  sourceModuleConfigurationsCount?: number;
  solutionsValidated?: number | null;
  solutionsCreated?: number | null;
  solutionsUpdated?: number | null;
  modulesValidated?: number | null;
  surveyRolesValidated?: number | null;
  testCategoriesValidated?: number | null;
  questionDesignsValidated?: number | null;
  questionDesignsCreated?: number | null;
  questionDesignsUpdated?: number | null;
  blocksValidated?: number | null;
  blocksCreated?: number | null;
  blocksUpdated?: number | null;
  modulesCreated?: number | null;
  modulesUpdated?: number | null;
  moduleConfigurationsReplaced?: number | null;
  archivedSolutions?: number | null;
  archivedQuestionDesigns?: number | null;
  archivedBlocks?: number | null;
  archivedModules?: number | null;
  errorMessage?: string | null;
};
export type CreateModuleBlockResult = {
  newModulesCount?: number;
  newBlocksCount?: number;
  existingBlocksCount?: number;
};
export type ChatMessageResponse = {
  uiMessageId: string;
  seq: number;
  role: string;
  /** The opaque AI SDK `UIMessagePart[]`, returned verbatim as stored. */
  parts: any;
  metadata?: any | null;
};
export type ChatConversationResponse = {
  id: string;
  kind: string;
  projectId?: number | null;
  personaPanelId?: string | null;
  title?: string | null;
  schemaVersion: number;
  createdAt: string;
  updatedAt?: string | null;
  messages: ChatMessageResponse[];
};
export type AppendChatMessageRequest = {
  uiMessageId: string;
  role: string;
  parts: any;
  metadata?: any | null;
};
export type UpdateChatConversationRequest = {
  title: string;
};
export type ProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
};
export type ChatConversationSummary = {
  id: string;
  kind: string;
  title?: string | null;
  createdAt: string;
  updatedAt?: string | null;
};
export type IBranding = {
  primaryColorHex?: string | null;
  slug?: string | null;
  homePageUrl?: string | null;
  accountPageUrl?: string | null;
  name?: string | null;
  logoUrl?: string | null;
  privacyPolicyUrl?: string | null;
};
export type Community = {
  id?: string;
  organizationId?: number;
  slug?: string | null;
  branding?: IBranding;
  allowedTesterCountryCodes?: string[] | null;
  participationAgreement?: string | null;
  supportEmail?: string | null;
  tagWeights?: {
    [key: string]: number;
  } | null;
  usesHardcodedHighlightProfileQuestions?: boolean;
};
export type BrandingDto = {
  primaryColorHex?: string | null;
  slug?: string | null;
  homePageUrl?: string | null;
  accountPageUrl?: string | null;
  name?: string | null;
  logoUrl?: string | null;
  privacyPolicyUrl?: string | null;
};
export type CommunityDto = {
  id?: string;
  organizationId?: number;
  slug?: string | null;
  branding?: BrandingDto;
  allowedTesterCountryCodes?: string[] | null;
  participationAgreement?: string | null;
  supportEmail?: string | null;
};
export type FeasibilityQuotaAnswers = {
  values?: string[] | null;
  ageMin?: number | null;
  ageMax?: number | null;
};
export type FeasibilityQuotaPartition = {
  min?: number;
  max?: number;
  answers?: FeasibilityQuotaAnswers;
};
export type FeasibilityQuota = {
  key?: string | null;
  type?: string | null;
  partitions?: FeasibilityQuotaPartition[] | null;
};
export type FeasibilityTestGroupTask = {
  type?: string | null;
  target?: number;
};
export type FeasibilityTestGroupProduct = {
  productId?: number;
  order?: number | null;
  countPerTester?: number;
  name?: string | null;
  recipientName?: string | null;
};
export type FeasibilityTestGroup = {
  hasCriteria?: boolean;
  /** Forwarded to Orchestrator ParticipantQuery. Soft-max quota rules scale from Placements;
    omitting it (default 0) turns soft-max partitions into hard excludes. */
  placements?: number;
  target?: number;
  quotas?: FeasibilityQuota[] | null;
  tasks?: FeasibilityTestGroupTask[] | null;
  products?: FeasibilityTestGroupProduct[] | null;
};
export type FeasibilityRecruitingFilter = {
  excludeActiveItemSurvey?: boolean | null;
  excludeActiveOptInSurvey?: boolean | null;
  excludeActiveOneOffSurvey?: boolean | null;
  excludePendingItemSurvey?: boolean | null;
  excludeItemSurveyDeadlineDateTimeRangeStart?: string | null;
  excludeItemSurveyDeadlineDateTimeRangeEnd?: string | null;
  statuses?: string[] | null;
  boxesMin?: number | null;
  boxesMax?: number | null;
  cities?: string[] | null;
  zipCodes?: string[] | null;
  includeTags?: string[] | null;
  excludeTags?: string[] | null;
  referralCode?: string | null;
  recruitableBypass?: boolean | null;
};
export type FeasibilityInternalRecruitingOptions = {
  includeHighlightEmployees?: boolean;
  sendToHighlightEmployeesOnly?: boolean;
  restrictRecruitReferralCodeIds?: string[] | null;
};
export type FeasibilityRecruitCountRequest = {
  schemaVersion?: number;
  testGroup?: FeasibilityTestGroup;
  filter?: FeasibilityRecruitingFilter;
  internalOptions?: FeasibilityInternalRecruitingOptions;
  questionsThatMustNotBeAnswered?: string[] | null;
  communitySlug?: string | null;
};
export type CustomerRegistrationResponse = {
  organizationId?: number;
  teamId?: number;
  customerId?: number;
  emailAddress?: string | null;
  message?: string | null;
};
export type CustomerRegistrationRequest = {
  firstName?: string | null;
  lastName?: string | null;
  emailAddress?: string | null;
  organizationName?: string | null;
};
export type Team = {
  teamId?: number;
  name?: string | null;
  orgId?: number;
  orgName?: string | null;
  userIdCsadmin?: number;
  createdAt?: string;
  isDeleted?: boolean;
  customerCount?: number;
  projectCount?: number;
};
export type Organization = {
  id?: number;
  name?: string | null;
  hubspotId?: string | null;
  createdAt?: string;
  customerCount?: number;
  projectCount?: number;
  teams?: Team[] | null;
  isDeleted?: boolean;
};
export type CustomerTeam = {
  id?: number;
  name?: string | null;
};
export type Customer = {
  id?: number;
  emailAddress?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  lastLogin?: string | null;
  createdAt?: string;
  createdBy?: string | null;
  updatedAt?: string | null;
  status?: string | null;
  organizationRole?: string | null;
  organization?: Organization;
  teams?: CustomerTeam[] | null;
};
export type CreateCustomerRequest = {
  emailAddress?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  organization?: Organization;
  organizationRole?: string | null;
  teams?: CustomerTeam[] | null;
};
export type UpdateCustomerRequest = {
  id?: number;
  emailAddress?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  lastLogin?: string | null;
  createdAt?: string;
  createdBy?: string | null;
  updatedAt?: string | null;
  status?: string | null;
  organizationRole?: string | null;
  organization?: Organization;
  teams?: CustomerTeam[] | null;
};
export type CustomerBatchOperationResultItem = {
  success?: boolean;
  message?: string | null;
  customer?: Customer;
  emailAddress?: string | null;
  errorType?: string | null;
};
export type CustomerBatchOperationResult = {
  totalRequested?: number;
  successful?: number;
  failed?: number;
  duplicates?: number;
  invalid?: number;
  success?: boolean;
  message?: string | null;
  items: CustomerBatchOperationResultItem[];
};
export type CreateCustomersBulkRequest = {
  emailAddresses?: string[] | null;
  organization?: Organization;
  organizationRole?: string | null;
  teams?: CustomerTeam[] | null;
};
export type CustomTopic = {
  id?: string;
  lineItemId?: string;
  name?: string | null;
  status?: string | null;
  createdAt?: string | null;
  createdBy?: string | null;
  updatedAt?: string | null;
  updatedBy?: string | null;
};
export type CreateCustomTopicRequest = {
  name?: string | null;
};
export type SurveyExpressionOp = {
  slug?: string | null;
  operand?: string | null;
  display?: string | null;
};
export type DisqualificationLogicAllowedOpsResponse = {
  lookup?: {
    [key: string]: SurveyExpressionOp[];
  } | null;
};
export type SurveyExpression = {
  id?: string | null;
  kind?: string | null;
  op?: string | null;
  children?: SurveyExpression[] | null;
  surveyConfigQuestionId?: string | null;
  variableName?: string | null;
  operandInt?: number | null;
  operandString?: string | null;
  operandChoices?: string[] | null;
};
export type DisqualificationLogic = {
  id?: string;
  surveyConfigQuestionId?: string;
  expressionTree?: SurveyExpression;
  createdAt?: string | null;
  createdBy?: string | null;
  updatedAt?: string | null;
  updatedBy?: string | null;
};
export type DisqualificationValidation = {
  surveyConfigBlockId?: string;
  messages?: string[] | null;
};
export type DisqualificationLogicValidationResults = {
  questionValidationFailures?: DisqualificationValidation[] | null;
};
export type FeasibilityEstimateResponse = {
  estimate?: any | null;
  audienceHash?: string | null;
  updatedAt?: string;
  overrideAllowProjectSubmit?: boolean;
};
export type UpsertFeasibilityEstimateRequest = {
  estimate?: any | null;
  audienceHash?: string | null;
};
export type Note = {
  userId?: number | null;
  status?: string | null;
  date?: string | null;
  content?: string | null;
};
export type InsertUser = {
  id?: number;
  firstName?: string | null;
  lastName?: string | null;
};
export type Insert = {
  insertId?: number;
  name?: string | null;
  uuid?: string;
  linkUrl?: string | null;
  mockLinkUrl?: string | null;
  notes?: Note[] | null;
  assetId?: string | null;
  asset?: AssetWithUrls;
  status?: string | null;
  projectId?: number;
  users?: InsertUser[] | null;
};
export type Allergen = {
  allergenTypeId?: number;
};
export type ProductHandlingPreference = {
  id?: string | null;
  productId?: number;
  key?: string | null;
  value?: string | null;
  createdAt?: string | null;
  createdBy?: string | null;
  updatedAt?: string | null;
  updatedBy?: string | null;
};
export type Product = {
  id?: number;
  organizationId?: number;
  /** Optimistic-concurrency token, bumped by every update, legacy PUT edits included. Ignored on
    the legacy POST/PUT bodies; Products/$bulk checks it on every update. */
  version?: number;
  /** Internal name.
    Viewed by customer and not viewed by Highlighter.
    Required in the database.
    e.g. "Pepsi 12oz Aluminum Can (2025 Branding Label)" */
  name?: string | null;
  ingredients?: string | null;
  /** Displayed to Highlighter.
    e.g. "Pepsi" */
  recipientName?: string | null;
  recipientDescription?: string | null;
  productUuid?: string;
  blindingNotes?: string | null;
  fragile?: boolean | null;
  upc?: string | null;
  returnProduct?: boolean;
  isCustomAddress?: boolean;
  isOvernightShipping?: boolean;
  returnAddress?: string | null;
  relabel?: boolean;
  relabelCode?: string | null;
  /** BlindingTypeId is a required field,
    but our database allows nulls and we have legacy data. */
  blindingTypeId?: number | null;
  blindingTypeIdArr?: number[] | null;
  categoryTypeId?: number | null;
  perishableTypeId?: number | null;
  perishableTypeName?: string | null;
  productUrl?: string | null;
  allergens?: Allergen[] | null;
  allergenNames?: string[] | null;
  /** What to do with the extra product. */
  extraProductHandling?: string | null;
  /** If the extra product should be returned, this is the address to ship to. */
  extraProductReturnAddress?: string | null;
  extraProductComments?: string | null;
  productHandlingPreferences?: ProductHandlingPreference[] | null;
  isProductBlinded?: boolean | null;
};
export type ProductListEntry = {
  id?: number;
  productListId?: number;
  productId?: number;
  quantity?: number;
  createdAt?: string;
  updatedAt?: string | null;
  product?: Product;
};
export type ProductList = {
  id?: number;
  projectId?: number;
  name?: string | null;
  instructions?: string | null;
  createdAt?: string;
  updatedAt?: string | null;
  productListEntries?: ProductListEntry[] | null;
};
export type Kit = {
  id?: number;
  name?: string | null;
  internalName?: string | null;
  productListId?: number;
  insertId?: number;
  projectId?: number;
  quantity?: number;
  uuid?: string;
  kittingInstructions?: string | null;
  boxLengthInches?: number | null;
  boxWidthInches?: number | null;
  boxHeightInches?: number | null;
  createdAt?: string;
  updatedAt?: string | null;
  highlighterIds?: string | null;
  insert?: Insert;
  productList?: ProductList;
  notes?: Note[] | null;
  /** Contains a subset of user profiles referenced in any Note[s] so they
    can be rendered by clients without requiring additional API roundtrips. */
  users?: InsertUser[] | null;
};
export type KitRead = {
  id?: number;
  name?: string | null;
  internalName?: string | null;
  productListId?: number;
  insertId?: number;
  projectId?: number;
  quantity?: number;
  uuid?: string;
  kittingInstructions?: string | null;
  boxLengthInches?: number | null;
  boxWidthInches?: number | null;
  boxHeightInches?: number | null;
  createdAt?: string;
  updatedAt?: string | null;
  highlighterIds?: string | null;
  insert?: Insert;
  productList?: ProductList;
  notes?: Note[] | null;
  /** Contains a subset of user profiles referenced in any Note[s] so they
    can be rendered by clients without requiring additional API roundtrips. */
  users?: InsertUser[] | null;
  /** Legacy Status field derived from the most recent note's Status.
    Defaults to "UPLOADED" if no notes are present. */
  status?: string | null;
};
export type FieldingGroupKit = {
  name?: string | null;
  internalName?: string | null;
  quantity?: number;
  insertId?: number;
  productListId?: number | null;
  insertAssetId?: string | null;
};
export type ProductBase = {
  id?: number;
  recipientName?: string | null;
  name?: string | null;
};
export type ProjectSurveyBase = {
  productIds?: number[] | null;
  projectId?: number;
  products?: ProductBase[] | null;
  surveyId?: number;
  surveyUuid?: string;
  surveyName?: string | null;
  surveyStatus?: string | null;
  surveyConfigId?: string | null;
  linkUrl?: string | null;
  surveyRoleId?: string | null;
  ordinal?: number | null;
};
export type FieldingGroupAssignmentBase = {
  id?: string | null;
  highlighterId?: string | null;
  customData?: KeyValuePair602[] | null;
};
export type StepBaseType = 'survey' | 'group' | 'custom';
export type StepBase = {
  id?: string;
  type?: StepBaseType;
  survey?: ProjectSurveyBase;
  surveyId?: number | null;
  duration?: number | null;
  ordinal?: number;
  groupId?: string | null;
  groupedSteps?: StepBase[] | null;
  action?: string | null;
  message?: string | null;
};
export type FieldingGroup = {
  kit?: Kit;
  surveyIds?: number[] | null;
  id?: string;
  projectId?: number;
  name?: string | null;
  internalName?: string | null;
  kitId?: number | null;
  kitInfo?: FieldingGroupKit;
  surveys?: ProjectSurveyBase[] | null;
  fieldingGroupAssignments?: FieldingGroupAssignmentBase[] | null;
  studyDuration?: number | null;
  studyIncentive?: number | null;
  steps?: StepBase[] | null;
  status?: string | null;
  instructionsIntro?: string | null;
  targetN?: number | null;
  customData?: KeyValuePair602[] | null;
  rotationGroupKey?: string | null;
};
export type FieldingGroupRead = {
  kit?: KitRead;
  surveyIds?: number[] | null;
  id?: string;
  projectId?: number;
  name?: string | null;
  internalName?: string | null;
  kitId?: number | null;
  kitInfo?: FieldingGroupKit;
  surveys?: ProjectSurveyBase[] | null;
  fieldingGroupAssignments?: FieldingGroupAssignmentBase[] | null;
  studyDuration?: number | null;
  studyIncentive?: number | null;
  steps?: StepBase[] | null;
  status?: string | null;
  instructionsIntro?: string | null;
  targetN?: number | null;
  customData?: KeyValuePair602[] | null;
  rotationGroupKey?: string | null;
};
export type CreateFieldingGroupRequest = {
  name?: string | null;
  internalName?: string | null;
  productIds?: number[] | null;
  fieldingGroupAssignments?: FieldingGroupAssignmentBase[] | null;
  targetN?: number | null;
  customData?: KeyValuePair602[] | null;
  rotationGroupKey?: string | null;
};
export type BulkCreateFieldingGroupRequest = {
  groupsToCreate?: CreateFieldingGroupRequest[] | null;
};
export type CreateFromKitsRequest = {
  kits?: Kit[] | null;
};
export type CreateFromKitsRequestRead = {
  kits?: KitRead[] | null;
};
export type FieldingGroupAssignment = {
  id?: string | null;
  highlighterId?: string | null;
  customData?: KeyValuePair602[] | null;
};
export type HighlighterExperienceProductNames = {
  name?: string | null;
  nameHighlighterFacing?: string | null;
};
export type HighlighterExperienceSurveyNames = {
  name?: string | null;
  nameHighlighterFacing?: string | null;
};
export type HighlighterExperienceStepKind =
  | 'Wait'
  | 'UseProduct'
  | 'TakeStandaloneSurvey'
  | 'TakeProductSurvey';
export type HighlighterExperienceStep = {
  id?: string;
  kind?: HighlighterExperienceStepKind;
  day?: number;
  ordinal?: number;
  durationDays?: number;
  productId?: number | null;
  surveyUuid?: string | null;
};
export type HighlighterExperienceRead = {
  productNamesById?: {
    [key: string]: HighlighterExperienceProductNames;
  } | null;
  surveyNamesByUuid?: {
    [key: string]: HighlighterExperienceSurveyNames;
  } | null;
  id?: string;
  projectId?: number;
  builtFromTestDesignId?: string | null;
  builtForTestGroupId?: string | null;
  steps?: HighlighterExperienceStep[] | null;
};
export type HighlighterExperience = {
  id?: string;
  projectId?: number;
  builtFromTestDesignId?: string | null;
  builtForTestGroupId?: string | null;
  steps?: HighlighterExperienceStep[] | null;
};
export type SurveyOverviewRow = {
  surveyUuid?: string;
  surveyName?: string | null;
  statusCounts?: {
    done?: number;
    available?: number;
    availableOverdue?: number;
    blocked?: number;
  } | null;
};
export type HighlighterExperienceOverviewRow = {
  highlighterExperienceId?: string;
  surveys?: SurveyOverviewRow[] | null;
};
export type HighlighterExperienceOverviewResponse = {
  experiences?: HighlighterExperienceOverviewRow[] | null;
};
export type HighlighterExperienceAssignment = {
  id?: string;
  highlighterExperienceId?: string;
  highlighterId?: string;
  beginOn?: string | null;
  boxId?: string | null;
};
export type InitializeHighlighterExperienceRequest = {
  highlighterIds?: string[] | null;
};
export type HighlighterBeginOn = {
  highlighterId?: string;
  beginOn?: string;
};
export type EnrichedHubSpotDeal = {
  id?: string | null;
  dealName?: string | null;
  companyName?: string | null;
  amount?: string | null;
  closeDate?: string | null;
  isClosedWon?: boolean;
  salesModel?: string | null;
  totalHighlights?: string | null;
  totalAddons?: string | null;
  termStartDate?: string | null;
  termLengthInMonths?: string | null;
  subscription?: string | null;
};
export type CreateInsertRequest = {
  insert?: Insert;
  projectId?: number;
};
export type KitAsset = {
  kitAssetId?: string;
  assetId?: string;
  name?: string | null;
  description?: string | null;
  url?: string | null;
  downloadUrl?: string | null;
};
export type RequestReviewRequest = {
  note?: string | null;
};
export type ReviewRequest = {
  status?: string | null;
  note?: string | null;
};
export type ProjectLink = {
  projectLinkId?: string;
  projectId?: number;
  name?: string | null;
  description?: string | null;
  url?: string | null;
};
export type CreateRequest = {
  name?: string | null;
  description?: string | null;
  url?: string | null;
};
export type ManualSurveyNote = {
  content?: string | null;
  date?: string;
  status?: string | null;
  userId?: number;
};
export type SurveyType = 'screening' | 'product';
export type ManualSurveyUser = {
  id?: number;
  firstName?: string | null;
  lastName?: string | null;
};
export type ManualSurvey = {
  projectId?: number;
  projectSurveyId?: number;
  surveyId?: number;
  surveyUuid?: string;
  teamId?: number;
  name?: string | null;
  notes?: ManualSurveyNote[] | null;
  surveyType?: SurveyType;
  surveyStatus?: string | null;
  /** Link to the programmed survey e.g. for review */
  linkUrl?: string | null;
  /** Link to some document uploaded by the customer (e.g. an instructions file) */
  uploadLink?: string | null;
  ordinal?: number | null;
  /** An embedded list of the users referenced in survey notes. This is a
    client-side convenience carried over from GraphQL/Hasura days */
  users?: ManualSurveyUser[] | null;
};
export type CreateManualSurveyRequest = {
  teamId?: number;
  name?: string | null;
  instructions?: string | null;
  uploadLink?: string | null;
};
export type UpdateManualSurveyRequest = {
  projectId?: number;
  surveyId?: number;
  status?: string | null;
  linkUrl?: string | null;
  name?: string | null;
  currentNote?: string | null;
  uploadLink?: string | null;
};
export type ModuleConfiguration = {
  id?: string | null;
  /** True, if the module configuration is default (ie included in the survey at the start)
    False, the module configuration is recommended (available for the customer to use, but isn't in the survey at the start) */
  isDefault?: boolean;
  moduleId?: string;
  ordinal?: number;
  solutionId?: string;
  /** See ProjectSubject for types. */
  subject?: string | null;
  surveyRoleId?: string;
  testCategoryId?: string;
  createdAt?: string | null;
  createdBy?: string | null;
  updatedAt?: string | null;
};
export type BlueprintKey = {
  solutionId?: string;
  surveyRoleId?: string;
  testCategoryId?: string;
  subject?: string | null;
};
export type BlueprintConfigurationDto = {
  isDefault?: boolean;
  moduleId?: string;
};
export type AssignModuleConfigurationsToBlueprintRequest = {
  key?: BlueprintKey;
  /** The order of the configurationDtos will be used to calculate the ordinal. */
  configurations?: BlueprintConfigurationDto[] | null;
};
export type Slot = {
  id?: string | null;
  blockId?: string;
  key?: string | null;
  label?: string | null;
  placeholder?: string | null;
  slotType?: string | null;
  displayOrder?: number;
  slotValueOptions?: string[] | null;
  canApplyAllWithinSurveys?: boolean;
  isRequired?: boolean;
  createdAt?: string | null;
  createdBy?: string | null;
  updatedAt?: string | null;
  updatedBy?: string | null;
};
export type QuestionDesign = {
  id?: string;
  name?: string | null;
  questionType?: string | null;
  questionText?: string | null;
  descriptionText?: string | null;
  descriptionImageUrl?: string | null;
  isArchived?: boolean;
  createdAt?: string | null;
  createdBy?: string | null;
  updatedAt?: string | null;
  updatedBy?: string | null;
};
export type BlockBehavior = {
  id?: string | null;
  blockId?: string | null;
  questionBehavior?: string | null;
  canCustomerEdit?: boolean;
  defaultValue?: boolean;
  defaultNumericValue?: number | null;
  defaultStringValue?: string | null;
};
export type BlockSlotsDto = {
  slots?: Slot[] | null;
  id?: string;
  description?: string | null;
  name?: string | null;
  externalId?: string | null;
  questionDesign?: QuestionDesign;
  internalName?: string | null;
  isArchived?: boolean;
  behaviors?: BlockBehavior[] | null;
  createdAt?: string | null;
  createdBy?: string | null;
  updatedAt?: string | null;
  updatedBy?: string | null;
};
export type Module = {
  id?: string | null;
  displayName?: string | null;
  internalName?: string | null;
  blocks?: BlockSlotsDto[] | null;
  isArchived?: boolean;
  showInConfigurator?: boolean;
  showInSurveyPanels?: boolean;
  hideInRecommendedPanel?: boolean;
  createdAt?: string | null;
  createdBy?: string | null;
  updatedAt?: string | null;
  updatedBy?: string | null;
  description?: string | null;
  infoLink?: string | null;
  excludedSubjects?: string[] | null;
  excludedTestCategoryIds?: string[] | null;
};
export type NotificationUnsubscription = {
  id?: string | null;
  projectId?: number;
  userId?: number;
  createdAt?: string | null;
  createdBy?: string | null;
};
export type ByolDto = {
  isEnabled: boolean;
};
export type ByocDto = {
  isEnabled: boolean;
};
export type CostCalcDto = {
  isEnabled: boolean;
};
export type CustomerNotificationsDto = {
  isEnabled: boolean;
};
export type HighlightCommunityDto = {
  isEnabled: boolean;
};
export type HighlightLogisticsDto = {
  isEnabled: boolean;
};
export type ProjectSubmittedSlackDto = {
  isEnabled: boolean;
};
export type PulseDto = {
  isEnabled: boolean;
};
export type EntitlementsDefn = {
  byol: ByolDto;
  byoc: ByocDto;
  costCalc: CostCalcDto;
  customerNotifications: CustomerNotificationsDto;
  highlightCommunity: HighlightCommunityDto;
  highlightLogistics: HighlightLogisticsDto;
  projectSubmittedSlack: ProjectSubmittedSlackDto;
  pulse: PulseDto;
};
export type RuleDto = {
  value?: boolean;
  defaultDescription?: string | null;
};
export type PresentationRuleDto = {
  slug?: string | null;
  display?: string | null;
  level?: number;
  isOverriddenValues?: boolean;
  visible?: RuleDto;
};
export type EditPresentationRuleRequest = {
  projectId?: number;
  slug?: string | null;
  visible?: boolean;
};
export type ProductProjectAsset = {
  id?: string;
  productId?: number;
  projectAssetId?: string;
  projectId?: number;
  asset?: AssetWithUrls;
  createdAt?: string | null;
  createdBy?: string | null;
};
export type ProductProjectAssetRequest = {
  /** The ID of the project asset to associate with the product */
  projectAssetId: string;
};
export type CreateProductRequest = {
  name: string;
  recipientName: string;
  ingredients: string;
  allergens: Allergen[];
  isProductBlinded: boolean;
};
export type HandlingPreferenceRequest = {
  key: string;
  value: string;
};
export type UpdateProductRequest = {
  id: number;
  name?: string | null;
  recipientName?: string | null;
  ingredients?: string | null;
  allergens?: Allergen[] | null;
  isProductBlinded?: boolean | null;
  fragile?: boolean | null;
  returnProduct?: boolean | null;
  isCustomAddress?: boolean | null;
  isOvernightShipping?: boolean | null;
  /** Nullable text, here and in the other handling text fields: null is left as stored and ""
    clears the column. */
  returnAddress?: string | null;
  relabel?: boolean | null;
  relabelCode?: string | null;
  blindingTypeIdArr?: number[] | null;
  /** Replace-only: once set, $bulk can't clear it back to none. */
  perishableTypeId?: number | null;
  /** One of ProjectApi.Products.ExtraProductHandlingType, or "" to clear. */
  extraProductHandling?: string | null;
  extraProductReturnAddress?: string | null;
  extraProductComments?: string | null;
  /** Upserted by key; keys not listed are left as stored. A "" value keeps the row with an empty
    value, which is how the handling step clears one. */
  handlingPreferences?: HandlingPreferenceRequest[] | null;
  /** The version last read by the caller. It must match the current version or the whole batch
    fails with 409. */
  version: number;
};
export type DeleteProductRequest = {
  id: number;
  /** The version last read by the caller. It must match the current version or the whole batch
    fails with 409. A product already deleted is left alone, whatever version is sent. */
  version: number;
};
export type BulkProductRequest = {
  creates?: CreateProductRequest[] | null;
  updates?: UpdateProductRequest[] | null;
  deletes?: DeleteProductRequest[] | null;
};
export type SlotValue = {
  id?: string | null;
  surveyConfigBlockId?: string;
  slotId?: string;
  value?: string | null;
  assetId?: string | null;
  externalUrl?: string | null;
  createdAt?: string | null;
  createdBy?: string | null;
  updatedAt?: string | null;
  updatedBy?: string | null;
};
export type SurveyConfigBlockSlotValues = {
  surveyConfigBlockId?: string;
  slotValues?: SlotValue[] | null;
};
export type SurveyRenameWrite = {
  surveyConfigId?: string;
  displayName?: string | null;
  internalName?: string | null;
  durationDays?: number;
  slotValues?: SurveyConfigBlockSlotValues[] | null;
};
export type UnreplacedTemplate = {
  surveyConfigId?: string;
  template?: string | null;
};
export type ProductSurveyRenamePlan = {
  writes?: SurveyRenameWrite[] | null;
  configsWithoutDesign?: string[] | null;
  unreplacedTemplates?: UnreplacedTemplate[] | null;
};
export type StimulusChange = {
  assetId?: string;
  name?: string | null;
};
export type ProductSurveyRenamePlanRequest = {
  productId: number;
  name?: string | null;
  recipientName?: string | null;
  stimulus?: StimulusChange;
};
export type ProjectCategory = {
  id?: string;
  name?: string | null;
  labelValue?: string | null;
};
export type ProjectFinalReports = {
  finalDataSet?: AssetWithUrls;
  finalReport?: AssetWithUrls;
  additionalDeliverableFiles?: AssetWithUrls[] | null;
  finalReportLink?: string | null;
  additionalDeliverableLinks?: string[] | null;
  hasNoDataset?: boolean;
};
export type ProjectTypeOption = 'physical_product_test' | 'concept_test' | 'survey' | 'quick_pulse';
export type ProductStageOption = 'prototype' | 'newly_launched' | 'established_in_market';
export type StudyPurposeOption =
  | 'see_how_it_performs'
  | 'choose_between_options'
  | 'concept_matches_product'
  | 'understand_impact_of_change'
  | 'understand_usage_and_occasions'
  | 'explore_or_back_up_claims'
  | 'understand_your_audience';
export type PrototypeStageOption =
  | 'product_only'
  | 'product_with_concept_or_artwork'
  | 'product_in_packaging';
export type ComparedToWhatPerformanceOption =
  | 'on_its_own'
  | 'against_another_of_your_products'
  | 'against_a_competitor';
export type ComparedToWhatChooseOption = 'between_your_own_versions' | 'against_competitors';
export type FeedbackOnOption = 'the_product_itself' | 'the_packaging' | 'both';
export type TrialCadenceOption = 'standard' | 'track_over_time';
export type HowSeeConceptOption = 'on_the_package' | 'shown_digitally';
export type ImpactNeedToKnowOption =
  | 'whether_current_users_will_be_alienated'
  | 'whether_the_change_is_noticeable_broadly';
export type WhatChangedOption = 'formulation' | 'packaging' | 'both';
export type ResearchUseOption =
  | 'product_development_and_iteration'
  | 'internal_go_no_go_decision'
  | 'sharing_with_a_retailer'
  | 'marketing_collateral'
  | 'investor_or_board_presentation';
export type SuccessCriteriaOption =
  | 'match_specific_product_parity'
  | 'beat_specific_product'
  | 'hit_target_score'
  | 'no_fixed_bar_exploratory';
export type PhysicalProductTestAnswers = {
  productStage: ProductStageOption;
  studyPurpose: StudyPurposeOption;
  prototypeStage?: PrototypeStageOption;
  /** Compared to what? (Only when the study purpose is to see how the product performs.) */
  performanceComparisonTargets?: ComparedToWhatPerformanceOption[] | null;
  /** Compared to what? (Only when the study purpose is to choose between options.) */
  choiceComparisonTargets?: ComparedToWhatChooseOption[] | null;
  feedbackOn?: FeedbackOnOption;
  trialCadence?: TrialCadenceOption;
  howConceptIsShown?: HowSeeConceptOption;
  changeImpactFocus?: ImpactNeedToKnowOption;
  whatChanged?: WhatChangedOption;
  /** What will you use this research for? */
  researchUsePurposes: ResearchUseOption[];
  successCriteria: SuccessCriteriaOption;
};
export type ConceptTestSubjectOption =
  | 'product_concept'
  | 'pack_design'
  | 'claims_or_messaging'
  | 'names_or_labels'
  | 'mix_of_the_above';
export type ConceptTestDecisionOption =
  | 'decide_if_strong_enough_to_build'
  | 'narrow_down_list'
  | 'choose_winning_concept'
  | 'make_concept_stronger'
  | 'explore_options'
  | 'evaluate_specific_element';
export type ConceptCountOption = 'one_specific_concept' | 'multiple_concepts';
export type ConceptTestAnswers = {
  conceptTestSubject: ConceptTestSubjectOption;
  decisionToInform: ConceptTestDecisionOption;
  conceptCount?: ConceptCountOption;
  /** Do you want to compare your concept(s) against competitor concepts? */
  compareAgainstCompetitors?: boolean | null;
  /** What will you use this research for? */
  researchUsePurposes: ResearchUseOption[];
  successCriteria: SuccessCriteriaOption;
};
export type SurveyAnswers = object;
export type QuickPulseAnswers = object;
export type ProjectIntakeAnswers = {
  /** What specifically is being tested? (For survey / quick pulse: what specifically will you be
    asking about?) */
  whatSpecificallyIsBeingTested: string;
  type: ProjectTypeOption;
  physicalProductTest?: PhysicalProductTestAnswers;
  conceptTest?: ConceptTestAnswers;
  survey?: SurveyAnswers;
  quickPulse?: QuickPulseAnswers;
};
export type ReviewIssue = {
  id?: string | null;
  title?: string | null;
  categories?: string[] | null;
  description?: string | null;
  recommendation?: string | null;
};
export type ReviewRecommendation = {
  id?: string | null;
  title?: string | null;
  categories?: string[] | null;
  description?: string | null;
  recommendation?: string | null;
};
export type ProjectReviewResult = {
  overview?: string | null;
  issues?: ReviewIssue[] | null;
  recommendations?: ReviewRecommendation[] | null;
};
export type ProjectObjectiveResponse = {
  title?: string | null;
  description?: string | null;
};
export type ProjectSummaryResponse = {
  summary?: string | null;
  objectives?: ProjectObjectiveResponse[] | null;
  generatedAt?: string;
};
export type ProjectRecruitSource = 'highlight_community' | 'custom_community' | 'guest_link';
export type StoredSelectedAddOn = {
  code?: string | null;
  price?: number;
};
export type SnapshotLineItem = {
  label?: string | null;
  value?: string | null;
};
export type SnapshotInputs = {
  targetParticipants?: number;
  totalParticipantsReceivingProducts?: number;
  totalBlindedBoxes?: number;
  totalRepackingBoxes?: number;
  totalVideoTasks?: number;
  totalPhotoTasks?: number;
  totalProductReturnTasks?: number;
  selectedAddOnCodes?: string[] | null;
  hasAudienceCriteria?: boolean;
};
export type SubmittedCostSnapshot = {
  snapshotVersion?: number;
  submittedAt?: string | null;
  totalHighlights?: number | null;
  totalAddOnCost?: number;
  highlightsLineItems?: SnapshotLineItem[] | null;
  addOnLineItems?: SnapshotLineItem[] | null;
  inputs?: SnapshotInputs;
};
export type Project = {
  /** Primary identifier for a project. */
  id?: number;
  projectUuid?: string | null;
  publicId?: string | null;
  name?: string | null;
  highlighterFacingName?: string | null;
  description?: string | null;
  additionalInformation?: string | null;
  studyDesign?: string | null;
  studyDesignHtml?: string | null;
  /** Status should be one of the values in SurveyApi.SharedTypes.Projects.ProjectType. */
  type?: string | null;
  /** Subtype should be one of the values in ProjectApi.Projects.Models.ProjectSubtype. */
  subtype?: string | null;
  stage?: string | null;
  teamId?: number;
  teamName?: string | null;
  orgId?: number;
  orgName?: string | null;
  hubspotDealId?: string | null;
  hubspotProjectId?: string | null;
  /** Macro Category. */
  category?: string | null;
  /** Micro Category */
  testCategoryId?: string | null;
  /** Classification of the test. Like "Coffee" or "Soda". */
  testClassificationId?: string | null;
  /** Subcategory of the test derived from the category and classification combination. */
  testSubcategoryId?: string | null;
  /** Defines the target test demographic for a Project matching one of the values in ProjectApi.Projects.Models.ProjectSubject. */
  subject?: string | null;
  /** Specifies the blinding method for all Products in a project as a global setting matching one of the values in ProjectApi.Projects.Models.ProjectProductBlindingMethod. */
  productBlindingMethod?: string | null;
  creditCost?: number | null;
  estimatedCreditCost?: number | null;
  complexityScore?: number | null;
  requiresVideoSubmission?: boolean | null;
  requiresPhotoSubmission?: boolean | null;
  requiresIDI?: boolean | null;
  requiresProductReturn?: boolean | null;
  solutionId?: string | null;
  solution?: string | null;
  /** Status should be one of the values in Common.Storage.ClientPortal.ProjectStatus. */
  status?: string | null;
  recruitStatus?: string | null;
  /** ManualRecruitStatus is the representation of the project.recruitingStatus field
    if a project has recruited manually successfully this field should be true */
  manualRecruitStatus?: string | null;
  isDeleted?: boolean | null;
  audienceSchemaVersion?: number | null;
  scoreCardId?: string | null;
  resultContextId?: string | null;
  createdAt?: string;
  createdBy?: string | null;
  /** UpdatedAt will be null the first time the project is created. */
  updatedAt?: string | null;
  startDate?: string | null;
  completeDate?: string | null;
  dataCollectionStartDate?: string | null;
  dataCollectionEndDate?: string | null;
  boxesShipOutDate?: string | null;
  desiredCompletionDate?: string | null;
  actualCompletionDate?: string | null;
  hasNoDataset?: boolean | null;
  syncKitsEnabled?: boolean;
  /** True once box tracking numbers have ever been uploaded for this project. */
  anyTrackingSet?: boolean;
  completes?: number | null;
  /** List of recommended module IDs for this project */
  recommendedModuleIds?: string[] | null;
  /** Determines whether automations will occur for this project.
    as of 8/14/25 this involves automatically adding boxes and surveys to highlighters assigned to test groups */
  automationsEnabled?: boolean | null;
  /** When true, Insights results only include highlighters who completed and were
    approved for ALL product surveys they submitted. When false or null, includes
    partial completes. */
  fullCompletesOnly?: boolean | null;
  /** When true, default core survey groups are split per (product, bundle/timepoint) so each
    longitudinal wave is its own group. When false (default), a product's surveys are combined
    into one group. */
  separateSurveyGroups?: boolean;
  /** Logistics storage column represented as an array for mixed logistics support.
    Each value is a ProjectApi.Projects.Models.Project.LogisticsType enum name (e.g. `onsite_pickup`). */
  logisticsType?: string[] | null;
  recruitSource?: ProjectRecruitSource;
  /** Slug of the custom community associated with this project. */
  communitySlug?: string | null;
  /** User-selected flat-fee add-ons (e.g., reporting extras) stored as JSONB. */
  selectedAddOns?: StoredSelectedAddOn[] | null;
  submittedCostSnapshot?: SubmittedCostSnapshot;
};
export type ObjectiveDto = {
  /** Short title summarizing the objective. */
  title?: string | null;
  /** Detailed description of the research objective. */
  description?: string | null;
};
export type ProjectConfigurationDto = {
  /** Required for $configure endpoint.
    The display name of the project. */
  name?: string | null;
  /** Required for $configure endpoint.
    The name displayed to highlighters when they view project tasks. */
  highlighterFacingName?: string | null;
  /** Required for $configure endpoint.
    The team that owns this project. */
  teamId?: number;
  /** Required for $configure endpoint.
    HubSpot Deal ID - must be 11 digits when provided.
    Use 00000000000 if no associated deal or if its a testing project. */
  hubspotDealId?: string | null;
  /** Required for $configure endpoint.
    Credit cost associated with this project.
    Pass in Null when its a testing project or if you're unsure of the cost. */
  creditCost?: number | null;
  /** Required for $configure endpoint.
    The solution that this project is associated with. */
  solutionId?: string;
  solutionName?: string | null;
  solutionIdentifierName?: string | null;
  /** Required for $configure endpoint.
    The test category that this project is associated with. */
  testCategoryId?: string | null;
  testCategoryName?: string | null;
  /** Optional for $configure endpoint.
    The test classification that this project is associated with.
    Classification is a child of the test category.
    When omitted, no subcategory is resolved and the highlighter-facing name
    falls back to the caller-provided HighlighterFacingName (the
    classification-derived naming branches are skipped). */
  testClassificationId?: string | null;
  testClassificationName?: string | null;
  /** Required for $configure endpoint.
    Default to null.
    Currently only used for non-stimulus projects. */
  testSubcategoryId?: string | null;
  testSubcategoryName?: string | null;
  /** Required for $configure endpoint.
    Defines the target demographic for a Project matching one of the values in ProjectApi.Projects.Models.ProjectSubject. */
  subject?: string | null;
  /** Either this should be provided, or an ExperienceId should be provided for the $configure endpoint.
    Should be one of the values in ProjectApi.Projects.Models.TestType, example ["concept"] or ["product"].
    For MCP consumers: its simpler set this property instead of the ExperienceId, so lean towards setting this property instead of determining an experienceId for the $configure endpoint. */
  testTypes?: string[] | null;
  /** Experience for the project.
    Either this should be provided, or the TestTypes should be provided for the $configure endpoint. */
  experienceId?: string | null;
  /** List of recommended module for this project
    These are the modules recommend to be used for this project.
    It populates the survey builder with a quick-start list of modules. */
  recommendedModuleIds?: string[] | null;
  /** Logistics storage column represented as an array for mixed logistics support.
    Each value is a ProjectApi.Projects.Models.ProjectConfigurationDTO.LogisticsType enum name. */
  logisticsType?: string[] | null;
  /** Research objectives generated by AI during guided project setup. They are produced
    automatically from the study configuration and are not authored or reviewed by the
    customer before submission. Each objective has a title and description. */
  objectives?: ObjectiveDto[] | null;
  recruitSource?: ProjectRecruitSource;
  /** Slug of the community to recruit from. */
  communitySlug?: string | null;
};
export type ConfigureProjectV2Request = {
  projectDto: ProjectConfigurationDto;
  projectIntakeAnswers: ProjectIntakeAnswers;
};
export type UpdateProjectRequest = {
  completes?: number | null;
  status?: string | null;
  /** Legacy experience freeform document (text version) */
  studyDesign?: string | null;
  /** Legacy experience freeform document (html version) */
  studyDesignHtml?: string | null;
  hubspotDealId?: string | null;
  /** HubSpot Projects record id. Null leaves the stored value untouched; blank clears it
    (the hubspot-worker then re-populates it on the next sync). */
  hubspotProjectId?: string | null;
  actualCompletionDate?: string | null;
  creditCost?: number | null;
  name?: string | null;
  productBlindingMethod?: string | null;
  /** Who the study is about — a `public.subject` enum value (adult/teen/child/baby/pet).
    When omitted, `subject` is not updated. */
  subject?: string | null;
  highlighterFacingName?: string | null;
  description?: string | null;
  type?: string | null;
  solutionId?: string | null;
  category?: string | null;
  complexityScore?: number | null;
  automationsEnabled?: boolean | null;
  fullCompletesOnly?: boolean | null;
  separateSurveyGroups?: boolean | null;
  recruitSource?: ProjectRecruitSource;
  communitySlug?: string | null;
  selectedAddOns?: StoredSelectedAddOn[] | null;
  submittedCostSnapshot?: SubmittedCostSnapshot;
};
export type ProjectNotificationEntitlements = {
  customerNotifications?: boolean;
};
export type ProjectStatusResponse = {
  status?: string | null;
};
export type ProductSurveyConfig = {
  surveyConfigId?: string;
  productId?: number;
};
export type ShipmentProduct = {
  id?: number | null;
  shipmentId?: number;
  productId?: number;
  productName?: string | null;
  quantity?: number;
  createdAt?: string | null;
  updatedAt?: string | null;
};
export type Shipment = {
  id?: number | null;
  uuid?: string | null;
  projectId?: number;
  name?: string | null;
  trackingNumber?: string | null;
  notes?: string | null;
  status?: string | null;
  carrier?: string | null;
  shipDate?: string | null;
  expectedDeliveryDate?: string | null;
  trackingStatus?: string | null;
  trackingLastUpdated?: string | null;
  warehouseStorageRequirement?: string | null;
  warehouseStorageNotes?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
  shipmentProducts?: ShipmentProduct[] | null;
};
export type AdminProject = {
  /** List of ProjectApi.Admins.Admins assigned to the project. */
  admins?: Admin[] | null;
  products?: Product[] | null;
  kits?: Kit[] | null;
  shipments?: Shipment[] | null;
  testCategoryName?: string | null;
  testClassificationName?: string | null;
  testSubcategoryName?: string | null;
  /** Primary identifier for a project. */
  id?: number;
  projectUuid?: string | null;
  publicId?: string | null;
  name?: string | null;
  highlighterFacingName?: string | null;
  description?: string | null;
  additionalInformation?: string | null;
  studyDesign?: string | null;
  studyDesignHtml?: string | null;
  /** Status should be one of the values in SurveyApi.SharedTypes.Projects.ProjectType. */
  type?: string | null;
  /** Subtype should be one of the values in ProjectApi.Projects.Models.ProjectSubtype. */
  subtype?: string | null;
  stage?: string | null;
  teamId?: number;
  teamName?: string | null;
  orgId?: number;
  orgName?: string | null;
  hubspotDealId?: string | null;
  hubspotProjectId?: string | null;
  /** Macro Category. */
  category?: string | null;
  /** Micro Category */
  testCategoryId?: string | null;
  /** Classification of the test. Like "Coffee" or "Soda". */
  testClassificationId?: string | null;
  /** Subcategory of the test derived from the category and classification combination. */
  testSubcategoryId?: string | null;
  /** Defines the target test demographic for a Project matching one of the values in ProjectApi.Projects.Models.ProjectSubject. */
  subject?: string | null;
  /** Specifies the blinding method for all Products in a project as a global setting matching one of the values in ProjectApi.Projects.Models.ProjectProductBlindingMethod. */
  productBlindingMethod?: string | null;
  creditCost?: number | null;
  estimatedCreditCost?: number | null;
  complexityScore?: number | null;
  requiresVideoSubmission?: boolean | null;
  requiresPhotoSubmission?: boolean | null;
  requiresIDI?: boolean | null;
  requiresProductReturn?: boolean | null;
  solutionId?: string | null;
  solution?: string | null;
  /** Status should be one of the values in Common.Storage.ClientPortal.ProjectStatus. */
  status?: string | null;
  recruitStatus?: string | null;
  /** ManualRecruitStatus is the representation of the project.recruitingStatus field
    if a project has recruited manually successfully this field should be true */
  manualRecruitStatus?: string | null;
  isDeleted?: boolean | null;
  audienceSchemaVersion?: number | null;
  scoreCardId?: string | null;
  resultContextId?: string | null;
  createdAt?: string;
  createdBy?: string | null;
  /** UpdatedAt will be null the first time the project is created. */
  updatedAt?: string | null;
  startDate?: string | null;
  completeDate?: string | null;
  dataCollectionStartDate?: string | null;
  dataCollectionEndDate?: string | null;
  boxesShipOutDate?: string | null;
  desiredCompletionDate?: string | null;
  actualCompletionDate?: string | null;
  hasNoDataset?: boolean | null;
  syncKitsEnabled?: boolean;
  /** True once box tracking numbers have ever been uploaded for this project. */
  anyTrackingSet?: boolean;
  completes?: number | null;
  /** List of recommended module IDs for this project */
  recommendedModuleIds?: string[] | null;
  /** Determines whether automations will occur for this project.
    as of 8/14/25 this involves automatically adding boxes and surveys to highlighters assigned to test groups */
  automationsEnabled?: boolean | null;
  /** When true, Insights results only include highlighters who completed and were
    approved for ALL product surveys they submitted. When false or null, includes
    partial completes. */
  fullCompletesOnly?: boolean | null;
  /** When true, default core survey groups are split per (product, bundle/timepoint) so each
    longitudinal wave is its own group. When false (default), a product's surveys are combined
    into one group. */
  separateSurveyGroups?: boolean;
  /** Logistics storage column represented as an array for mixed logistics support.
    Each value is a ProjectApi.Projects.Models.Project.LogisticsType enum name (e.g. `onsite_pickup`). */
  logisticsType?: string[] | null;
  recruitSource?: ProjectRecruitSource;
  /** Slug of the custom community associated with this project. */
  communitySlug?: string | null;
  /** User-selected flat-fee add-ons (e.g., reporting extras) stored as JSONB. */
  selectedAddOns?: StoredSelectedAddOn[] | null;
  submittedCostSnapshot?: SubmittedCostSnapshot;
};
export type AdminProjectRead = {
  /** List of ProjectApi.Admins.Admins assigned to the project. */
  admins?: Admin[] | null;
  products?: Product[] | null;
  kits?: KitRead[] | null;
  shipments?: Shipment[] | null;
  testCategoryName?: string | null;
  testClassificationName?: string | null;
  testSubcategoryName?: string | null;
  /** Primary identifier for a project. */
  id?: number;
  projectUuid?: string | null;
  publicId?: string | null;
  name?: string | null;
  highlighterFacingName?: string | null;
  description?: string | null;
  additionalInformation?: string | null;
  studyDesign?: string | null;
  studyDesignHtml?: string | null;
  /** Status should be one of the values in SurveyApi.SharedTypes.Projects.ProjectType. */
  type?: string | null;
  /** Subtype should be one of the values in ProjectApi.Projects.Models.ProjectSubtype. */
  subtype?: string | null;
  stage?: string | null;
  teamId?: number;
  teamName?: string | null;
  orgId?: number;
  orgName?: string | null;
  hubspotDealId?: string | null;
  hubspotProjectId?: string | null;
  /** Macro Category. */
  category?: string | null;
  /** Micro Category */
  testCategoryId?: string | null;
  /** Classification of the test. Like "Coffee" or "Soda". */
  testClassificationId?: string | null;
  /** Subcategory of the test derived from the category and classification combination. */
  testSubcategoryId?: string | null;
  /** Defines the target test demographic for a Project matching one of the values in ProjectApi.Projects.Models.ProjectSubject. */
  subject?: string | null;
  /** Specifies the blinding method for all Products in a project as a global setting matching one of the values in ProjectApi.Projects.Models.ProjectProductBlindingMethod. */
  productBlindingMethod?: string | null;
  creditCost?: number | null;
  estimatedCreditCost?: number | null;
  complexityScore?: number | null;
  requiresVideoSubmission?: boolean | null;
  requiresPhotoSubmission?: boolean | null;
  requiresIDI?: boolean | null;
  requiresProductReturn?: boolean | null;
  solutionId?: string | null;
  solution?: string | null;
  /** Status should be one of the values in Common.Storage.ClientPortal.ProjectStatus. */
  status?: string | null;
  recruitStatus?: string | null;
  /** ManualRecruitStatus is the representation of the project.recruitingStatus field
    if a project has recruited manually successfully this field should be true */
  manualRecruitStatus?: string | null;
  isDeleted?: boolean | null;
  audienceSchemaVersion?: number | null;
  scoreCardId?: string | null;
  resultContextId?: string | null;
  createdAt?: string;
  createdBy?: string | null;
  /** UpdatedAt will be null the first time the project is created. */
  updatedAt?: string | null;
  startDate?: string | null;
  completeDate?: string | null;
  dataCollectionStartDate?: string | null;
  dataCollectionEndDate?: string | null;
  boxesShipOutDate?: string | null;
  desiredCompletionDate?: string | null;
  actualCompletionDate?: string | null;
  hasNoDataset?: boolean | null;
  syncKitsEnabled?: boolean;
  /** True once box tracking numbers have ever been uploaded for this project. */
  anyTrackingSet?: boolean;
  completes?: number | null;
  /** List of recommended module IDs for this project */
  recommendedModuleIds?: string[] | null;
  /** Determines whether automations will occur for this project.
    as of 8/14/25 this involves automatically adding boxes and surveys to highlighters assigned to test groups */
  automationsEnabled?: boolean | null;
  /** When true, Insights results only include highlighters who completed and were
    approved for ALL product surveys they submitted. When false or null, includes
    partial completes. */
  fullCompletesOnly?: boolean | null;
  /** When true, default core survey groups are split per (product, bundle/timepoint) so each
    longitudinal wave is its own group. When false (default), a product's surveys are combined
    into one group. */
  separateSurveyGroups?: boolean;
  /** Logistics storage column represented as an array for mixed logistics support.
    Each value is a ProjectApi.Projects.Models.Project.LogisticsType enum name (e.g. `onsite_pickup`). */
  logisticsType?: string[] | null;
  recruitSource?: ProjectRecruitSource;
  /** Slug of the custom community associated with this project. */
  communitySlug?: string | null;
  /** User-selected flat-fee add-ons (e.g., reporting extras) stored as JSONB. */
  selectedAddOns?: StoredSelectedAddOn[] | null;
  submittedCostSnapshot?: SubmittedCostSnapshot;
};
export type ProjectAdmin = {
  id?: string;
  projectId?: number;
  adminId?: number;
};
export type AssignProjectAdminsRequest = {
  projectAdmins?: ProjectAdmin[] | null;
};
export type ProjectStatusRequest = {
  status?: string | null;
};
export type ProjectTeamRequest = {
  teamId?: number;
};
export type ProjectProductBlindingMethodRequest = {
  productBlindingMethod?: string | null;
};
export type ProjectNameRequest = {
  name?: string | null;
};
export type BoxTrackingFileParseResultItem = {
  success?: boolean;
  message?: string | null;
  boxId?: string | null;
  trackingNumber?: string | null;
};
export type BoxTrackingFileParseResult = {
  projectId?: number;
  success?: boolean;
  message?: string | null;
  items: BoxTrackingFileParseResultItem[];
};
export type CreateProjectFromExistingProjectsRequest = {
  projectIds?: number[] | null;
  surveyConfigIds?: string[] | null;
  name?: string | null;
  templateProjectId?: number;
};
export type UpdateTimelineRequest = {
  startDate?: string | null;
  completeDate?: string | null;
  dataCollectionStartDate?: string | null;
  dataCollectionEndDate?: string | null;
  boxesShipOutDate?: string | null;
  productReceivedDate?: string | null;
  screenerUploadDate?: string | null;
  surveyUploadDate?: string | null;
};
export type QuestionLinkingResult = {
  processedQuestions?: number;
  newLineItemsCreated?: number;
  questionsLinkedToExisting?: number;
  unmatchedQuestions?: number;
};
export type ScoreCardPopulationResult = {
  /** Result contexts the pass got all the way through, whether or not it wrote to them. */
  contextsCovered?: number;
  /** Result contexts abandoned part-way because populating them threw. Non-zero means
                the project is not fully repaired and the run should be repeated - the pass carries on past a
                failure so one bad context cannot strand the others. */
  contextsFailed?: number;
  /** Scopes left alone because their scorecard already had entries (Decision 2). */
  scopesAlreadyPopulated?: number;
  /** Entries submitted to the batch endpoint across every scope. */
  entriesRequested?: number;
  /** Entries the batch endpoint created. */
  entriesCreated?: number;
  /** Entries the batch endpoint rejected. */
  entriesFailed?: number;
};
export type ResetDashboardResponse = {
  scorecardEntriesDeleted?: number;
  segmentsDeleted?: number;
  lineItemsDeleted?: number;
};
export type UpdateDashboardResponse = {
  projectId?: number;
  surveysLinked?: number;
  productsLinked?: number;
  lineItemsCreated?: number;
  resetResult?: ResetDashboardResponse;
};
export type UpdateDashboardRequest = {
  sourceProjectIds?: number[] | null;
  surveyConfigIds?: string[] | null;
};
export type HackyAllergen =
  | 'Unknown'
  | 'None'
  | 'Coconut'
  | 'Dairy'
  | 'Eggs'
  | 'Fish'
  | 'Gluten'
  | 'Mustard'
  | 'Peanuts'
  | 'Sesame'
  | 'Shellfish'
  | 'Soy'
  | 'TreeNuts'
  | 'Milk'
  | 'Latex'
  | 'Fragrance'
  | 'Preservatives'
  | 'DyeColorAdditives'
  | 'Other';
export type HackyProduct = {
  name?: string | null;
  recipientName?: string | null;
  ingredients?: string | null;
  allergens?: HackyAllergen[] | null;
};
export type ProjectHackyConfigurationDto = {
  /** The display name of the project. */
  name?: string | null;
  /** The name displayed to highlighters when they view project tasks. */
  highlighterFacingName?: string | null;
  /** The team that owns this project. */
  teamId?: number;
  /** HubSpot Deal ID - must be 11 digits when provided. Use 00000000000 if no associated deal or if its a testing project. */
  hubspotDealId?: string | null;
  /** Credit cost associated with this project. Pass in Null when its a testing project or if you're unsure of the cost. */
  creditCost?: number | null;
  /** The solution that this project is associated with. */
  solutionId?: string;
  solutionName?: string | null;
  solutionIdentifierName?: string | null;
  /** The test category that this project is associated with. */
  testCategoryId?: string;
  /** The test classification that this project is associated with. Classification is a child of the test category. */
  testClassificationId?: string;
  /** Default to null.
    Currently only used for non-stimulus projects. */
  testSubcategoryId?: string | null;
  /** Defines the target demographic for a Project matching one of the values in ProjectApi.Projects.Models.ProjectSubject. */
  subject?: string | null;
  /** Either this should be provided, or an ExperienceId should be provided for the $configure endpoint.
    Should be one of the values in ProjectApi.Projects.Models.TestType, example ["concept"] or ["product"].
    For MCP consumers: its simpler set this property instead of the ExperienceId,
    so lean towards setting this property instead of determining an experienceId for the $configure endpoint. */
  testTypes?: string[] | null;
  /** Experience for the project.
    Either this should be provided, or the TestTypes should be provided for the $configure endpoint. */
  experienceId?: string | null;
  /** List of recommended module for this project
    These are the modules recommend to be used for this project.
    It populates the survey builder with a quick-start list of modules. */
  recommendedModuleIds?: string[] | null;
  /** Logistics storage column represented as an array for mixed logistics support.
    Each value is a ProjectApi.Projects.Models.ProjectHackyConfigurationDTO.LogisticsType enum name. */
  logisticsType?: string[] | null;
  /** Customer-provided research objectives extracted from AI project setup conversation.
    Each objective has a title and description. */
  objectives?: ObjectiveDto[] | null;
  recruitSource?: ProjectRecruitSource;
  /** Slug of the community to recruit from. */
  communitySlug?: string | null;
  productBlindingMethod?: string | null;
  products?: HackyProduct[] | null;
};
export type ProjectSurvey = {
  productIds?: number[] | null;
  products?: Product[] | null;
  projectId?: number;
  projectSurveyId?: number;
  surveyId?: number;
  surveyUuid?: string;
  teamId?: number;
  surveyName?: string | null;
  solutionSurveyDesignId?: string | null;
  surveyConfigId?: string | null;
  resultContextId?: string | null;
  surveyRoleId?: string | null;
  notes?: ManualSurveyNote[] | null;
  surveyType?: SurveyType;
  surveyStatus?: string | null;
  linkUrl?: string | null;
  uploadLink?: string | null;
  ordinal?: number | null;
  resultsDashboardLink?: string | null;
  resultsStatus?: string | null;
};
export type SetSurveyStatusRequest = {
  surveyStatus?: string | null;
};
export type SetResultsStatusRequest = {
  /** The status of the survey results (e.g., "not started", "data ready", "live dashboard") */
  resultsStatus: string;
  /** URL link to the results dashboard for this survey */
  resultsDashboardLink?: string | null;
};
export type ResponseStatus = {
  status?: string | null;
  surveyResponseId?: string;
};
export type RespondentReview = {
  highlighterId?: string;
  surveyReviews?: {
    [key: string]: ResponseStatus;
  } | null;
  updatedAt?: string | null;
};
export type Header = {
  dataKey?: string | null;
  label?: string | null;
};
export type QualityControlReport = {
  statuses?: RespondentReview[] | null;
  headers?: Header[] | null;
};
export type SubmitReviewRequest = {
  comment?: string | null;
  reviewTargetResponse?: string;
  secondaryResponses?: string[] | null;
  action?: string | null;
  updateHighlighterSurvey?: boolean | null;
};
export type File = {
  filename?: string | null;
  url?: string | null;
  downloadUrl?: string | null;
};
export type QuestionChoice = {
  id?: string | null;
  externalId?: string | null;
  label?: string | null;
  questionId?: string | null;
  ordinal?: number;
  imageUrl?: string | null;
};
export type QuestionScaleProperties = {
  id?: string | null;
  questionId?: string | null;
  scaleStart?: number;
  scaleEnd?: number;
  startLabel?: string | null;
  middleLabel?: string | null;
  endLabel?: string | null;
  appearance?: string | null;
};
export type Question = {
  id?: string | null;
  resultSchemaId?: string | null;
  questionType?: string | null;
  allowMultipleSelections?: boolean;
  label?: string | null;
  externalId?: string | null;
  choices?: QuestionChoice[] | null;
  scaleProperties?: QuestionScaleProperties;
  ordinal?: number;
  createdAt?: string | null;
  updatedAt?: string | null;
};
export type QuestionResponse = {
  question?: string | null;
  questionType?: string | null;
  answerDisplay?: string | null;
  answerFile?: File;
  flagged?: boolean;
  excluded?: boolean;
  answerId?: string | null;
  isMultiSelect?: boolean;
  questionDetails?: Question;
  qualityRating?: string | null;
  qualityJustification?: string | null;
};
export type ResponseReview = {
  comment?: string | null;
  createdBy?: string | null;
  createdAt?: string;
  answerId?: string | null;
  reviewStatus?: string | null;
  justification?: string | null;
};
export type ResponseDetails = {
  responses?: QuestionResponse[] | null;
  responseTags?: string[] | null;
  responseReviewEntries?: ResponseReview[] | null;
  surveyDuration?: string;
  surveyResponseTime?: string | null;
  recruitingTestGroup?: string | null;
  highlighterId?: string;
};
export type SetAnswerExcludedPayload = {
  answerId?: string;
  excluded?: boolean;
};
export type FullCompletesBreakdown = {
  projectStatus?: string | null;
  isStrictCalculationActive?: boolean;
  allRespondentsCount?: number;
  looseFullCompletesCount?: number;
  strictFullCompletesCount?: number;
};
export type RecommendationGenerationStatus = 'queued' | 'running' | 'completed' | 'failed';
export type RankedLineItemMetricProductResponse = {
  label?: string | null;
  bannerPointId?: string | null;
  value?: number | null;
};
export type RankedLineItemMetricResponse = {
  metricSlug?: string | null;
  metricLabel?: string | null;
  isProportion?: boolean;
  scaleStart?: number | null;
  scaleEnd?: number | null;
  scaleStartLabel?: string | null;
  scaleEndLabel?: string | null;
  products?: RankedLineItemMetricProductResponse[] | null;
};
export type RankedLineItemResponse = {
  lineItemId?: string;
  variantHint?: string | null;
  label?: string | null;
  sortOrder?: number;
  summary?: string | null;
  /** EPD-813. Short "what we learned" takeaway used as the chart-card title; null for
                items generated before the version-7 bump (FE falls back to the bare label). */
  takeaway?: string | null;
  isStatisticallySignificant?: boolean;
  metric?: RankedLineItemMetricResponse;
};
export type ProjectRecommendationResponse = {
  id?: string;
  projectId?: number;
  generationStatus?: RecommendationGenerationStatus;
  synthesisText?: string | null;
  synthesisGeneratedAt?: string | null;
  rankedLineItems?: RankedLineItemResponse[] | null;
};
export type AudienceBuilderRecruitType = 'manual' | 'automatic';
export type AudienceBuilderRecruitStatus =
  | 'paused'
  | 'started'
  | 'completed'
  | 'notStarted'
  | 'outOfHighlighters';
export type InternalRecruitingOptions = {
  excludeProjectIds?: number[] | null;
  includeHighlightEmployees?: boolean;
  sendOptIns?: boolean;
  sendToHighlightEmployeesOnly?: boolean;
  staticAssignment?: boolean;
  tagWeights?: {
    [key: string]: number | null;
  } | null;
  willUseBackendTransform?: boolean;
  restrictRecruitReferralCodeIds?: string[] | null;
};
export type RecruitingSpec = {
  audience?: AudienceBuilderLegacyAudience;
  internalOptions?: InternalRecruitingOptions;
  importedScreenerDisqualificationQuotas?: AudienceBuilderQuota[] | null;
};
export type RecruitingData = {
  projectId?: number;
  recruitType?: AudienceBuilderRecruitType;
  recruitStatus?: AudienceBuilderRecruitStatus;
  spec?: RecruitingSpec;
  audienceSchemaVersion?: number;
  createdAt?: string;
  updatedAt?: string | null;
  externalRecruitReferralCodeId?: string;
  isCustomerEditDisabled?: boolean;
};
export type UpdateRecruitingDataStatusRequest = {
  recruitStatus?: AudienceBuilderRecruitStatus;
};
export type UpdateTestGroupPlacementsRequest = {
  /** Unique identifier to indicate which test group to update. */
  testGroupName?: string | null;
  placements?: number;
};
export type UpdateProjectPlacementsRequest = {
  testGroupPlacements?: UpdateTestGroupPlacementsRequest[] | null;
};
export type BoostRecruitingRequest = {
  desiredOptIns?: number;
};
export type GeneratedReport = {
  id?: string;
  projectId?: number;
  name?: string | null;
  details?: string | null;
  driveFolderId?: string | null;
  createdAt?: string;
  createdBy?: string | null;
  customerGenerated?: boolean;
  status?: string | null;
  statusMessage?: string | null;
  statusTimestamp?: string | null;
};
export type CrossTabParams = {
  significanceLevel?: number | null;
  /** The looser (secondary) significance level, when the user picks a second confidence level.
    Null (the default) preserves single-level behaviour; never defaulted to a value. */
  secondarySignificanceLevel?: number | null;
  segmentIds?: string[] | null;
  surveyGroupIds?: string[] | null;
  resultContextId?: string | null;
  fullCompletesOnly?: boolean;
  /** Read Position filter sourced from the URL query (`?readPosition=N`) on the
    client; null = no filter (all positions). 1-indexed. Exposing this on the
    request lets the frontend put it in the RTK Query cache key so picker
    changes auto-refetch. */
  positionFilter?: number | null;
  allProjectSurveyConfigIds?: string[] | null;
  /** When non-empty, narrows the crosstab to these line items (linked questions);
    empty (the default) returns every line item, preserving today's behaviour. */
  lineItemIds?: string[] | null;
};
export type AlienationParams = {
  resultContextId?: string | null;
  controlSurveyGroupId?: string;
  testSurveyGroupId?: string;
  segmentIds?: string[] | null;
  fullCompletesOnly?: boolean;
  /** Read Position filter sourced from the URL query (`?readPosition=N`); null = no
    filter (all positions). 1-indexed. */
  positionFilter?: number | null;
};
export type ReportParams = {
  crossTabParams?: CrossTabParams;
  alienationParams?: AlienationParams;
  customerGenerated?: boolean;
  templateNameOverride?: string | null;
};
export type SurveyConfigDto = {
  projectId?: number | null;
  surveyId?: number | null;
  solutionSurveyDesignId?: string | null;
  surveyRoleId?: string | null;
  products?: Product[] | null;
  surveyStatus?: string | null;
  projectSurveyUuid?: string | null;
  id?: string | null;
  surveyDesignId?: string | null;
  displayName?: string | null;
  internalName?: string | null;
  resultSchemaId?: string | null;
  externalId?: string | null;
  vendorName?: string | null;
  createdAt?: string | null;
  createdBy?: string | null;
  updatedAt?: string | null;
  updatedBy?: string | null;
  durationDays?: number;
};
export type SurveyConfigDtoRead = {
  projectId?: number | null;
  surveyId?: number | null;
  solutionSurveyDesignId?: string | null;
  surveyRoleId?: string | null;
  products?: Product[] | null;
  surveyStatus?: string | null;
  projectSurveyUuid?: string | null;
  id?: string | null;
  surveyDesignId?: string | null;
  displayName?: string | null;
  internalName?: string | null;
  resultSchemaId?: string | null;
  externalId?: string | null;
  vendorName?: string | null;
  externalUrl?: string | null;
  createdAt?: string | null;
  createdBy?: string | null;
  updatedAt?: string | null;
  updatedBy?: string | null;
  durationDays?: number;
};
export type ResultContext = {
  surveyConfigs?: SurveyConfigDto[] | null;
  type?: string | null;
  display?: string | null;
  resultContextId?: string | null;
  surveyType?: SurveyType;
};
export type ResultContextRead = {
  surveyConfigs?: SurveyConfigDtoRead[] | null;
  type?: string | null;
  display?: string | null;
  resultContextId?: string | null;
  surveyType?: SurveyType;
};
export type ScorecardAggregationOverride = {
  lineItemId?: string;
  aggregationType?: string | null;
};
export type DownloadScorecardParams = {
  crossTabParams?: CrossTabParams;
  scorecardAggregationOverrides?: ScorecardAggregationOverride[] | null;
};
export type BannerGroup = {
  label?: string | null;
  id?: string;
  ordinal?: number;
};
export type BannerPoint = {
  bannerPointId?: string | null;
  label?: string | null;
  combinedLabel?: string | null;
  bannerGroupId?: string | null;
  responseCount?: number;
  bannerDefinitionId?: string;
  surveyGroupId?: string;
  segmentId?: string;
};
export type EntryDataValue = {
  bannerPointId?: string | null;
  proportion?: number;
  count?: number;
  quantitativeNumericValues?: number[] | null;
  significance?: string[] | null;
  secondarySignificance?: string[] | null;
  withinQuestionSignificance?: string[] | null;
};
export type CrossTabEntry = {
  entryDataValues?: EntryDataValue[] | null;
  label?: string | null;
  numericalValue?: number;
  skipInCrossTabTable?: boolean;
};
export type CrossTabAggregation = {
  label?: string | null;
  slug?: string | null;
  value?: number;
  isProportion?: boolean;
  showInCrossTab?: boolean;
  significance?: string[] | null;
  secondarySignificance?: string[] | null;
};
export type CrossTabMetadata = {
  bannerPointId?: string | null;
  responseCount?: number;
  sigma?: number;
  aggregations?: CrossTabAggregation[] | null;
};
export type CrossTab = {
  entries?: CrossTabEntry[] | null;
  lineItemId?: string;
  label?: string | null;
  kind?: string | null;
  metadata?: CrossTabMetadata[] | null;
  isPreferenceQuestion?: boolean;
  ordinal?: number;
};
export type CrossTabsDto = {
  bannerGroups?: BannerGroup[] | null;
  bannerPoints?: BannerPoint[] | null;
  crossTabs?: CrossTab[] | null;
  significanceLevel?: number;
  secondarySignificanceLevel?: number | null;
};
export type ScorecardEntryMetadata = {
  bannerPointId?: string | null;
  aggregations?: CrossTabAggregation[] | null;
};
export type ScorecardEntryData = {
  lineItemId?: string;
  label?: string | null;
  ordinal?: number;
  aggregationType?: string | null;
  aggregationGroup?: string | null;
  metadata?: ScorecardEntryMetadata[] | null;
};
export type LineItemScope = 'within_touchpoint' | 'cross_touchpoint';
export type ScorecardDataDto = {
  bannerGroups?: BannerGroup[] | null;
  bannerPoints?: BannerPoint[] | null;
  significanceLevel?: number | null;
  secondarySignificanceLevel?: number | null;
  entries?: ScorecardEntryData[] | null;
  effectiveLineItemScope?: LineItemScope;
};
export type ScorecardParams = {
  resultContextId?: string | null;
  segmentIds?: string[] | null;
  surveyGroupIds?: string[] | null;
  fullCompletesOnly?: boolean;
  /** Read Position filter sourced from the URL query (`?readPosition=N`); null = no
    filter (all positions). 1-indexed. */
  positionFilter?: number | null;
  significanceLevel?: number | null;
  /** The looser (secondary) significance level, when the user picks a second confidence level.
    Null (the default) preserves single-level behaviour; never defaulted to a value. */
  secondarySignificanceLevel?: number | null;
};
export type ExploreBanner = {
  id?: string;
  surveyGroupLabel?: string | null;
  bannerGroupId?: string;
  bannerDefinitionId?: string;
  segmentLabel?: string | null;
  segmentId?: string | null;
  surveyGroupId?: string;
};
export type ExploreBannerRead = {
  id?: string;
  surveyGroupLabel?: string | null;
  bannerGroupId?: string;
  bannerDefinitionId?: string;
  segmentLabel?: string | null;
  segmentId?: string | null;
  surveyGroupId?: string;
  combinedLabel?: string | null;
};
export type ExploreOptionResultCount = {
  resultsBannerId?: string;
  countOfThisOption?: number;
  proportion?: number;
};
export type ExploreOptionResult = {
  label?: string | null;
  secondaryLabel?: string | null;
  displayOrder?: number;
  counts?: ExploreOptionResultCount[] | null;
};
export type ExploreTextAnswerResult = {
  answerId?: string;
  answerText?: string | null;
  sentiment?: string | null;
  topics?: string[] | null;
  customTopics?: string[] | null;
  keyPhrases?: string[] | null;
  productLabel?: string | null;
};
export type ExploreTextWordCloudSegment = {
  count?: number;
  label?: string | null;
};
export type ExploreTextResult = {
  resultsBannerId?: string;
  textAnswerResults?: ExploreTextAnswerResult[] | null;
  wordCloudSegments?: ExploreTextWordCloudSegment[] | null;
};
export type ExploreRankResultMean = {
  label?: string | null;
  mean?: number;
};
export type ExploreRankResult = {
  resultsBannerId?: string;
  means?: ExploreRankResultMean[] | null;
};
export type ExploreAgeResultCount = {
  resultsBannerId?: string;
  countOfThisSegment?: number;
  proportion?: number;
};
export type ExploreAgeResult = {
  label?: string | null;
  displayOrder?: number;
  counts?: ExploreAgeResultCount[] | null;
};
export type ExploreBannerCount = {
  resultsBannerId?: string;
  sumOfAllAnswers?: number;
};
export type ExploreItemResult = {
  id?: string;
  lineItemId?: string | null;
  sampleQuestion?: Question;
  label?: string | null;
  type?: string | null;
  displayOrder?: number;
  optionResults?: ExploreOptionResult[] | null;
  textResults?: ExploreTextResult[] | null;
  rankResults?: ExploreRankResult[] | null;
  ageResults?: ExploreAgeResult[] | null;
  responseCounts?: ExploreBannerCount[] | null;
};
export type ExploreResponse = {
  banners?: ExploreBanner[] | null;
  results?: ExploreItemResult[] | null;
};
export type ExploreResponseRead = {
  banners?: ExploreBannerRead[] | null;
  results?: ExploreItemResult[] | null;
};
export type ExploreProjectApiRequest = {
  resultContextId?: string | null;
  segmentIds?: string[] | null;
  surveyGroupIds?: string[] | null;
  fullCompletesOnly?: boolean;
  /** Read Position filter. Sourced from the URL query (`?readPosition=N`) on the
    client; null = no filter (all positions). 1-indexed. */
  positionFilter?: number | null;
};
export type GetSummaryResponse = {
  summary?: string | null;
  askAgain?: boolean;
};
export type GetSummaryProjectApiRequest = {
  lineItemId?: string | null;
  segmentIds?: string[] | null;
  surveyGroupIds?: string[] | null;
  resultContextId?: string | null;
  /** Read Position filter. Sourced from the URL query (`?readPosition=N`) on the
    client; null = no filter (all positions). 1-indexed. */
  positionFilter?: number | null;
  /** Confidence level selected at report generation; drives the cross-tab summary's
    significance testing. Null falls back to the 0.05 default. */
  significanceLevel?: number | null;
};
export type GetBatchSummaryResponse = {
  summaries?: {
    [key: string]: GetSummaryResponse;
  } | null;
  allComplete?: boolean;
};
export type GetBatchSummaryProjectApiRequest = {
  lineItemIds?: string[] | null;
  segmentIds?: string[] | null;
  surveyGroupIds?: string[] | null;
  resultContextId?: string | null;
  /** Read Position filter. Sourced from the URL query (`?readPosition=N`) on the
    client; null = no filter (all positions). 1-indexed. */
  positionFilter?: number | null;
  /** Confidence level selected at report generation; drives the cross-tab summary's
    significance testing. Null falls back to the 0.05 default. */
  significanceLevel?: number | null;
};
export type PenaltyStatus = {
  slug?: string | null;
  display?: string | null;
  minInclusive?: number;
  maxExclusive?: number | null;
};
export type Group = {
  status?: string | null;
  label?: string | null;
  proportion?: number;
  meanOverall?: number | null;
  penalty?: number | null;
  weightedPenalty?: number | null;
  sampleSize?: number;
};
export type AttributeResult = {
  label?: string | null;
  low?: Group;
  jar?: Group;
  high?: Group;
};
export type PenaltyAnalysis = {
  label?: string | null;
  results?: AttributeResult[] | null;
  significanceLevel?: number;
};
export type PenaltyAnalysisDto = {
  statuses?: PenaltyStatus[] | null;
  analyses?: PenaltyAnalysis[] | null;
};
export type PenaltyParams = {
  resultContextId?: string | null;
  segmentIds?: string[] | null;
  surveyGroupIds?: string[] | null;
  fullCompletesOnly?: boolean;
  /** Read Position filter sourced from the URL query (`?readPosition=N`); null = no
    filter (all positions). 1-indexed. */
  positionFilter?: number | null;
  significanceLevel?: number | null;
};
export type AlienationGroup = {
  n?: number;
  proportion?: number;
};
export type AlienationAnalysisResponse = {
  n?: number;
  alienated?: AlienationGroup;
  error?: AlienationGroup;
  likedEverything?: AlienationGroup;
  dislikedEverything?: AlienationGroup;
  verdict?: string | null;
  aggregationGroup?: string | null;
};
export type ProjectDescriptionQuestion = {
  lineItemId?: string;
  label?: string | null;
  questionType?: string | null;
  responseCount?: number;
  allowMultipleSelections?: boolean;
  scaleStart?: number | null;
  scaleEnd?: number | null;
  startLabel?: string | null;
  middleLabel?: string | null;
  endLabel?: string | null;
  choiceCount?: number | null;
  /** True when this line item is designated a Just-About-Right attribute for Penalty Analysis. */
  isJarQuestion?: boolean;
  /** True when this line item is designated the Overall Liking measure for Penalty Analysis or Alienation Analysis. */
  isOverallLikingQuestion?: boolean;
  /** Survey-group ids (the agent's "products") this question covers. */
  productIds?: string[] | null;
};
export type ProjectDescriptionProduct = {
  id?: string;
  label?: string | null;
  /** True when this is an individual product, not a product group. Alienation Control/Test and
    the Penalty Analysis default set are core products. */
  isCore?: boolean;
  /** The product's participant-facing (blind) label, when it is an authoritative single value: an
    individual (core) product that resolves to exactly one setup product whose recipient name is
    set and differs from Label. Null — and omitted — for a product group, which has no single
    coherent participant-facing label, and wherever no distinct blind label exists. */
  blindLabel?: string | null;
};
export type ProjectDescriptionResponse = {
  questions?: ProjectDescriptionQuestion[] | null;
  products?: ProjectDescriptionProduct[] | null;
};
export type ResultsMeta = {
  videoDownloadUrl?: string | null;
};
export type SegmentLogicOp = {
  slug?: string | null;
  display?: string | null;
};
export type SegmentRuleAllowedOps = {
  segmentRuleKind?: string | null;
  allowedLogicOps?: SegmentLogicOp[] | null;
};
export type SegmentRule = {
  kind?: string | null;
  questionId?: string | null;
  logicOp?: string | null;
  number?: number | null;
  questionChoices?: string[] | null;
  numberChoices?: number[] | null;
  responseTags?: string[] | null;
  responseTagResultSchemaId?: string | null;
};
export type SegmentRuleGroup = {
  rules?: SegmentRule[] | null;
  name?: string | null;
  combineOp?: string | null;
};
export type Segment = {
  ruleGroups?: SegmentRuleGroup[] | null;
  id?: string | null;
  resultContextId?: string;
  name?: string | null;
  combineOp?: string | null;
  enabled?: boolean;
  createdAt?: string;
  createdBy?: string | null;
  updatedBy?: string | null;
};
export type SegmentCount = {
  segmentId?: string;
  includedHighlighters?: number;
  totalHighlighters?: number;
};
export type SequenceSurvey = {
  name?: string | null;
  linkUrl?: string | null;
};
export type Sequence = {
  name?: string | null;
  surveys?: SequenceSurvey[] | null;
};
export type CreateGuestHighlighterRequest = {
  onboardingCode?: string | null;
  communitySlug?: string | null;
  type?: string | null;
  sequences?: Sequence[] | null;
};
export type ShareLinkDefn = {
  kind?: string | null;
  createGuestHighlighterReq?: CreateGuestHighlighterRequest;
};
export type ShareLink = {
  id?: string;
  publicId?: string | null;
  projectId?: number;
  communitySlug?: string | null;
  isActive?: boolean;
  linkUrl?: string | null;
  defn?: ShareLinkDefn;
};
export type PatchShareLinkRequest = {
  isActive?: boolean;
};
export type DeliveryReceipt = {
  id?: string;
  /** The shipment we're reporting against.
    This holds the tracking number. */
  shipmentId?: number;
  /** The product we're reporting against.
    Note - this product may not have be recorded in the original shipment manifest.
         - this product may not exist in the project ("ie I have something but I dont know what it is") */
  productId?: number | null;
  notes?: string | null;
  /** Number of items that were received */
  quantity?: number;
  /** Are these items damaged or not? */
  productState?: string | null;
  /** Did the product arrive frozen, air-temp, or refrigerated? */
  refrigeration?: string | null;
  createdAt?: string;
  createdBy?: string | null;
};
export type DeliveryConfirmationRequest = {
  receipts?: DeliveryReceipt[] | null;
  status?: string | null;
};
export type ShipmentAsset = {
  id?: string;
  clientShipmentId?: number;
  assetId?: string;
  description?: string | null;
  createdAt?: string | null;
  createdBy?: string | null;
  url?: string | null;
  downloadUrl?: string | null;
};
export type ShowLogicAllowedOpsResponse = {
  lookup?: {
    [key: string]: SurveyExpressionOp[];
  } | null;
};
export type ShowLogic = {
  id?: string;
  surveyConfigQuestionId?: string;
  expressionTree?: SurveyExpression;
};
export type QuestionValidation = {
  surveyConfigBlockId?: string;
  messages?: string[] | null;
};
export type ShowLogicValidationResults = {
  questionValidationFailures?: QuestionValidation[] | null;
};
export type UpdateSolutionRequest = {
  experienceType?: ExperienceType;
  name?: string | null;
  identifierName?: string | null;
  isDeleted?: boolean | null;
  supportedExperiences?: Experience[] | null;
  businessReason?: string | null;
  keyPhrases?: string[] | null;
  useCase?: string | null;
};
export type AssignSolutionSurveyDesign = {
  solutionSurveyDesignId?: string | null;
  isOptional?: boolean;
  isPerItem?: boolean;
  ordinal?: number;
  solutionSurveyDesignName?: string | null;
  surveyRoleId?: string | null;
  vendorName?: string | null;
};
export type CreateGroupRequest = {
  stepIds?: string[] | null;
};
export type SurveyBundle = {
  surveyBundleId?: string | null;
  projectId?: number | null;
  label?: string | null;
  ordinal?: number;
  createdAt?: string | null;
  updatedAt?: string | null;
  createdBy?: string | null;
  updatedBy?: string | null;
  surveyIds?: number[] | null;
};
export type BlockGroupBehaviorValue = {
  id?: string | null;
  blockGroupBehaviorId?: string | null;
  surveyConfigBlockGroupId?: string;
  canCustomerEdit?: boolean;
  blockGroupBehavior?: string | null;
  value?: boolean;
};
export type GroupType = 'Generic' | 'Matrix';
export type SurveyConfigBlockGroup = {
  id?: string | null;
  name?: string | null;
  surveyConfigBlockIds?: string[] | null;
  behaviors?: BlockGroupBehaviorValue[] | null;
  groupType?: GroupType;
};
export type ConfigureSlotValueRequest = {
  slotId?: string;
  value?: string | null;
  assetId?: string | null;
  externalUrl?: string | null;
};
export type MatrixBlockRequest = {
  matrixBlockId?: string;
  ordinal?: number;
  slots?: ConfigureSlotValueRequest[] | null;
};
export type AddMatrixBlockRequest = {
  slots?: ConfigureSlotValueRequest[] | null;
};
export type PreviewResponse = {
  externalId?: string | null;
  vendorName?: string | null;
};
export type UpdateNameRequest = {
  name?: string | null;
};
export type UpdateAreQuestionsRequiredRequest = {
  areQuestionsRequired?: boolean;
};
export type Block = {
  id?: string;
  description?: string | null;
  name?: string | null;
  externalId?: string | null;
  questionDesign?: QuestionDesign;
  internalName?: string | null;
  isArchived?: boolean;
  behaviors?: BlockBehavior[] | null;
  createdAt?: string | null;
  createdBy?: string | null;
  updatedAt?: string | null;
  updatedBy?: string | null;
};
export type BlockBehaviorValue = {
  id?: string | null;
  blockBehaviorId?: string | null;
  surveyConfigBlockId?: string;
  value?: boolean;
  canCustomerEdit?: boolean;
  questionBehavior?: string | null;
  numericValue?: number | null;
  stringValue?: string | null;
};
export type CompositeSlot = {
  slotValueId?: string | null;
  slotId?: string;
  key?: string | null;
  value?: string | null;
  slotType?: string | null;
  assetId?: string | null;
  externalUrl?: string | null;
  label?: string | null;
  placeholder?: string | null;
  slotValueOptions?: string[] | null;
  canApplyAllWithinSurveys?: boolean;
  isRequired?: boolean;
};
export type BlockType = {
  id?: string;
  name?: string | null;
};
export type SurveyConfigQuestion = {
  id?: string;
  name?: string | null;
  showLogicId?: string | null;
  disqualificationLogicId?: string | null;
  questionDesign?: QuestionDesign;
};
export type QuestionDesignChoice = {
  id?: string | null;
  questionDesignId?: string;
  label?: string | null;
  ordinal?: number;
  type?: string | null;
  createdAt?: string | null;
  createdBy?: string | null;
  updatedAt?: string | null;
  updatedBy?: string | null;
};
export type SurveyConfigQuestionChoice = {
  id?: string;
  surveyConfigQuestionId?: string;
  questionDesignChoice?: QuestionDesignChoice;
  assetId?: string | null;
  externalUrl?: string | null;
  altText?: string | null;
};
export type SurveyConfigBlock = {
  id?: string | null;
  surveyConfigId?: string;
  surveyDesignBlockId?: string | null;
  block?: Block;
  behaviors?: BlockBehaviorValue[] | null;
  slots?: CompositeSlot[] | null;
  ordinal?: number;
  isRequired?: boolean;
  areQuestionsRequired?: boolean;
  isDefault?: boolean;
  blockType?: BlockType;
  surveyConfigBlockGroupId?: string | null;
  surveyConfigQuestion?: SurveyConfigQuestion;
  surveyConfigQuestionChoices?: SurveyConfigQuestionChoice[] | null;
  createdAt?: string | null;
  createdBy?: string | null;
  updatedAt?: string | null;
  updatedBy?: string | null;
  moduleId?: string | null;
  internalName?: string | null;
};
export type AssignConfigBlockRequest = {
  blockId?: string;
  surveyDesignBlockId?: string | null;
  surveyConfigBlockId?: string | null;
  areQuestionsRequired?: boolean;
  moduleId?: string | null;
  slots?: CompositeSlot[] | null;
  internalName?: string | null;
  sourceSurveyConfigBlockId?: string | null;
};
export type CustomizeSurveyConfigBlockRequest = {
  customBlockId?: string;
};
export type SurveyConfigQuestionRouting = {
  id?: string;
  sourceSurveyConfigQuestionId?: string;
  sourceSurveyConfigQuestionChoiceId?: string | null;
  targetSurveyConfigQuestionId?: string | null;
  targetSurveyConfigBlockId?: string | null;
  isDisqualification?: boolean;
  createdAt?: string | null;
  createdBy?: string | null;
  updatedAt?: string | null;
  updatedBy?: string | null;
};
export type ConfigureBlockRequest = {
  blockId?: string;
  surveyDesignBlockId?: string | null;
  moduleId?: string | null;
  areQuestionsRequired?: boolean;
  internalName?: string | null;
  slots?: ConfigureSlotValueRequest[] | null;
};
export type ConfigureSurveyByTypeRequest = {
  surveyType?: SurveyType;
  productId?: number | null;
  solutionSurveyDesignId?: string | null;
  surveyRoleId?: string | null;
  /** Include if configured survey config should be attached to existing project survey */
  surveyId?: number | null;
  surveyDesignId?: string | null;
  internalName?: string | null;
  displayName?: string | null;
  vendorName?: string | null;
  blocks?: ConfigureBlockRequest[] | null;
};
export type ConfigureScreenerSurveyV2Request = {
  moduleId?: string;
  internalName?: string | null;
  displayName?: string | null;
};
export type SurveyConfig = {
  id?: string | null;
  surveyDesignId?: string | null;
  displayName?: string | null;
  internalName?: string | null;
  resultSchemaId?: string | null;
  externalId?: string | null;
  vendorName?: string | null;
  createdAt?: string | null;
  createdBy?: string | null;
  updatedAt?: string | null;
  updatedBy?: string | null;
  durationDays?: number;
};
export type SurveyConfigRead = {
  id?: string | null;
  surveyDesignId?: string | null;
  displayName?: string | null;
  internalName?: string | null;
  resultSchemaId?: string | null;
  externalId?: string | null;
  vendorName?: string | null;
  externalUrl?: string | null;
  createdAt?: string | null;
  createdBy?: string | null;
  updatedAt?: string | null;
  updatedBy?: string | null;
  durationDays?: number;
};
export type MaterializeSurveyRequest = {
  customVariables?: string[] | null;
  hiddenVars?: string[] | null;
};
export type SurveyConfigContentCopySlotOverrides = {
  productName?: string | null;
  stimulusAssetId?: string | null;
  stimulusName?: string | null;
};
export type SurveyConfigContentCopyRequest = {
  sourceSurveyConfigId?: string;
  targetSurveyConfigId?: string;
  slotOverrides?: SurveyConfigContentCopySlotOverrides;
};
export type ZipJobWithUrl = {
  id?: string | null;
  name?: string | null;
  status?: string | null;
  downloadUrl?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
};
export type ProjectZipJobs = {
  productZipJob?: ZipJobWithUrl;
  screeningZipJob?: ZipJobWithUrl;
};
export type CreateFileAnswerZipRequest = {
  zipFileName?: string | null;
  type?: string | null;
  fullCompletesOnly?: boolean;
  /** Read Position filter. Sourced from the URL query
    (`?readPosition=N`) on the client; null = no filter (all positions).
    1-indexed. */
  positionFilter?: number | null;
  /** Optional list of survey group IDs scoping the zip job. When null/empty
    (and no position filter is set), no survey groups are threaded onto the
    export and the SurveyApi side falls back to the legacy flat export. */
  surveyGroupIds?: string[] | null;
};
export type SurveyGroupDto = {
  id?: string | null;
  projectId?: number;
  label?: string | null;
  surveyIds?: number[] | null;
  isCore?: boolean;
  productIds?: number[] | null;
  sourceProjectId?: number | null;
  sourceProjectIndex?: number | null;
  color?: string | null;
};
export type SurveyGroup = {
  surveyConfigIds?: string[] | null;
  id?: string;
  label?: string | null;
  ordinal?: number;
  isCore?: boolean;
  productIds?: number[] | null;
  sourceProjectId?: number | null;
  color?: string | null;
};
export type SurveyGroupSeparabilityResponse = {
  isSeparable?: boolean;
};
export type ProductGroupDto = {
  id?: string | null;
  projectId?: number;
  label?: string | null;
  productIds?: number[] | null;
  enabled?: boolean;
  isCore?: boolean;
};
export type SetSurveyGroupColorRequest = {
  /** Hex color `#RRGGBB`, or `null` to reset to the default palette. */
  color?: string | null;
};
export type ProjectIndexLegendItem = {
  index?: number;
  projectId?: number;
  projectName?: string | null;
};
export type SurveyResponseTags = {
  surveyConfigId?: string;
  resultSchemaId?: string;
  responseTags?: string[] | null;
};
export type SurveyQuestionGroup = {
  id?: string;
  name?: string | null;
  questions?: Question[] | null;
  surveyType?: string | null;
};
export type EnrichedSubscription = {
  id?: number;
  teamId?: number;
  hubSpotDealId?: string | null;
  dealName?: string | null;
  amount?: string | null;
  closeDate?: string | null;
  isClosedWon?: boolean;
  salesModel?: string | null;
  totalHighlights?: string | null;
  totalAddons?: string | null;
  termStartDate?: string | null;
  termLengthInMonths?: string | null;
  termEndDate?: string | null;
  subscription?: string | null;
  createdAt?: string;
  lastFetchedAt?: string;
};
export type Subscription = {
  id?: number;
  teamId?: number;
  orgId?: number;
  hubSpotDealId?: string | null;
  createdAt?: string;
};
export type SubscriptionRequest = {
  hubSpotDealId?: string | null;
};
export type SubscriptionBalance = {
  highlightsAllocated?: number;
  highlightsSpent?: number;
  highlightsRemaining?: number;
  addOnsAllocated?: number;
  addOnsSpent?: number;
  addOnsRemaining?: number;
  planName?: string | null;
  termStartDate?: string | null;
  termEndDate?: string | null;
};
export type TestCategory = {
  id?: string;
  name?: string | null;
};
export type TestClassification = {
  id?: string;
  name?: string | null;
  testCategoryTypeId?: string;
};
export type TimelineEntryKind =
  | 'TakeSurvey'
  | 'TakeSurveyAndRename'
  | 'TakeSurveyFromCreate'
  | 'UseSingleProductContainer'
  | 'UseRotatedProductContainer';
export type TimelineEntryBase = {
  kind: TimelineEntryKind;
  day: number;
  ordinal: number;
  durationDays: number;
};
export type TakeSurveyEntry = {
  kind: 'TakeSurvey';
} & TimelineEntryBase & {
    kind?: TimelineEntryKind;
    surveyConfigId: string;
  };
export type TakeSurveyFromCreateEntry = {
  kind: 'TakeSurveyFromCreate';
} & TimelineEntryBase & {
    kind?: TimelineEntryKind;
    createSurveyWithName: string;
  };
export type TakeSurveyAndRenameEntry = {
  kind: 'TakeSurveyAndRename';
} & TimelineEntryBase & {
    kind?: TimelineEntryKind;
    surveyConfigId: string;
    renameSurveyTo: string;
  };
export type TimelineContainerTestGroupProductSpec = {
  testGroupId: string;
  productIds: number[];
};
export type TimelineSubentryKind =
  | 'Wait'
  | 'UseProduct'
  | 'TakeSurveyFromBundle'
  | 'TakeSurveyFromBundleAndRename'
  | 'TakeSurveyFromBundleFromCreate';
export type TimelineSubentryBase = {
  kind: TimelineSubentryKind;
  dayWithin: number;
  ordinalWithin: number;
  durationDaysWithin: number;
};
export type WaitSubentry = {
  kind: 'Wait';
} & TimelineSubentryBase & {
    kind?: TimelineSubentryKind;
  };
export type UseProductSubentry = {
  kind: 'UseProduct';
} & TimelineSubentryBase & {
    kind?: TimelineSubentryKind;
  };
export type TakeSurveyFromBundleSubentry = {
  kind: 'TakeSurveyFromBundle';
} & TimelineSubentryBase & {
    kind?: TimelineSubentryKind;
    surveyBundleId: string;
  };
export type TakeSurveyFromBundleAndRenameSubentry = {
  kind: 'TakeSurveyFromBundleAndRename';
} & TimelineSubentryBase & {
    kind?: TimelineSubentryKind;
    surveyBundleId: string;
    newName: string;
  };
export type TakeSurveyFromBundleFromCreateSubentry = {
  kind: 'TakeSurveyFromBundleFromCreate';
} & TimelineSubentryBase & {
    kind?: TimelineSubentryKind;
    name: string;
  };
export type UseSingleProductContainer = {
  kind: 'UseSingleProductContainer';
} & TimelineEntryBase & {
    kind?: TimelineEntryKind;
    timelineContainerTestGroupProductSpecs: TimelineContainerTestGroupProductSpec[];
    subentries: (
      | WaitSubentry
      | UseProductSubentry
      | TakeSurveyFromBundleSubentry
      | TakeSurveyFromBundleAndRenameSubentry
      | TakeSurveyFromBundleFromCreateSubentry
    )[];
  };
export type UseRotatedProductContainer = {
  kind: 'UseRotatedProductContainer';
} & TimelineEntryBase & {
    kind?: TimelineEntryKind;
    timelineContainerTestGroupProductSpecs: TimelineContainerTestGroupProductSpec[];
    subentries: (
      | WaitSubentry
      | UseProductSubentry
      | TakeSurveyFromBundleSubentry
      | TakeSurveyFromBundleAndRenameSubentry
      | TakeSurveyFromBundleFromCreateSubentry
    )[];
  };
export type TestDesign = {
  id: string;
  /** Optimistic-concurrency token, incremented on every successful upsert. A caller must echo
    the version it last read when saving again; a mismatch fails the request. */
  version: number;
  projectId: number;
  timelineEntries: (
    | TakeSurveyEntry
    | TakeSurveyFromCreateEntry
    | TakeSurveyAndRenameEntry
    | UseSingleProductContainer
    | UseRotatedProductContainer
  )[];
};
export type UpsertTestDesignRequest = {
  /** The version last read by the caller. Ignored when creating a test design for a project
    that doesn't have one yet; otherwise must match the current version or the request fails. */
  version: number;
  timelineEntries: (
    | TakeSurveyEntry
    | TakeSurveyFromCreateEntry
    | TakeSurveyAndRenameEntry
    | UseSingleProductContainer
    | UseRotatedProductContainer
  )[];
};
export type TestGroupV10Product = {
  testGroupId: string;
  productId: number;
  countPerTester: number;
};
export type TestGroupV10 = {
  id: string;
  audienceId: string;
  target: number;
  placements: number;
  products: TestGroupV10Product[];
  /** Optimistic-concurrency token, incremented on every successful update. A caller must echo the
    version it last read on every update/delete; a mismatch fails the request. */
  version: number;
};
export type CreateTestGroupV10ProductRequest = {
  productId: number;
  countPerTester: number;
};
export type CreateTestGroupV10Request = {
  audienceId: string;
  target: number;
  placements: number;
  products: CreateTestGroupV10ProductRequest[];
};
export type UpdateTestGroupV10ProductRequest = {
  productId: number;
  countPerTester: number;
};
export type UpdateTestGroupV10Request = {
  id: string;
  audienceId?: string | null;
  target?: number | null;
  placements?: number | null;
  /** `[]` replaces existing products. */
  products?: UpdateTestGroupV10ProductRequest[] | null;
  /** The version last read by the caller. Must match the current version or the update fails. */
  version: number;
};
export type DeleteTestGroupV10Request = {
  id: string;
  /** The version last read by the caller. Must match the current version or the delete fails. */
  version: number;
};
export type BulkTestGroupV10Request = {
  creates: CreateTestGroupV10Request[];
  updates: UpdateTestGroupV10Request[];
  deletes: DeleteTestGroupV10Request[];
};
export const {
  useGetAdminsQuery,
  usePostAdminsMutation,
  usePostByIdDisableMutation,
  useGetProjectsByProjectIdAdminsQuery,
  useGetAggregationtypesQuery,
  useGetProjectsByProjectIdAttachmentsQuery,
  usePostProjectsByProjectIdAttachmentsMutation,
  usePutProjectsByProjectIdAttachmentsAndAttachmentIdMutation,
  useDeleteProjectsByProjectIdAttachmentsAndProjectAttachmentIdMutation,
  useGetProjectsByProjectIdAudienceBuilderAudienceQuery,
  usePutProjectsByProjectIdAudienceBuilderAudienceMutation,
  usePostProjectsByProjectIdAudienceAttachmentsMutation,
  useGetProjectsByProjectIdAudienceAttachmentsAndAttachmentIdQuery,
  useGetProjectsByProjectIdAudiencesQuery,
  usePostProjectsByProjectIdAudiencesMutation,
  usePatchProjectsByProjectIdAudiencesAndAudienceIdMutation,
  useDeleteProjectsByProjectIdAudiencesAndAudienceIdMutation,
  usePostProjectsByProjectIdAudiencesBulkMutation,
  useGetBlueprintCatalogExportQuery,
  useGetBlueprintCatalogApplyJobsQuery,
  usePostBlueprintCatalogApplyMutation,
  usePostBlueprintsModuleconfigurationsMutation,
  usePostBlueprintsMutation,
  useGetBlueprintsQuery,
  usePostProjectsByProjectIdChatConversationsAndConversationIdMessagesMutation,
  useGetProjectsByProjectIdChatConversationsAndConversationIdQuery,
  usePatchProjectsByProjectIdChatConversationsAndConversationIdMutation,
  useDeleteProjectsByProjectIdChatConversationsAndConversationIdMutation,
  useGetProjectsByProjectIdChatConversationsQuery,
  useGetCommunitiesQuery,
  useGetCommunitiesBySlugQuery,
  useGetCommunitiesBySlugStudyEventsQuery,
  useGetCommunitiesStudyEventsSchemaQuery,
  usePostCommunitiesBySlugRecruitCountMutation,
  usePostCustomerRegistrationSelfServeMutation,
  useGetCustomersQuery,
  usePostCustomersMutation,
  usePutCustomersMutation,
  usePostCustomersBulkMutation,
  useGetCustomersByCustomerIdQuery,
  useGetTeamsByTeamIdCustomersQuery,
  usePostTeamsByTeamIdCustomersAndCustomerIdMutation,
  useDeleteTeamsByTeamIdCustomersAndCustomerIdMutation,
  usePostCustomersByCustomerIdDisableMutation,
  usePostCustomersByCustomerIdEnableMutation,
  usePostCustomersByCustomerIdTrackloginMutation,
  useGetProjectsByProjectIdResultsCustomTopicsQuery,
  usePostProjectsByProjectIdResultsCustomTopicsMutation,
  useDeleteProjectsByProjectIdResultsCustomTopicsAndIdMutation,
  useGetDisqualificationlogicsAllowedopsQuery,
  useGetSurveyconfigsBySurveyConfigIdDisqualificationlogicsQuery,
  usePutSurveyconfigsBySurveyConfigIdDisqualificationlogicsAndIdMutation,
  useDeleteSurveyconfigsBySurveyConfigIdDisqualificationlogicsAndIdMutation,
  useGetSurveyconfigsBySurveyConfigIdDisqualificationlogicsValidationQuery,
  useGetExperiencesQuery,
  useGetProjectsByProjectIdFeasibilityEstimateQuery,
  usePutProjectsByProjectIdFeasibilityEstimateMutation,
  usePutProjectsByProjectIdFieldingGroupAssignHighlightersMutation,
  usePatchProjectsByProjectIdFieldingGroupAndFieldingGroupIdMutation,
  useDeleteProjectsByProjectIdFieldingGroupAndFieldingGroupIdMutation,
  useDeleteProjectsByProjectIdFieldingGroupMutation,
  useGetProjectsByProjectIdFieldingGroupQuery,
  useGetFieldingGroupQuery,
  usePostProjectsByProjectIdFieldingGroupFromKitsMutation,
  usePostProjectsByProjectIdFieldingGroupFromTestGroupsMutation,
  usePostProjectsByProjectIdFieldingGroupDeleteAllEntitiesMutation,
  usePostFieldingGroupsByFieldingGroupIdFieldingGroupAssignmentsMutation,
  useDeleteFieldingGroupsByFieldingGroupIdFieldingGroupAssignmentsMutation,
  useGetProjectsByProjectIdHighlighterExperiencesQuery,
  usePostProjectsByProjectIdHighlighterExperiencesMutation,
  useGetProjectsByProjectIdHighlighterExperiencesOverviewQuery,
  useGetProjectsByProjectIdHighlighterExperiencesAndExperienceIdAssignmentsQuery,
  usePostProjectsByProjectIdHighlighterExperiencesAndExperienceIdInitializeMutation,
  usePostProjectsByProjectIdHighlighterExperiencesAndExperienceIdActivateMutation,
  useGetHubSpotDealsByDealIdQuery,
  usePostInsertsMutation,
  usePutInsertsByInsertIdMutation,
  useDeleteInsertsByInsertIdMutation,
  usePostInsertsByInsertIdFileMutation,
  useDeleteInsertsByInsertIdFileMutation,
  useGetProjectsByProjectIdKitsQuery,
  usePostProjectsByProjectIdKitsMutation,
  usePutProjectsByProjectIdKitsAndKitIdMutation,
  useDeleteProjectsByProjectIdKitsAndKitIdMutation,
  useGetProjectsByProjectIdKitsAndKitIdAssetsQuery,
  usePostProjectsByProjectIdKitsAndKitIdAssetsMutation,
  useDeleteProjectsByProjectIdKitsAndKitIdAssetsKitAssetIdMutation,
  usePostProjectsByProjectIdKitsAndKitIdRequestReviewMutation,
  usePostProjectsByProjectIdKitsAndKitIdReviewMutation,
  usePostProjectsByProjectIdLinksMutation,
  useGetProjectsByProjectIdLinksQuery,
  usePutProjectsByProjectIdLinksAndProjectLinkIdMutation,
  useDeleteProjectsByProjectIdLinksAndProjectLinkIdMutation,
  useGetProjectsByProjectIdSurveysManualQuery,
  usePostProjectsByProjectIdSurveysManualMutation,
  usePatchProjectsByProjectIdSurveysManualAndSurveyIdMutation,
  usePostModulesByModuleIdBlocksAssignMutation,
  useGetModuleConfigurationsQuery,
  usePostModuleConfigurationsMutation,
  usePostModuleConfigurationsAssignMutation,
  useGetModulesByModuleIdQuery,
  useGetModulesQuery,
  usePostModulesMutation,
  usePutModulesMutation,
  useGetBlocksByBlockIdModulesQuery,
  useGetProjectsByProjectIdNotificationUnsubscriptionsQuery,
  usePostProjectsByProjectIdNotificationUnsubscriptionsMutation,
  useDeleteProjectsByProjectIdNotificationUnsubscriptionsMutation,
  usePostOrganizationsMutation,
  useGetOrganizationsQuery,
  usePutOrganizationsMutation,
  useGetOrganizationsByOrgIdEntitlementDefnQuery,
  useGetOrganizationsByOrgIdCommunitiesQuery,
  useGetProjectsByProjectIdPackingListBoxConfigurationsQuery,
  useGetProjectsByProjectIdPackingListSimplifiedBoxListQuery,
  usePostOrganizationsByOrgIdPersonaPanelsAndPersonaPanelIdChatConversationsConversationIdMessagesMutation,
  useGetOrganizationsByOrgIdPersonaPanelsAndPersonaPanelIdChatConversationsConversationIdQuery,
  usePatchOrganizationsByOrgIdPersonaPanelsAndPersonaPanelIdChatConversationsConversationIdMutation,
  useDeleteOrganizationsByOrgIdPersonaPanelsAndPersonaPanelIdChatConversationsConversationIdMutation,
  useGetOrganizationsByOrgIdPersonaPanelsAndPersonaPanelIdChatConversationsQuery,
  useGetProjectsByProjectIdPresentationrulesQuery,
  usePutProjectsByProjectIdPresentationrulesAndSlugMutation,
  useDeleteProjectsByProjectIdPresentationrulesAndSlugMutation,
  useGetProjectsByProjectIdProductListsQuery,
  usePostProjectsByProjectIdProductListsMutation,
  usePutProjectsByProjectIdProductListsAndIdMutation,
  useDeleteProjectsByProjectIdProductListsAndIdMutation,
  useGetProjectsByProjectIdProductProjectAssetsQuery,
  usePostProjectsByProjectIdProductsAndProductIdProductProjectAssetsMutation,
  useDeleteProductProjectAssetsByProductProjectAssetIdMutation,
  useGetProductsByProductIdQuery,
  usePutProductsByProductIdMutation,
  usePostProjectsByProjectIdProductsMutation,
  useGetProjectsByProjectIdProductsQuery,
  usePutProjectsByProjectIdProductsMutation,
  useDeleteProjectsByProjectIdProductsMutation,
  usePostProjectsByProjectIdProductsBulkMutation,
  usePostProjectsByProjectIdProductsSurveyRenamePlanMutation,
  useGetProjectCategoriesQuery,
  useGetProjectFinalReportsByProjectIdQuery,
  usePutProjectFinalReportsByProjectIdMutation,
  usePostProjectFinalReportsUploadFileMutation,
  useGetProjectsByProjectIdProjectIntakeAnswersQuery,
  usePostAdminProcessAllProjectsMutation,
  usePostProjectsByProjectIdAiReviewMutation,
  useGetProjectsByProjectIdAiReviewQuery,
  usePostProjectsByProjectIdAiSummaryMutation,
  useGetProjectsByProjectIdAiSummaryQuery,
  usePostProjectsMutation,
  usePostProjectsConfigureMutation,
  usePostProjectsConfigureV2Mutation,
  usePutProjectsMutation,
  useGetProjectsQuery,
  usePatchProjectsByProjectIdMutation,
  useGetProjectsByProjectIdQuery,
  useDeleteProjectsByProjectIdMutation,
  useGetProjectsByProjectIdNotificationEntitlementsQuery,
  useGetProjectsByProjectIdStatusQuery,
  useGetProjectsByProjectIdProductSurveyConfigIdsQuery,
  useGetProjectsByProjectIdProductSurveyConfigMapQuery,
  useGetProjectsByProjectIdInsertsQuery,
  useGetProjectsAdminProjectsQuery,
  usePostProjectsByProjectIdAssignAdminsMutation,
  useGetProjectsAutomaticRecruitingQuery,
  usePatchProjectsByProjectIdStatusMutation,
  usePatchProjectsByProjectIdTeamMutation,
  usePatchProjectsByProjectIdProductBlindingMethodMutation,
  usePatchProjectsByProjectIdNameMutation,
  usePostProjectsByProjectIdUploadBoxTrackingMutation,
  usePostProjectsByProjectIdSyncKitsMutation,
  usePostProjectsCreateFromExistingMutation,
  usePostProjectsByProjectIdDisableAutomationsMutation,
  usePostProjectsByProjectIdLaunchProjectMutation,
  usePutProjectsByProjectIdTimelineMutation,
  usePostProjectsByProjectIdQuestionsAutoLinkMutation,
  usePostProjectsByProjectIdScorecardPopulateMutation,
  useGetProjectsGetActiveParticipantGuidanceProjectIdsQuery,
  usePostProjectsByProjectIdUpdateDashboardMutation,
  useGetProjectsByProjectIdConfigurationsQuery,
  useGetProjectsByProjectIdExperiencesQuery,
  usePostProjectsHackyconfigureMutation,
  useDeleteProjectsByProjectIdSurveysAndSurveyIdMutation,
  useDeleteProjectsByProjectIdSurveysAndSurveyIdFileMutation,
  useGetProjectsByProjectIdSurveysAndSurveyIdFileQuery,
  usePostProjectsByProjectIdSurveysAndSurveyIdFileMutation,
  useGetProjectsByProjectIdSurveysQuery,
  usePatchProjectsByProjectIdSurveysAndSurveyIdSurveyStatusMutation,
  usePatchProjectsByProjectIdSurveysAndSurveyIdResultsStatusMutation,
  useGetProjectsByProjectIdQualityControlReportQuery,
  useGetQualityControlReportQuery,
  usePostQualityControlReportSubmitreviewMutation,
  useGetProjectsByProjectIdQualityControlReportAndResponseIdQuery,
  usePostProjectsByProjectIdQualityControlReportSetAnswerExcludedMutation,
  useGetProjectsByProjectIdQualityControlReportFullCompletesBreakdownQuery,
  useGetProjectsByProjectIdRecommendationQuery,
  usePostProjectsByProjectIdRecommendationMutation,
  usePostProjectsByProjectIdRecruitCountMutation,
  useGetProjectsByProjectIdRecruitingDataQuery,
  usePostProjectsByProjectIdRecruitingDataMutation,
  usePutProjectsByProjectIdRecruitingDataMutation,
  usePatchProjectsByProjectIdRecruitingDataMutation,
  usePatchProjectsByProjectIdRecruitingDataPlacementsMutation,
  usePostProjectsByProjectIdRecruitingDataBoostMutation,
  usePostProjectsByProjectIdRecruitingDataImportMutation,
  usePostProjectsByProjectIdReportMutation,
  useGetProjectsByProjectIdReportQuery,
  useGetProjectsByProjectIdReportCustomerreportsQuery,
  usePostProjectsByProjectIdReportAndGeneratedReportIdDownloadReportDownloadTypeMutation,
  useDeleteProjectsByProjectIdReportAndGeneratedReportIdMutation,
  useGetProjectsByProjectIdResultContextsQuery,
  usePostProjectsByProjectIdSurveyconfigsAndSurveyConfigIdResultContextsMutation,
  useGetProjectsByProjectIdResultsDownloadcsvQuery,
  useGetProjectsByProjectIdResultsDownloadcodedcsvQuery,
  useGetProjectsByProjectIdResultsDownloadcsvallrespondentsQuery,
  useGetProjectsByProjectIdResultsDownloadcodedcsvallrespondentsQuery,
  usePostProjectsByProjectIdResultsDownloadcrosstabsMutation,
  usePostProjectsByProjectIdResultsDownloadscorecardcsvMutation,
  usePostProjectsByProjectIdResultsGetcrosstabdataMutation,
  useGetProjectsByProjectIdResultsGetcrosstabdataQuery,
  usePostProjectsByProjectIdResultsGetscorecarddataMutation,
  useGetProjectsByProjectIdResultsGetscorecarddataQuery,
  usePostProjectsByProjectIdResultsExploreresultsMutation,
  useGetProjectsByProjectIdResultsExploreresultsQuery,
  usePostProjectsByProjectIdResultsGetsummaryMutation,
  usePostProjectsByProjectIdResultsGetbatchsummaryMutation,
  useGetProjectsByProjectIdResultsPenaltyanalysisQuery,
  usePostProjectsByProjectIdResultsGetpenaltyanalysisMutation,
  usePostProjectsByProjectIdResultsDownloadpenaltyanalysisMutation,
  usePostProjectsByProjectIdResultsAlienationanalysisMutation,
  useGetProjectsByProjectIdResultsAlienationanalysisQuery,
  useGetProjectsByProjectIdResultsDescribeQuery,
  useGetProjectsByProjectIdResultsmetaQuery,
  usePutProjectsByProjectIdResultsmetaMutation,
  useGetProjectsByProjectIdSegmentsAllowedopsQuery,
  useGetProjectsByProjectIdSegmentsQuery,
  useGetProjectsByProjectIdSegmentsEnabledQuery,
  useGetProjectsByProjectIdSegmentsAndSegmentIdCountsQuery,
  usePutProjectsByProjectIdSegmentsUpsertMutation,
  usePostProjectsByProjectIdSegmentsBackfillDefaultSegmentsMutation,
  useDeleteProjectsByProjectIdSegmentsAndIdMutation,
  usePostProjectsByProjectIdShareLinksMutation,
  useGetProjectsByProjectIdShareLinksQuery,
  useDeleteProjectsByProjectIdShareLinksMutation,
  useGetShareLinksByPublicIdQuery,
  usePatchShareLinksByIdMutation,
  usePostShipmentsMutation,
  usePutShipmentsMutation,
  usePostShipmentsByShipmentIdDeliveryConfirmationMutation,
  usePostShipmentsByShipmentIdAssetsMutation,
  useGetShipmentsByShipmentIdAssetsQuery,
  useDeleteShipmentsByShipmentIdAssetsAndShipmentAssetIdMutation,
  useGetShowlogicsAllowedopsQuery,
  useGetSurveyconfigsBySurveyConfigIdShowlogicsQuery,
  useGetSurveyconfigsBySurveyConfigIdShowlogicsAndIdQuery,
  usePutSurveyconfigsBySurveyConfigIdShowlogicsAndIdMutation,
  useDeleteSurveyconfigsBySurveyConfigIdShowlogicsAndIdMutation,
  useGetSurveyconfigsBySurveyConfigIdShowlogicsValidationQuery,
  usePostProjectsByProjectIdSurveyConfigBlocksAndSurveyConfigBlockIdSlotValuesV2Mutation,
  usePostProjectsByProjectIdSurveyConfigBlocksAndSurveyConfigBlockIdSlotValuesBulkAssignMutation,
  usePostProjectsByProjectIdSurveyConfigsAndSurveyConfigIdSlotValuesMutation,
  useDeleteProjectsByProjectIdSurveyConfigBlocksAndSurveyConfigBlockIdSlotValuesSlotValueIdMutation,
  usePostSolutionsMutation,
  useGetSolutionsQuery,
  useGetProjectsByProjectIdSolutionsQuery,
  usePatchSolutionsBySolutionIdMutation,
  useGetSolutionsBySolutionIdOrgAndOrgIdCountQuery,
  useGetSolutionsBySolutionIdCountQuery,
  useGetSolutionsUseCasesQuery,
  useGetSolutionsBySolutionIdSurveyDesignsQuery,
  usePostSolutionsBySolutionIdSurveyDesignsAssignMutation,
  usePostFieldingGroupsByFieldingGroupIdStepsMutation,
  useGetFieldingGroupsByFieldingGroupIdStepsQuery,
  usePatchFieldingGroupsByFieldingGroupIdStepsAndStepIdMutation,
  useDeleteFieldingGroupsByFieldingGroupIdStepsAndStepIdMutation,
  usePatchFieldingGroupsByFieldingGroupIdStepsUpdateOrdinalsMutation,
  usePostFieldingGroupsByFieldingGroupIdStepsGroupMutation,
  useGetProjectsByProjectIdSurveyBundlesQuery,
  usePostProjectsByProjectIdSurveyBundlesMutation,
  usePutProjectsByProjectIdSurveyBundlesAndSurveyBundleIdMutation,
  useGetSurveyConfigBlockGroupsQuery,
  usePostSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsCreateAndReorderMutation,
  usePostSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsCreateMatrixGroupMutation,
  usePostSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdAddMatrixBlockMutation,
  usePostSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdPreviewMutation,
  useDeleteSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdMutation,
  usePatchSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdNameMutation,
  usePatchSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdAreQuestionsRequiredMutation,
  usePatchSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdBehaviorsMutation,
  usePatchSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdBlockIdsMutation,
  usePostSurveyConfigsBySurveyConfigIdSurveyConfigBlockGroupsAndSurveyConfigBlockGroupIdCloneMutation,
  useGetProjectsByProjectIdSurveyConfigsAndSurveyConfigIdBlocksQuery,
  usePutProjectsByProjectIdSurveyConfigsAndSurveyConfigIdBlocksMutation,
  usePutProjectsByProjectIdSurveyConfigsAndSurveyConfigIdBlocksSurveyConfigBlockIdMutation,
  usePostProjectsByProjectIdSurveyConfigsAndSurveyConfigIdBlocksAssignMutation,
  usePostProjectsByProjectIdSurveyConfigsAndSurveyConfigIdBlocksSurveyConfigBlockIdCustomizeMutation,
  usePostProjectsByProjectIdSurveyConfigsAndSurveyConfigIdBlocksSurveyConfigBlockIdPreviewMutation,
  usePostSurveyConfigsBySurveyConfigIdBlocksAndSurveyConfigBlockIdCloneMutation,
  usePatchProjectsByProjectIdSurveyConfigsAndSurveyConfigIdBlocksOrdinalsMutation,
  usePostProjectsByProjectIdSurveyConfigsAndSurveyConfigIdQuestionsSurveyConfigQuestionIdChoicesSurveyConfigQuestionChoiceIdMutation,
  useGetProjectsByProjectIdSurveyConfigsAndSurveyConfigIdQuestionsSurveyConfigQuestionIdRoutingsQuery,
  useGetProjectsByProjectIdSurveyConfigsAndSurveyConfigIdRoutingsQuery,
  useGetProjectsByProjectIdSurveyConfigsQuery,
  useGetSurveyConfigsQuery,
  usePostProjectsByProjectIdSurveyConfigsConfigureMutation,
  usePostProjectsByProjectIdSurveyConfigsConfigurescreenerv2Mutation,
  usePostProjectsByProjectIdSurveyConfigsAndSurveyConfigIdMaterializeMutation,
  usePostProjectsByProjectIdSurveyConfigsAndSurveyConfigIdPreviewMutation,
  usePostProjectsByProjectIdSurveyConfigsCopySurveyContentMutation,
  usePutProjectsByProjectIdSurveyConfigsAndSurveyConfigIdMutation,
  useGetProjectsByProjectIdFileAnswersQuery,
  usePostProjectsByProjectIdFileAnswersMutation,
  useGetProjectsByProjectIdSurveyGroupsQuery,
  usePutProjectsByProjectIdSurveyGroupsMutation,
  useGetProjectsByProjectIdSurveyGroupsEnabledQuery,
  useGetProjectsByProjectIdSurveyGroupsSeparableQuery,
  useGetProjectsByProjectIdSurveyGroupsProductGroupsQuery,
  usePutProjectsByProjectIdSurveyGroupsProductGroupsMutation,
  useDeleteProjectsByProjectIdSurveyGroupsProductGroupsAndProductGroupIdMutation,
  usePatchProjectsByProjectIdSurveyGroupsAndSurveyGroupIdColorMutation,
  useGetProjectsByProjectIdSurveyGroupsProjectIndexLegendQuery,
  useGetProjectsByProjectIdSurveyQuestionsProfilequestionsQuery,
  useGetProjectsByProjectIdSurveyQuestionsResponsetagsQuery,
  useGetProjectsByProjectIdSurveyQuestionsQuestiongroupsQuery,
  usePostTeamsMutation,
  useGetTeamsQuery,
  useGetTeamsByTeamIdQuery,
  usePutTeamsByTeamIdMutation,
  useDeleteTeamsByTeamIdMutation,
  useGetTeamsByTeamIdSubscriptionsQuery,
  usePostTeamsByTeamIdSubscriptionsMutation,
  usePutTeamsByTeamIdSubscriptionsAndSubscriptionIdMutation,
  useDeleteTeamsByTeamIdSubscriptionsAndSubscriptionIdMutation,
  useGetTeamsByTeamIdSubscriptionBalanceQuery,
  useGetTestCategoriesQuery,
  useGetTestClassificationsQuery,
  useGetProjectsByProjectIdTestDesignQuery,
  usePutProjectsByProjectIdTestDesignMutation,
  useGetProjectsByProjectIdTestGroupsQuery,
  usePostProjectsByProjectIdTestGroupsMutation,
  usePatchProjectsByProjectIdTestGroupsAndTestGroupIdMutation,
  useDeleteProjectsByProjectIdTestGroupsAndTestGroupIdMutation,
  usePostProjectsByProjectIdTestGroupsBulkMutation,
} = injectedRtkApi;
